/// <reference path="./custom.d.ts" />
// tslint:disable
/**
 * Amadeus Digital Experience API
 * # API information The document aims at describing the Amadeus Digital Experience API.  Through Digital API, an end user is able to search air offers and related services, add all necessary information to complete a booking, display a seatmap and select seats, add traveler preferences such as meal and finally finalize a booking (creation of an order). API also allows retrieving an existing order. Since the API is REST, operations are not flow related.  ## CRUD operations We do our best to have all our URLs be [RESTful](http://en.wikipedia.org/wiki/Representational_state_transfer). Every endpoint (URL) may support one of five different http verbs. GET requests fetch information about an object, POST requests create objects. PATCH [JSON Merge Patch](https://tools.ietf.org/html/rfc7396) requests perform partial updates.  ## Structure ### The envelope Every response is contained by an envelope. That is, each response has a predictable set of keys with which you can expect to interact: ```json {     \"warnings\": [         ...     ],     \"data\": {         ...     },     \"dictionaries\": {         ...     },     \"errors\": [         ...     ] } ``` #### ERRORS Error messages corresponding to functional blocking issues encountered when processing an operation. When at least one message has a level 'error' nothing has been processed so no 'data' are returned. In this case the HTTP status become 200 for POST (instead of 201) and DELETE (instead of 204).  #### WARNINGS Warning messages corresponding to non blocking issues encountered when processing an operation.  #### DATA The data key is the meat of the response. It contains all information regarding the resource requested.  #### DICTIONARIES Each dictionary contains: - localized data : it's possible to request for a specific code (e.g. location code) the translation in the language code specified as query parameter. The translation applies as well to the related information: in case of location code, type of location (airport or city), corresponding city (for airport location), state, country, etc.) - dictionarized data : information used on different parts of the message can be defined once and referenced via an id. It that case, the id makes the connection between dictionary and data information Dictionary structure is available on page [Maps in dictionary documentation](https://dxapi.digitalforairlines.com/swagger-ui/display/documentation.html#/Maps/get_).  ### Example of request/response When triggering an API operation it is interesting to evaluate the response (or the data model corresponding to the input body in case of POST). ``` GET /carts/{cartId}/travelers/{travelerId} HTTP/1.1 Accept: application/json ```  Multiple errors can occur in response to a single request. The list of error messages is provided by the server: ```json HTTP/1.1 400 Bad Request Content-Type: application/json {   \"errors\": [     {       \"code\": \"04926\",       \"source\": { \"pointer\": \"/names/0/lastName\" },       \"title\": \"INVALID DATA RECEIVED\"       \"detail\": \"must match \\\"^[A-Za-zÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬-ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¿][A-Za-zÃƒÆ’Ã†â€™ÃƒÂ¢Ã¢â‚¬Å¡Ã‚Â¬-ÃƒÆ’Ã†â€™Ãƒâ€šÃ‚Â¿ -.]{1,69}$\\\"     },     {       \"code\": \"36986\",       \"source\": { \"pointer\": \"/0/dateOfBirth\" },       \"detail\": \"Date of birth '2018-07-01' should be in the past\",       \"title\": \"INVALID DATA RECEIVED\"     },   ] } ``` Note: example added for illustration only.  A few considerations on the error message structure: - The title communicates the type of problem encountered. - The code refers to an application-specific code representing the type of problem encountered. Code and title have a similar behaviour, since they communicate which is the problem type. However, it is suggested to rely on the code as a unique identifier. - The detail is used to provide information specific to this occurrence of the problem.  Message may use source to point to the top-level of the document (\"\"). The source member can also be used to indicate that the error originated from a problem with a URI query parameter (parameter field used instead of pointer in that case).  Standard [HTTP response status codes](https://en.wikipedia.org/wiki/List_of_HTTP_status_codes) apply. As such they are not all mentioned below.  ## Top resources ### Cart The central resource is the `Cart` (shopping cart) used at shopping time to prepare a journey (shopping, booking and pricing). A `Cart` contains one `AirOffer` and related `Traveler`s, `Service`s, `Seat`s, `FrequentFlyerCard`s,  `Contact`s. At checkout time, an `Order` is created based on content selected from the `Cart`.  ### AirCalendar `Air Calendar` provides the best price per day based on input parameters.  ### AirBound `Air Bound` provides the bound-by-bound shopping proposal based on input parameters. ### AirOffer An `Air Offer` is the result of a shopping proposal. It is a collection of `OfferItem`s, each offer item containing flights.  ### Service The ``Service`` resource allows to access the list of free and/or chargeable services.  ### Seatmap ``Seatmap`` refers to display of the air seat map, allowing the end user to identify the seat to be booked for free or at a charge.  ### Order An ``Order`` corresponds to a reservation record (Amadeus PNRs). The order can contain flights, services and seats, as well as travel documents (E-Tickets and/or EMDs) in case the order has been paid and related tickets issued.  ### Payment Method A `Payment Method` refers to a payment method that be used to pay an order. The following payment methods are supported by DAPI: Payment cards, External  payment, Miles payment and Alternative Payment Method.  ## Secondary resources (main ones) ### Traveler A ``Traveler`` is an individual involved in the booking and taking part in a journey. ### Seat A ``Seat`` refers to the seat that the end user can select as part of the booking. ### Frequent Flyer ``Frequent Flyer`` contains frequent flyer cards either to accrue miles or redeem miles (only accrual supported initially). ### Contact ``Contact`` refers to emails, phone numbers and addresses. ### Travel Document A ``Travel Document`` refers to the tickets (E-Tickets and/or EMDs) issued for flights or services. ### Payment Record A `Payment Record` contains the details of the payment transaction for an order. It includes the payment method used for the order payment, as well additional information such as the approval code for a Credit Card payment. ## Limitations - Only air related content booking is supported. - Only one order is created at a time from the cart. - A cart can only contain one single airOffer.  ## Miscellaneous ### Temporary id (tid) A temporary id (``tid``) can be used to: - identify an object in the request of a POST operation when the id of the object is not known yet.  - identify an object in the response of a PUT operation when the id of the object is changing.  In all cases, a tid is only valid for the time of the transaction   ### Output filtering JSON output can be filtered using ``-fields`` and ``fields`` query parameters, followed by the fully qualified name of the attribute to filter/keep.  Optionally the ``keepRequiredFields`` boolean query parameter can be used to avoid filtering required fields out.  Examples: ``` GET /carts/{cartId}?-fields=data.travelers ``` will filter all travelers out of the response ``` GET /carts/{cartId}?fields=data.travelers.age ``` will keep only age of the travelers in response  Any questions, suggestions or feedbacks, thank you for contacting the DxAPI team  ### Traceability token For better traceability of requests, a traceability token should be added to  every API call as a HTTP header tag: ``Ama-Client-Ref``. This allows a correlation of logs between the client application and the API, enabling: - for the airline or third party developer to provide the session id of their  own application in case of questions/issues (in addition to the usual mandatory fields) - for the Amadeus API developer to extract faster all logs associated to that session and  get a better and faster understanding of the API implementation of the client application  The `Ama-Client-Ref`` should have less than 64 characters. Additional characters are ignored.       The recommended format for this token is composed of both a session part and  a request part resulting in a unique ID for a single request. This recommended format is as following: ``${SESSION_ID}:${REQUEST_ID}``. Where: - ``SESSION_ID``: is a client-side generated token identifying the client-side user session. For example:        - ``123e4567-e89b-12d3-a456-426655440000`` if the application uses    [UUID](https://en.wikipedia.org/wiki/Universally_unique_identifier)    in [RFC 4122](https://tools.ietf.org/html/rfc4122)      - ``kGAMfG5by8NaHqZxkQ3oDCpQ6oszEwaIusvbE-6S9x59qZxD_pKH`` if the    application is a J2EE application using a ``JSESSIONID`` as a cookie   - ``REQUEST_ID`` is a client-side request id within the client-side user session matching the ``[a-zA-Z0-9]{1,10}`` format.    - For example: ``1``, ``42``, ``5fa2``, ``Px2z5``, ...    - There is no notion of order between two ``REQUEST_ID``    - ``REQUEST_ID`` must be unique within a session.   Examples:  - Request ``2fc0`` within session ``123e4567-e89b-12d3-a456-426655440000`` traceability token:  ``Ama-Client-Ref: 123e4567-e89b-12d3-a456-426655440000:2fc0``     - Request ``7ba19e`` within session ``123e4567-e89b-12d3-a456-426655440000`` traceability token:  ``Ama-Client-Ref: 123e4567-e89b-12d3-a456-426655440000:7ba19e``  - Request ``7ba19e`` within JSESSIONID session ``kGAMfG5by8NaHqZxkQ3oDCpQ6oszEwaIusvbE-6S9x59qZxD_pKH`` traceability token:  ``Ama-Client-Ref: kGAMfG5by8NaHqZxkQ3oDCpQ6oszEwaIusvbE-6S9x59qZxD_pKH:7ba19e``
 *
 * OpenAPI spec version: 2.51.0
 * Contact: DG-CORP-DAPI-Swagger@amadeus.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/**
 * @export
 * @namespace Address
 */
export var Address;
(function (Address) {
    /**
     * @export
     * @enum {string}
     */
    var PurposeEnum;
    (function (PurposeEnum) {
        PurposeEnum[PurposeEnum["Billing"] = 'billing'] = "Billing";
        PurposeEnum[PurposeEnum["Mailing"] = 'mailing'] = "Mailing";
    })(PurposeEnum = Address.PurposeEnum || (Address.PurposeEnum = {}));
})(Address || (Address = {}));
/**
 * @export
 * @namespace AirBestPricesItinerary
 */
export var AirBestPricesItinerary;
(function (AirBestPricesItinerary) {
    /**
     * @export
     * @enum {string}
     */
    var DaysOfWeekEnum;
    (function (DaysOfWeekEnum) {
        DaysOfWeekEnum[DaysOfWeekEnum["Monday"] = 'monday'] = "Monday";
        DaysOfWeekEnum[DaysOfWeekEnum["Tuesday"] = 'tuesday'] = "Tuesday";
        DaysOfWeekEnum[DaysOfWeekEnum["Wednesday"] = 'wednesday'] = "Wednesday";
        DaysOfWeekEnum[DaysOfWeekEnum["Thursday"] = 'thursday'] = "Thursday";
        DaysOfWeekEnum[DaysOfWeekEnum["Friday"] = 'friday'] = "Friday";
        DaysOfWeekEnum[DaysOfWeekEnum["Saturday"] = 'saturday'] = "Saturday";
        DaysOfWeekEnum[DaysOfWeekEnum["Sunday"] = 'sunday'] = "Sunday";
    })(DaysOfWeekEnum = AirBestPricesItinerary.DaysOfWeekEnum || (AirBestPricesItinerary.DaysOfWeekEnum = {}));
})(AirBestPricesItinerary || (AirBestPricesItinerary = {}));
/**
 * @export
 * @namespace AirBestPricesSearchPreferences
 */
export var AirBestPricesSearchPreferences;
(function (AirBestPricesSearchPreferences) {
    /**
     * @export
     * @enum {string}
     */
    var ModeEnum;
    (function (ModeEnum) {
        ModeEnum[ModeEnum["BestByDay"] = 'bestByDay'] = "BestByDay";
        ModeEnum[ModeEnum["BestByMonth"] = 'bestByMonth'] = "BestByMonth";
        ModeEnum[ModeEnum["BestOverall"] = 'bestOverall'] = "BestOverall";
        ModeEnum[ModeEnum["BestByTrip"] = 'bestByTrip'] = "BestByTrip";
    })(ModeEnum = AirBestPricesSearchPreferences.ModeEnum || (AirBestPricesSearchPreferences.ModeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var ThemeSearchModeEnum;
    (function (ThemeSearchModeEnum) {
        ThemeSearchModeEnum[ThemeSearchModeEnum["MatchAll"] = 'matchAll'] = "MatchAll";
        ThemeSearchModeEnum[ThemeSearchModeEnum["MatchAtLeastOne"] = 'matchAtLeastOne'] = "MatchAtLeastOne";
    })(ThemeSearchModeEnum = AirBestPricesSearchPreferences.ThemeSearchModeEnum || (AirBestPricesSearchPreferences.ThemeSearchModeEnum = {}));
})(AirBestPricesSearchPreferences || (AirBestPricesSearchPreferences = {}));
/**
 * @export
 * @namespace AirExchangeCalendarItinerary
 */
export var AirExchangeCalendarItinerary;
(function (AirExchangeCalendarItinerary) {
    /**
     * @export
     * @enum {string}
     */
    var ActionEnum;
    (function (ActionEnum) {
        ActionEnum[ActionEnum["Change"] = 'change'] = "Change";
        ActionEnum[ActionEnum["Keep"] = 'keep'] = "Keep";
        ActionEnum[ActionEnum["Add"] = 'add'] = "Add";
        ActionEnum[ActionEnum["Remove"] = 'remove'] = "Remove";
    })(ActionEnum = AirExchangeCalendarItinerary.ActionEnum || (AirExchangeCalendarItinerary.ActionEnum = {}));
})(AirExchangeCalendarItinerary || (AirExchangeCalendarItinerary = {}));
/**
 * @export
 * @namespace AirExchangeItinerary
 */
export var AirExchangeItinerary;
(function (AirExchangeItinerary) {
    /**
     * @export
     * @enum {string}
     */
    var ActionEnum;
    (function (ActionEnum) {
        ActionEnum[ActionEnum["Change"] = 'change'] = "Change";
        ActionEnum[ActionEnum["Keep"] = 'keep'] = "Keep";
        ActionEnum[ActionEnum["Add"] = 'add'] = "Add";
        ActionEnum[ActionEnum["Remove"] = 'remove'] = "Remove";
    })(ActionEnum = AirExchangeItinerary.ActionEnum || (AirExchangeItinerary.ActionEnum = {}));
})(AirExchangeItinerary || (AirExchangeItinerary = {}));
/**
 * @export
 * @namespace AirOfferCondition
 */
export var AirOfferCondition;
(function (AirOfferCondition) {
    /**
     * @export
     * @enum {string}
     */
    var CategoryEnum;
    (function (CategoryEnum) {
        CategoryEnum[CategoryEnum["AdvancePurchase"] = 'advancePurchase'] = "AdvancePurchase";
        CategoryEnum[CategoryEnum["MinimumStay"] = 'minimumStay'] = "MinimumStay";
        CategoryEnum[CategoryEnum["MaximumStay"] = 'maximumStay'] = "MaximumStay";
        CategoryEnum[CategoryEnum["Change"] = 'change'] = "Change";
        CategoryEnum[CategoryEnum["Refund"] = 'refund'] = "Refund";
    })(CategoryEnum = AirOfferCondition.CategoryEnum || (AirOfferCondition.CategoryEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var SituationEnum;
    (function (SituationEnum) {
        SituationEnum[SituationEnum["AfterDeparture"] = 'afterDeparture'] = "AfterDeparture";
        SituationEnum[SituationEnum["BeforeDeparture"] = 'beforeDeparture'] = "BeforeDeparture";
        SituationEnum[SituationEnum["AfterDepartureNoShow"] = 'afterDepartureNoShow'] = "AfterDepartureNoShow";
        SituationEnum[SituationEnum["BeforeDepartureNoShow"] = 'beforeDepartureNoShow'] = "BeforeDepartureNoShow";
    })(SituationEnum = AirOfferCondition.SituationEnum || (AirOfferCondition.SituationEnum = {}));
})(AirOfferCondition || (AirOfferCondition = {}));
/**
 * @export
 * @namespace AirOfferItemCommon
 */
export var AirOfferItemCommon;
(function (AirOfferItemCommon) {
    /**
     * @export
     * @enum {string}
     */
    var LastRefreshStatusEnum;
    (function (LastRefreshStatusEnum) {
        LastRefreshStatusEnum[LastRefreshStatusEnum["Valid"] = 'valid'] = "Valid";
        LastRefreshStatusEnum[LastRefreshStatusEnum["Invalid"] = 'invalid'] = "Invalid";
        LastRefreshStatusEnum[LastRefreshStatusEnum["Unavailable"] = 'unavailable'] = "Unavailable";
    })(LastRefreshStatusEnum = AirOfferItemCommon.LastRefreshStatusEnum || (AirOfferItemCommon.LastRefreshStatusEnum = {}));
})(AirOfferItemCommon || (AirOfferItemCommon = {}));
/**
 * @export
 * @namespace AirOffersUpgradeOfferSearchRequest
 */
export var AirOffersUpgradeOfferSearchRequest;
(function (AirOffersUpgradeOfferSearchRequest) {
    /**
     * @export
     * @enum {string}
     */
    var UpsellLevelEnum;
    (function (UpsellLevelEnum) {
        UpsellLevelEnum[UpsellLevelEnum["BOUND"] = 'BOUND'] = "BOUND";
        UpsellLevelEnum[UpsellLevelEnum["ITINERARY"] = 'ITINERARY'] = "ITINERARY";
    })(UpsellLevelEnum = AirOffersUpgradeOfferSearchRequest.UpsellLevelEnum || (AirOffersUpgradeOfferSearchRequest.UpsellLevelEnum = {}));
})(AirOffersUpgradeOfferSearchRequest || (AirOffersUpgradeOfferSearchRequest = {}));
/**
 * @export
 * @namespace AlternativeOfferConfirmationJob
 */
export var AlternativeOfferConfirmationJob;
(function (AlternativeOfferConfirmationJob) {
    /**
     * @export
     * @enum {string}
     */
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["InProgress"] = 'inProgress'] = "InProgress";
        StatusEnum[StatusEnum["Completed"] = 'completed'] = "Completed";
    })(StatusEnum = AlternativeOfferConfirmationJob.StatusEnum || (AlternativeOfferConfirmationJob.StatusEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var RebookingStatusEnum;
    (function (RebookingStatusEnum) {
        RebookingStatusEnum[RebookingStatusEnum["InProgress"] = 'inProgress'] = "InProgress";
        RebookingStatusEnum[RebookingStatusEnum["Completed"] = 'completed'] = "Completed";
    })(RebookingStatusEnum = AlternativeOfferConfirmationJob.RebookingStatusEnum || (AlternativeOfferConfirmationJob.RebookingStatusEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var ReissuanceStatusEnum;
    (function (ReissuanceStatusEnum) {
        ReissuanceStatusEnum[ReissuanceStatusEnum["InProgress"] = 'inProgress'] = "InProgress";
        ReissuanceStatusEnum[ReissuanceStatusEnum["Completed"] = 'completed'] = "Completed";
    })(ReissuanceStatusEnum = AlternativeOfferConfirmationJob.ReissuanceStatusEnum || (AlternativeOfferConfirmationJob.ReissuanceStatusEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var ReacceptanceStatusEnum;
    (function (ReacceptanceStatusEnum) {
        ReacceptanceStatusEnum[ReacceptanceStatusEnum["InProgress"] = 'inProgress'] = "InProgress";
        ReacceptanceStatusEnum[ReacceptanceStatusEnum["Completed"] = 'completed'] = "Completed";
    })(ReacceptanceStatusEnum = AlternativeOfferConfirmationJob.ReacceptanceStatusEnum || (AlternativeOfferConfirmationJob.ReacceptanceStatusEnum = {}));
})(AlternativeOfferConfirmationJob || (AlternativeOfferConfirmationJob = {}));
/**
 * @export
 * @namespace AlternativePaymentMethod
 */
export var AlternativePaymentMethod;
(function (AlternativePaymentMethod) {
    /**
     * @export
     * @enum {string}
     */
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["Approved"] = 'approved'] = "Approved";
        StatusEnum[StatusEnum["Pending"] = 'pending'] = "Pending";
        StatusEnum[StatusEnum["Denied"] = 'denied'] = "Denied";
        StatusEnum[StatusEnum["Error"] = 'error'] = "Error";
    })(StatusEnum = AlternativePaymentMethod.StatusEnum || (AlternativePaymentMethod.StatusEnum = {}));
})(AlternativePaymentMethod || (AlternativePaymentMethod = {}));
/**
 * @export
 * @namespace AlternativePaymentMethodParameter
 */
export var AlternativePaymentMethodParameter;
(function (AlternativePaymentMethodParameter) {
    /**
     * @export
     * @enum {string}
     */
    var TypeEnum;
    (function (TypeEnum) {
        TypeEnum[TypeEnum["String"] = 'string'] = "String";
        TypeEnum[TypeEnum["Numeric"] = 'numeric'] = "Numeric";
        TypeEnum[TypeEnum["Alpha"] = 'alpha'] = "Alpha";
        TypeEnum[TypeEnum["Alphanumeric"] = 'alphanumeric'] = "Alphanumeric";
    })(TypeEnum = AlternativePaymentMethodParameter.TypeEnum || (AlternativePaymentMethodParameter.TypeEnum = {}));
})(AlternativePaymentMethodParameter || (AlternativePaymentMethodParameter = {}));
/**
 * @export
 * @namespace AmenitySeat
 */
export var AmenitySeat;
(function (AmenitySeat) {
    /**
     * @export
     * @enum {string}
     */
    var SpaceUnitEnum;
    (function (SpaceUnitEnum) {
        SpaceUnitEnum[SpaceUnitEnum["CENTIMETERS"] = 'CENTIMETERS'] = "CENTIMETERS";
        SpaceUnitEnum[SpaceUnitEnum["INCHES"] = 'INCHES'] = "INCHES";
    })(SpaceUnitEnum = AmenitySeat.SpaceUnitEnum || (AmenitySeat.SpaceUnitEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var TiltEnum;
    (function (TiltEnum) {
        TiltEnum[TiltEnum["NORMAL"] = 'NORMAL'] = "NORMAL";
        TiltEnum[TiltEnum["FULLFLAT"] = 'FULL_FLAT'] = "FULLFLAT";
        TiltEnum[TiltEnum["ANGLEFLAT"] = 'ANGLE_FLAT'] = "ANGLEFLAT";
        TiltEnum[TiltEnum["NONE"] = 'NONE'] = "NONE";
    })(TiltEnum = AmenitySeat.TiltEnum || (AmenitySeat.TiltEnum = {}));
})(AmenitySeat || (AmenitySeat = {}));
/**
 * @export
 * @namespace ApisDetailFromReference
 */
export var ApisDetailFromReference;
(function (ApisDetailFromReference) {
    /**
     * @export
     * @enum {string}
     */
    var AddressTypeEnum;
    (function (AddressTypeEnum) {
        AddressTypeEnum[AddressTypeEnum["HomeAddress"] = 'homeAddress'] = "HomeAddress";
        AddressTypeEnum[AddressTypeEnum["DestinationAddress"] = 'destinationAddress'] = "DestinationAddress";
    })(AddressTypeEnum = ApisDetailFromReference.AddressTypeEnum || (ApisDetailFromReference.AddressTypeEnum = {}));
})(ApisDetailFromReference || (ApisDetailFromReference = {}));
/**
 * @export
 * @namespace ArrivalDepartureDistance
 */
export var ArrivalDepartureDistance;
(function (ArrivalDepartureDistance) {
    /**
     * @export
     * @enum {string}
     */
    var UnitEnum;
    (function (UnitEnum) {
        UnitEnum[UnitEnum["Miles"] = 'miles'] = "Miles";
    })(UnitEnum = ArrivalDepartureDistance.UnitEnum || (ArrivalDepartureDistance.UnitEnum = {}));
})(ArrivalDepartureDistance || (ArrivalDepartureDistance = {}));
/**
 * @export
 * @namespace AvailabilityInfoItem
 */
export var AvailabilityInfoItem;
(function (AvailabilityInfoItem) {
    /**
     * @export
     * @enum {string}
     */
    var CabinEnum;
    (function (CabinEnum) {
        CabinEnum[CabinEnum["Eco"] = 'eco'] = "Eco";
        CabinEnum[CabinEnum["EcoPremium"] = 'ecoPremium'] = "EcoPremium";
        CabinEnum[CabinEnum["Business"] = 'business'] = "Business";
        CabinEnum[CabinEnum["First"] = 'first'] = "First";
    })(CabinEnum = AvailabilityInfoItem.CabinEnum || (AvailabilityInfoItem.CabinEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var StatusCodeEnum;
    (function (StatusCodeEnum) {
        StatusCodeEnum[StatusCodeEnum["HK"] = 'HK'] = "HK";
        StatusCodeEnum[StatusCodeEnum["HL"] = 'HL'] = "HL";
        StatusCodeEnum[StatusCodeEnum["TK"] = 'TK'] = "TK";
        StatusCodeEnum[StatusCodeEnum["UN"] = 'UN'] = "UN";
        StatusCodeEnum[StatusCodeEnum["UC"] = 'UC'] = "UC";
        StatusCodeEnum[StatusCodeEnum["HX"] = 'HX'] = "HX";
        StatusCodeEnum[StatusCodeEnum["NO"] = 'NO'] = "NO";
    })(StatusCodeEnum = AvailabilityInfoItem.StatusCodeEnum || (AvailabilityInfoItem.StatusCodeEnum = {}));
})(AvailabilityInfoItem || (AvailabilityInfoItem = {}));
/**
 * @export
 * @namespace BagTagDeliveryEligibility
 */
export var BagTagDeliveryEligibility;
(function (BagTagDeliveryEligibility) {
    /**
     * @export
     * @enum {string}
     */
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["Eligible"] = 'eligible'] = "Eligible";
        StatusEnum[StatusEnum["Ineligible"] = 'ineligible'] = "Ineligible";
    })(StatusEnum = BagTagDeliveryEligibility.StatusEnum || (BagTagDeliveryEligibility.StatusEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var ReasonsEnum;
    (function (ReasonsEnum) {
        ReasonsEnum[ReasonsEnum["MaxSegmentReached"] = 'maxSegmentReached'] = "MaxSegmentReached";
        ReasonsEnum[ReasonsEnum["CustomerNotAccepted"] = 'customerNotAccepted'] = "CustomerNotAccepted";
        ReasonsEnum[ReasonsEnum["CustomerEligibility"] = 'customerEligibility'] = "CustomerEligibility";
        ReasonsEnum[ReasonsEnum["FlightEligibility"] = 'flightEligibility'] = "FlightEligibility";
        ReasonsEnum[ReasonsEnum["FlightStatusInvalid"] = 'flightStatusInvalid'] = "FlightStatusInvalid";
        ReasonsEnum[ReasonsEnum["UnpaidItems"] = 'unpaidItems'] = "UnpaidItems";
        ReasonsEnum[ReasonsEnum["BaggroupExcess"] = 'baggroupExcess'] = "BaggroupExcess";
        ReasonsEnum[ReasonsEnum["BagActive"] = 'bagActive'] = "BagActive";
        ReasonsEnum[ReasonsEnum["BagNotFullyAccepted"] = 'bagNotFullyAccepted'] = "BagNotFullyAccepted";
        ReasonsEnum[ReasonsEnum["ShortTagged"] = 'shortTagged'] = "ShortTagged";
        ReasonsEnum[ReasonsEnum["MultipleBaggageRecord"] = 'multipleBaggageRecord'] = "MultipleBaggageRecord";
        ReasonsEnum[ReasonsEnum["Other"] = 'other'] = "Other";
    })(ReasonsEnum = BagTagDeliveryEligibility.ReasonsEnum || (BagTagDeliveryEligibility.ReasonsEnum = {}));
})(BagTagDeliveryEligibility || (BagTagDeliveryEligibility = {}));
/**
 * @export
 * @namespace BagTagsDeliveriesMethod
 */
export var BagTagsDeliveriesMethod;
(function (BagTagsDeliveriesMethod) {
    /**
     * @export
     * @enum {string}
     */
    var DeliveryTypeEnum;
    (function (DeliveryTypeEnum) {
        DeliveryTypeEnum[DeliveryTypeEnum["BagTagsEmailDelivery"] = 'BagTagsEmailDelivery'] = "BagTagsEmailDelivery";
        DeliveryTypeEnum[DeliveryTypeEnum["BagTagsPDFDocument"] = 'BagTagsPDFDocument'] = "BagTagsPDFDocument";
    })(DeliveryTypeEnum = BagTagsDeliveriesMethod.DeliveryTypeEnum || (BagTagsDeliveriesMethod.DeliveryTypeEnum = {}));
})(BagTagsDeliveriesMethod || (BagTagsDeliveriesMethod = {}));
/**
 * @export
 * @namespace BagTagsDeliveriesResult
 */
export var BagTagsDeliveriesResult;
(function (BagTagsDeliveriesResult) {
    /**
     * @export
     * @enum {string}
     */
    var EmailDeliveryStatusEnum;
    (function (EmailDeliveryStatusEnum) {
        EmailDeliveryStatusEnum[EmailDeliveryStatusEnum["Sent"] = 'sent'] = "Sent";
    })(EmailDeliveryStatusEnum = BagTagsDeliveriesResult.EmailDeliveryStatusEnum || (BagTagsDeliveriesResult.EmailDeliveryStatusEnum = {}));
})(BagTagsDeliveriesResult || (BagTagsDeliveriesResult = {}));
/**
 * @export
 * @namespace Baggage
 */
export var Baggage;
(function (Baggage) {
    /**
     * @export
     * @enum {string}
     */
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["Inactive"] = 'inactive'] = "Inactive";
        StatusEnum[StatusEnum["Active"] = 'active'] = "Active";
        StatusEnum[StatusEnum["Validated"] = 'validated'] = "Validated";
        StatusEnum[StatusEnum["StatusNotSupportedInThisVersion"] = 'statusNotSupportedInThisVersion'] = "StatusNotSupportedInThisVersion";
    })(StatusEnum = Baggage.StatusEnum || (Baggage.StatusEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var AcceptanceStatusEnum;
    (function (AcceptanceStatusEnum) {
        AcceptanceStatusEnum[AcceptanceStatusEnum["NotAccepted"] = 'notAccepted'] = "NotAccepted";
        AcceptanceStatusEnum[AcceptanceStatusEnum["FullyAccepted"] = 'fullyAccepted'] = "FullyAccepted";
        AcceptanceStatusEnum[AcceptanceStatusEnum["StandBy"] = 'standBy'] = "StandBy";
        AcceptanceStatusEnum[AcceptanceStatusEnum["StatusNotSupportedInThisVersion"] = 'statusNotSupportedInThisVersion'] = "StatusNotSupportedInThisVersion";
    })(AcceptanceStatusEnum = Baggage.AcceptanceStatusEnum || (Baggage.AcceptanceStatusEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var BagTagPrintStatusEnum;
    (function (BagTagPrintStatusEnum) {
        BagTagPrintStatusEnum[BagTagPrintStatusEnum["PrintingRequired"] = 'printingRequired'] = "PrintingRequired";
        BagTagPrintStatusEnum[BagTagPrintStatusEnum["Printed"] = 'printed'] = "Printed";
    })(BagTagPrintStatusEnum = Baggage.BagTagPrintStatusEnum || (Baggage.BagTagPrintStatusEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var WeightUnitEnum;
    (function (WeightUnitEnum) {
        WeightUnitEnum[WeightUnitEnum["Kilogram"] = 'kilogram'] = "Kilogram";
        WeightUnitEnum[WeightUnitEnum["Pound"] = 'pound'] = "Pound";
    })(WeightUnitEnum = Baggage.WeightUnitEnum || (Baggage.WeightUnitEnum = {}));
})(Baggage || (Baggage = {}));
/**
 * @export
 * @namespace BaggageAllowanceDetail
 */
export var BaggageAllowanceDetail;
(function (BaggageAllowanceDetail) {
    /**
     * @export
     * @enum {string}
     */
    var TypeEnum;
    (function (TypeEnum) {
        TypeEnum[TypeEnum["Weight"] = 'weight'] = "Weight";
        TypeEnum[TypeEnum["Piece"] = 'piece'] = "Piece";
    })(TypeEnum = BaggageAllowanceDetail.TypeEnum || (BaggageAllowanceDetail.TypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var WeightUnitEnum;
    (function (WeightUnitEnum) {
        WeightUnitEnum[WeightUnitEnum["Kilogram"] = 'kilogram'] = "Kilogram";
        WeightUnitEnum[WeightUnitEnum["Pound"] = 'pound'] = "Pound";
    })(WeightUnitEnum = BaggageAllowanceDetail.WeightUnitEnum || (BaggageAllowanceDetail.WeightUnitEnum = {}));
})(BaggageAllowanceDetail || (BaggageAllowanceDetail = {}));
/**
 * @export
 * @namespace BaggagePolicyRestrictions
 */
export var BaggagePolicyRestrictions;
(function (BaggagePolicyRestrictions) {
    /**
     * @export
     * @enum {string}
     */
    var TypeEnum;
    (function (TypeEnum) {
        TypeEnum[TypeEnum["Weight"] = 'weight'] = "Weight";
        TypeEnum[TypeEnum["Size"] = 'size'] = "Size";
    })(TypeEnum = BaggagePolicyRestrictions.TypeEnum || (BaggagePolicyRestrictions.TypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var QualifierEnum;
    (function (QualifierEnum) {
        QualifierEnum[QualifierEnum["UpTo"] = 'upTo'] = "UpTo";
        QualifierEnum[QualifierEnum["Over"] = 'over'] = "Over";
        QualifierEnum[QualifierEnum["MaxLength"] = 'maxLength'] = "MaxLength";
    })(QualifierEnum = BaggagePolicyRestrictions.QualifierEnum || (BaggagePolicyRestrictions.QualifierEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var UnitEnum;
    (function (UnitEnum) {
        UnitEnum[UnitEnum["Centimeter"] = 'centimeter'] = "Centimeter";
        UnitEnum[UnitEnum["Inch"] = 'inch'] = "Inch";
        UnitEnum[UnitEnum["Kilogram"] = 'kilogram'] = "Kilogram";
        UnitEnum[UnitEnum["Pound"] = 'pound'] = "Pound";
    })(UnitEnum = BaggagePolicyRestrictions.UnitEnum || (BaggagePolicyRestrictions.UnitEnum = {}));
})(BaggagePolicyRestrictions || (BaggagePolicyRestrictions = {}));
/**
 * @export
 * @namespace Barcode
 */
export var Barcode;
(function (Barcode) {
    /**
     * @export
     * @enum {string}
     */
    var TypeEnum;
    (function (TypeEnum) {
        TypeEnum[TypeEnum["Aztec"] = 'aztec'] = "Aztec";
        TypeEnum[TypeEnum["Datamatrix"] = 'datamatrix'] = "Datamatrix";
        TypeEnum[TypeEnum["Pdf417"] = 'pdf417'] = "Pdf417";
        TypeEnum[TypeEnum["Qrcode"] = 'qrcode'] = "Qrcode";
    })(TypeEnum = Barcode.TypeEnum || (Barcode.TypeEnum = {}));
})(Barcode || (Barcode = {}));
/**
 * @export
 * @namespace BeverageAmenity
 */
export var BeverageAmenity;
(function (BeverageAmenity) {
    /**
     * @export
     * @enum {string}
     */
    var BeverageTypeEnum;
    (function (BeverageTypeEnum) {
        BeverageTypeEnum[BeverageTypeEnum["ALCOHOLIC"] = 'ALCOHOLIC'] = "ALCOHOLIC";
        BeverageTypeEnum[BeverageTypeEnum["NONALCOHOLIC"] = 'NON_ALCOHOLIC'] = "NONALCOHOLIC";
        BeverageTypeEnum[BeverageTypeEnum["PREMIUMALCOHOLIC"] = 'PREMIUM_ALCOHOLIC'] = "PREMIUMALCOHOLIC";
    })(BeverageTypeEnum = BeverageAmenity.BeverageTypeEnum || (BeverageAmenity.BeverageTypeEnum = {}));
})(BeverageAmenity || (BeverageAmenity = {}));
/**
 * @export
 * @namespace BoardingPass
 */
export var BoardingPass;
(function (BoardingPass) {
    /**
     * @export
     * @enum {string}
     */
    var DeliveryTypeEnum;
    (function (DeliveryTypeEnum) {
        DeliveryTypeEnum[DeliveryTypeEnum["Email"] = 'email'] = "Email";
        DeliveryTypeEnum[DeliveryTypeEnum["Mobile"] = 'mobile'] = "Mobile";
        DeliveryTypeEnum[DeliveryTypeEnum["Pdf"] = 'pdf'] = "Pdf";
        DeliveryTypeEnum[DeliveryTypeEnum["Sms"] = 'sms'] = "Sms";
    })(DeliveryTypeEnum = BoardingPass.DeliveryTypeEnum || (BoardingPass.DeliveryTypeEnum = {}));
})(BoardingPass || (BoardingPass = {}));
/**
 * @export
 * @namespace BoardingPassAttachment
 */
export var BoardingPassAttachment;
(function (BoardingPassAttachment) {
    /**
     * @export
     * @enum {string}
     */
    var DocumentTypeEnum;
    (function (DocumentTypeEnum) {
        DocumentTypeEnum[DocumentTypeEnum["Pdf"] = 'pdf'] = "Pdf";
        DocumentTypeEnum[DocumentTypeEnum["AppleWallet"] = 'appleWallet'] = "AppleWallet";
    })(DocumentTypeEnum = BoardingPassAttachment.DocumentTypeEnum || (BoardingPassAttachment.DocumentTypeEnum = {}));
})(BoardingPassAttachment || (BoardingPassAttachment = {}));
/**
 * @export
 * @namespace BoardingPassDeliveryMethod
 */
export var BoardingPassDeliveryMethod;
(function (BoardingPassDeliveryMethod) {
    /**
     * @export
     * @enum {string}
     */
    var DeliveryMethodTypeEnum;
    (function (DeliveryMethodTypeEnum) {
        DeliveryMethodTypeEnum[DeliveryMethodTypeEnum["BoardingPassSmsDelivery"] = 'BoardingPassSmsDelivery'] = "BoardingPassSmsDelivery";
        DeliveryMethodTypeEnum[DeliveryMethodTypeEnum["BoardingPassEmailDelivery"] = 'BoardingPassEmailDelivery'] = "BoardingPassEmailDelivery";
        DeliveryMethodTypeEnum[DeliveryMethodTypeEnum["BoardingPassInResponseDelivery"] = 'BoardingPassInResponseDelivery'] = "BoardingPassInResponseDelivery";
    })(DeliveryMethodTypeEnum = BoardingPassDeliveryMethod.DeliveryMethodTypeEnum || (BoardingPassDeliveryMethod.DeliveryMethodTypeEnum = {}));
})(BoardingPassDeliveryMethod || (BoardingPassDeliveryMethod = {}));
/**
 * @export
 * @namespace BoardingPassEligibility
 */
export var BoardingPassEligibility;
(function (BoardingPassEligibility) {
    /**
     * @export
     * @enum {string}
     */
    var ReasonsEnum;
    (function (ReasonsEnum) {
        ReasonsEnum[ReasonsEnum["FlightEligibilityRule"] = 'flightEligibilityRule'] = "FlightEligibilityRule";
        ReasonsEnum[ReasonsEnum["CustomerEligibilityRule"] = 'customerEligibilityRule'] = "CustomerEligibilityRule";
        ReasonsEnum[ReasonsEnum["PassengerNotAccepted"] = 'passengerNotAccepted'] = "PassengerNotAccepted";
        ReasonsEnum[ReasonsEnum["Other"] = 'other'] = "Other";
    })(ReasonsEnum = BoardingPassEligibility.ReasonsEnum || (BoardingPassEligibility.ReasonsEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var AllowedBoardingPassTypesEnum;
    (function (AllowedBoardingPassTypesEnum) {
        AllowedBoardingPassTypesEnum[AllowedBoardingPassTypesEnum["AirportPrinted"] = 'airportPrinted'] = "AirportPrinted";
        AllowedBoardingPassTypesEnum[AllowedBoardingPassTypesEnum["HomePrinted"] = 'homePrinted'] = "HomePrinted";
        AllowedBoardingPassTypesEnum[AllowedBoardingPassTypesEnum["BarcodeOnDevice"] = 'barcodeOnDevice'] = "BarcodeOnDevice";
        AllowedBoardingPassTypesEnum[AllowedBoardingPassTypesEnum["TextMessageOnDevice"] = 'textMessageOnDevice'] = "TextMessageOnDevice";
    })(AllowedBoardingPassTypesEnum = BoardingPassEligibility.AllowedBoardingPassTypesEnum || (BoardingPassEligibility.AllowedBoardingPassTypesEnum = {}));
})(BoardingPassEligibility || (BoardingPassEligibility = {}));
/**
 * @export
 * @namespace BoardingPassInResponseDelivery
 */
export var BoardingPassInResponseDelivery;
(function (BoardingPassInResponseDelivery) {
    /**
     * @export
     * @enum {string}
     */
    var DocumentTypeEnum;
    (function (DocumentTypeEnum) {
        DocumentTypeEnum[DocumentTypeEnum["Pdf"] = 'pdf'] = "Pdf";
        DocumentTypeEnum[DocumentTypeEnum["MobileBoardingPass"] = 'mobileBoardingPass'] = "MobileBoardingPass";
        DocumentTypeEnum[DocumentTypeEnum["AppleWallet"] = 'appleWallet'] = "AppleWallet";
        DocumentTypeEnum[DocumentTypeEnum["BoardingPassData"] = 'boardingPassData'] = "BoardingPassData";
        DocumentTypeEnum[DocumentTypeEnum["GooglePay"] = 'googlePay'] = "GooglePay";
        DocumentTypeEnum[DocumentTypeEnum["Wallet"] = 'wallet'] = "Wallet";
    })(DocumentTypeEnum = BoardingPassInResponseDelivery.DocumentTypeEnum || (BoardingPassInResponseDelivery.DocumentTypeEnum = {}));
})(BoardingPassInResponseDelivery || (BoardingPassInResponseDelivery = {}));
/**
 * @export
 * @namespace BoardingPassLounge
 */
export var BoardingPassLounge;
(function (BoardingPassLounge) {
    /**
     * @export
     * @enum {string}
     */
    var AirportEnum;
    (function (AirportEnum) {
        AirportEnum[AirportEnum["Departure"] = 'departure'] = "Departure";
        AirportEnum[AirportEnum["Arrival"] = 'arrival'] = "Arrival";
    })(AirportEnum = BoardingPassLounge.AirportEnum || (BoardingPassLounge.AirportEnum = {}));
})(BoardingPassLounge || (BoardingPassLounge = {}));
/**
 * @export
 * @namespace BoardingPassResult
 */
export var BoardingPassResult;
(function (BoardingPassResult) {
    /**
     * @export
     * @enum {string}
     */
    var ResultEnum;
    (function (ResultEnum) {
        ResultEnum[ResultEnum["Sent"] = 'sent'] = "Sent";
        ResultEnum[ResultEnum["ReturnedDocumentURL"] = 'returnedDocumentURL'] = "ReturnedDocumentURL";
        ResultEnum[ResultEnum["ReturnedBoardingPassData"] = 'returnedBoardingPassData'] = "ReturnedBoardingPassData";
        ResultEnum[ResultEnum["Inhibited"] = 'inhibited'] = "Inhibited";
    })(ResultEnum = BoardingPassResult.ResultEnum || (BoardingPassResult.ResultEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var DocumentTypeEnum;
    (function (DocumentTypeEnum) {
        DocumentTypeEnum[DocumentTypeEnum["BoardingPass"] = 'boardingPass'] = "BoardingPass";
        DocumentTypeEnum[DocumentTypeEnum["Confirmation"] = 'confirmation'] = "Confirmation";
    })(DocumentTypeEnum = BoardingPassResult.DocumentTypeEnum || (BoardingPassResult.DocumentTypeEnum = {}));
})(BoardingPassResult || (BoardingPassResult = {}));
/**
 * @export
 * @namespace BoundCommon
 */
export var BoundCommon;
(function (BoundCommon) {
    /**
     * @export
     * @enum {string}
     */
    var BoundTypeEnum;
    (function (BoundTypeEnum) {
        BoundTypeEnum[BoundTypeEnum["OUTBOUND"] = 'OUTBOUND'] = "OUTBOUND";
        BoundTypeEnum[BoundTypeEnum["INBOUND"] = 'INBOUND'] = "INBOUND";
    })(BoundTypeEnum = BoundCommon.BoundTypeEnum || (BoundCommon.BoundTypeEnum = {}));
})(BoundCommon || (BoundCommon = {}));
/**
 * @export
 * @namespace BundleDiscountValueItem
 */
export var BundleDiscountValueItem;
(function (BundleDiscountValueItem) {
    /**
     * @export
     * @enum {string}
     */
    var DiscountTypeEnum;
    (function (DiscountTypeEnum) {
        DiscountTypeEnum[DiscountTypeEnum["Percentage"] = 'percentage'] = "Percentage";
        DiscountTypeEnum[DiscountTypeEnum["Fixed"] = 'fixed'] = "Fixed";
    })(DiscountTypeEnum = BundleDiscountValueItem.DiscountTypeEnum || (BundleDiscountValueItem.DiscountTypeEnum = {}));
})(BundleDiscountValueItem || (BundleDiscountValueItem = {}));
/**
 * @export
 * @namespace CancellationPolicy
 */
export var CancellationPolicy;
(function (CancellationPolicy) {
    /**
     * @export
     * @enum {string}
     */
    var TypeEnum;
    (function (TypeEnum) {
        TypeEnum[TypeEnum["FULLSTAY"] = 'FULL_STAY'] = "FULLSTAY";
        TypeEnum[TypeEnum["NIGHTS"] = 'NIGHTS'] = "NIGHTS";
    })(TypeEnum = CancellationPolicy.TypeEnum || (CancellationPolicy.TypeEnum = {}));
})(CancellationPolicy || (CancellationPolicy = {}));
/**
 * @export
 * @namespace CarInsuranceDocument
 */
export var CarInsuranceDocument;
(function (CarInsuranceDocument) {
    /**
     * @export
     * @enum {string}
     */
    var DocumentTypeEnum;
    (function (DocumentTypeEnum) {
        DocumentTypeEnum[DocumentTypeEnum["PolicyWording"] = 'policyWording'] = "PolicyWording";
        DocumentTypeEnum[DocumentTypeEnum["KeyFacts"] = 'keyFacts'] = "KeyFacts";
        DocumentTypeEnum[DocumentTypeEnum["Certificate"] = 'certificate'] = "Certificate";
    })(DocumentTypeEnum = CarInsuranceDocument.DocumentTypeEnum || (CarInsuranceDocument.DocumentTypeEnum = {}));
})(CarInsuranceDocument || (CarInsuranceDocument = {}));
/**
 * @export
 * @namespace CarLocationDictionaryItemLocation
 */
export var CarLocationDictionaryItemLocation;
(function (CarLocationDictionaryItemLocation) {
    /**
     * @export
     * @enum {string}
     */
    var TypeEnum;
    (function (TypeEnum) {
        TypeEnum[TypeEnum["Amadeus"] = 'amadeus'] = "Amadeus";
        TypeEnum[TypeEnum["Company"] = 'company'] = "Company";
    })(TypeEnum = CarLocationDictionaryItemLocation.TypeEnum || (CarLocationDictionaryItemLocation.TypeEnum = {}));
})(CarLocationDictionaryItemLocation || (CarLocationDictionaryItemLocation = {}));
/**
 * @export
 * @namespace CarRatePlanPrice
 */
export var CarRatePlanPrice;
(function (CarRatePlanPrice) {
    /**
     * @export
     * @enum {string}
     */
    var PricingTimeWindowEnum;
    (function (PricingTimeWindowEnum) {
        PricingTimeWindowEnum[PricingTimeWindowEnum["Hourly"] = 'hourly'] = "Hourly";
        PricingTimeWindowEnum[PricingTimeWindowEnum["Daily"] = 'daily'] = "Daily";
        PricingTimeWindowEnum[PricingTimeWindowEnum["Monthly"] = 'monthly'] = "Monthly";
        PricingTimeWindowEnum[PricingTimeWindowEnum["Weekend"] = 'weekend'] = "Weekend";
        PricingTimeWindowEnum[PricingTimeWindowEnum["Weekly"] = 'weekly'] = "Weekly";
        PricingTimeWindowEnum[PricingTimeWindowEnum["FullPeriod"] = 'fullPeriod'] = "FullPeriod";
    })(PricingTimeWindowEnum = CarRatePlanPrice.PricingTimeWindowEnum || (CarRatePlanPrice.PricingTimeWindowEnum = {}));
})(CarRatePlanPrice || (CarRatePlanPrice = {}));
/**
 * @export
 * @namespace CarRelevantCriteria
 */
export var CarRelevantCriteria;
(function (CarRelevantCriteria) {
    /**
     * @export
     * @enum {string}
     */
    var OrderByEnum;
    (function (OrderByEnum) {
        OrderByEnum[OrderByEnum["PriceAsc"] = 'priceAsc'] = "PriceAsc";
        OrderByEnum[OrderByEnum["PriceDesc"] = 'priceDesc'] = "PriceDesc";
        OrderByEnum[OrderByEnum["ProviderPreferredOrderAsc"] = 'providerPreferredOrderAsc'] = "ProviderPreferredOrderAsc";
    })(OrderByEnum = CarRelevantCriteria.OrderByEnum || (CarRelevantCriteria.OrderByEnum = {}));
})(CarRelevantCriteria || (CarRelevantCriteria = {}));
/**
 * @export
 * @namespace CheckInFlight
 */
export var CheckInFlight;
(function (CheckInFlight) {
    /**
     * @export
     * @enum {string}
     */
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["Scheduled"] = 'scheduled'] = "Scheduled";
        StatusEnum[StatusEnum["Gated"] = 'gated'] = "Gated";
        StatusEnum[StatusEnum["Departed"] = 'departed'] = "Departed";
        StatusEnum[StatusEnum["Finalized"] = 'finalized'] = "Finalized";
        StatusEnum[StatusEnum["Suspended"] = 'suspended'] = "Suspended";
        StatusEnum[StatusEnum["Locked"] = 'locked'] = "Locked";
        StatusEnum[StatusEnum["Cancelled"] = 'cancelled'] = "Cancelled";
        StatusEnum[StatusEnum["Reallocated"] = 'reallocated'] = "Reallocated";
        StatusEnum[StatusEnum["NotOperated"] = 'notOperated'] = "NotOperated";
        StatusEnum[StatusEnum["NotOK"] = 'notOK'] = "NotOK";
        StatusEnum[StatusEnum["StatusNotSupportedInThisVersion"] = 'statusNotSupportedInThisVersion'] = "StatusNotSupportedInThisVersion";
    })(StatusEnum = CheckInFlight.StatusEnum || (CheckInFlight.StatusEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var AcceptanceStatusEnum;
    (function (AcceptanceStatusEnum) {
        AcceptanceStatusEnum[AcceptanceStatusEnum["NotOpened"] = 'notOpened'] = "NotOpened";
        AcceptanceStatusEnum[AcceptanceStatusEnum["Opened"] = 'opened'] = "Opened";
        AcceptanceStatusEnum[AcceptanceStatusEnum["Gated"] = 'gated'] = "Gated";
        AcceptanceStatusEnum[AcceptanceStatusEnum["Closed"] = 'closed'] = "Closed";
        AcceptanceStatusEnum[AcceptanceStatusEnum["Finalized"] = 'finalized'] = "Finalized";
        AcceptanceStatusEnum[AcceptanceStatusEnum["Suspended"] = 'suspended'] = "Suspended";
        AcceptanceStatusEnum[AcceptanceStatusEnum["NotOK"] = 'notOK'] = "NotOK";
        AcceptanceStatusEnum[AcceptanceStatusEnum["StatusNotSupportedInThisVersion"] = 'statusNotSupportedInThisVersion'] = "StatusNotSupportedInThisVersion";
    })(AcceptanceStatusEnum = CheckInFlight.AcceptanceStatusEnum || (CheckInFlight.AcceptanceStatusEnum = {}));
})(CheckInFlight || (CheckInFlight = {}));
/**
 * @export
 * @namespace CheckinChannel
 */
export var CheckinChannel;
(function (CheckinChannel) {
    /**
     * @export
     * @enum {string}
     */
    var ChannelEnum;
    (function (ChannelEnum) {
        ChannelEnum[ChannelEnum["CRYPTIC"] = 'CRYPTIC'] = "CRYPTIC";
        ChannelEnum[ChannelEnum["EXTERNALDCS"] = 'EXTERNAL_DCS'] = "EXTERNALDCS";
        ChannelEnum[ChannelEnum["JFE"] = 'JFE'] = "JFE";
        ChannelEnum[ChannelEnum["KIOSK"] = 'KIOSK'] = "KIOSK";
        ChannelEnum[ChannelEnum["MOBILEPHONE"] = 'MOBILE_PHONE'] = "MOBILEPHONE";
        ChannelEnum[ChannelEnum["SMS"] = 'SMS'] = "SMS";
        ChannelEnum[ChannelEnum["TELEPHONE"] = 'TELEPHONE'] = "TELEPHONE";
        ChannelEnum[ChannelEnum["WEB"] = 'WEB'] = "WEB";
        ChannelEnum[ChannelEnum["EXTERNALFRONTEND"] = 'EXTERNAL_FRONTEND'] = "EXTERNALFRONTEND";
    })(ChannelEnum = CheckinChannel.ChannelEnum || (CheckinChannel.ChannelEnum = {}));
})(CheckinChannel || (CheckinChannel = {}));
/**
 * @export
 * @namespace CheckinRelationship
 */
export var CheckinRelationship;
(function (CheckinRelationship) {
    /**
     * @export
     * @enum {string}
     */
    var RelEnum;
    (function (RelEnum) {
        RelEnum[RelEnum["CHECKINIDENTIFICATION"] = 'CHECKIN_IDENTIFICATION'] = "CHECKINIDENTIFICATION";
        RelEnum[RelEnum["REGULATORYCHECK"] = 'REGULATORY_CHECK'] = "REGULATORYCHECK";
        RelEnum[RelEnum["BOARDINGPASSISSUANCE"] = 'BOARDINGPASS_ISSUANCE'] = "BOARDINGPASSISSUANCE";
        RelEnum[RelEnum["TRAVELLERMANAGEMENT"] = 'TRAVELLER_MANAGEMENT'] = "TRAVELLERMANAGEMENT";
    })(RelEnum = CheckinRelationship.RelEnum || (CheckinRelationship.RelEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var MethodsEnum;
    (function (MethodsEnum) {
        MethodsEnum[MethodsEnum["GET"] = 'GET'] = "GET";
        MethodsEnum[MethodsEnum["POST"] = 'POST'] = "POST";
        MethodsEnum[MethodsEnum["PUT"] = 'PUT'] = "PUT";
        MethodsEnum[MethodsEnum["PATCH"] = 'PATCH'] = "PATCH";
        MethodsEnum[MethodsEnum["DELETE"] = 'DELETE'] = "DELETE";
    })(MethodsEnum = CheckinRelationship.MethodsEnum || (CheckinRelationship.MethodsEnum = {}));
})(CheckinRelationship || (CheckinRelationship = {}));
/**
 * @export
 * @namespace CityPair
 */
export var CityPair;
(function (CityPair) {
    /**
     * @export
     * @enum {string}
     */
    var OriginLocationTypeEnum;
    (function (OriginLocationTypeEnum) {
        OriginLocationTypeEnum[OriginLocationTypeEnum["Airport"] = 'airport'] = "Airport";
        OriginLocationTypeEnum[OriginLocationTypeEnum["City"] = 'city'] = "City";
    })(OriginLocationTypeEnum = CityPair.OriginLocationTypeEnum || (CityPair.OriginLocationTypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var DestinationLocationTypeEnum;
    (function (DestinationLocationTypeEnum) {
        DestinationLocationTypeEnum[DestinationLocationTypeEnum["Airport"] = 'airport'] = "Airport";
        DestinationLocationTypeEnum[DestinationLocationTypeEnum["City"] = 'city'] = "City";
    })(DestinationLocationTypeEnum = CityPair.DestinationLocationTypeEnum || (CityPair.DestinationLocationTypeEnum = {}));
})(CityPair || (CityPair = {}));
/**
 * @export
 * @namespace Contact
 */
export var Contact;
(function (Contact) {
    /**
     * @export
     * @enum {string}
     */
    var CategoryEnum;
    (function (CategoryEnum) {
        CategoryEnum[CategoryEnum["Personal"] = 'personal'] = "Personal";
        CategoryEnum[CategoryEnum["Business"] = 'business'] = "Business";
        CategoryEnum[CategoryEnum["Agency"] = 'agency'] = "Agency";
        CategoryEnum[CategoryEnum["Other"] = 'other'] = "Other";
    })(CategoryEnum = Contact.CategoryEnum || (Contact.CategoryEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var ContactTypeEnum;
    (function (ContactTypeEnum) {
        ContactTypeEnum[ContactTypeEnum["Email"] = 'Email'] = "Email";
        ContactTypeEnum[ContactTypeEnum["Address"] = 'Address'] = "Address";
        ContactTypeEnum[ContactTypeEnum["Phone"] = 'Phone'] = "Phone";
        ContactTypeEnum[ContactTypeEnum["FreeFlow"] = 'FreeFlow'] = "FreeFlow";
    })(ContactTypeEnum = Contact.ContactTypeEnum || (Contact.ContactTypeEnum = {}));
})(Contact || (Contact = {}));
/**
 * @export
 * @namespace Coverage
 */
export var Coverage;
(function (Coverage) {
    /**
     * @export
     * @enum {string}
     */
    var PricingTimeWindowEnum;
    (function (PricingTimeWindowEnum) {
        PricingTimeWindowEnum[PricingTimeWindowEnum["Hourly"] = 'hourly'] = "Hourly";
        PricingTimeWindowEnum[PricingTimeWindowEnum["Daily"] = 'daily'] = "Daily";
        PricingTimeWindowEnum[PricingTimeWindowEnum["Monthly"] = 'monthly'] = "Monthly";
        PricingTimeWindowEnum[PricingTimeWindowEnum["Weekend"] = 'weekend'] = "Weekend";
        PricingTimeWindowEnum[PricingTimeWindowEnum["Weekly"] = 'weekly'] = "Weekly";
        PricingTimeWindowEnum[PricingTimeWindowEnum["FullPeriod"] = 'fullPeriod'] = "FullPeriod";
    })(PricingTimeWindowEnum = Coverage.PricingTimeWindowEnum || (Coverage.PricingTimeWindowEnum = {}));
})(Coverage || (Coverage = {}));
/**
 * @export
 * @namespace CustomPayment
 */
export var CustomPayment;
(function (CustomPayment) {
    /**
     * @export
     * @enum {string}
     */
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["Approved"] = 'approved'] = "Approved";
        StatusEnum[StatusEnum["Pending"] = 'pending'] = "Pending";
        StatusEnum[StatusEnum["Denied"] = 'denied'] = "Denied";
        StatusEnum[StatusEnum["Error"] = 'error'] = "Error";
    })(StatusEnum = CustomPayment.StatusEnum || (CustomPayment.StatusEnum = {}));
})(CustomPayment || (CustomPayment = {}));
/**
 * @export
 * @namespace DataUsageConsentPermission
 */
export var DataUsageConsentPermission;
(function (DataUsageConsentPermission) {
    /**
     * @export
     * @enum {string}
     */
    var ActionEnum;
    (function (ActionEnum) {
        ActionEnum[ActionEnum["READ"] = 'READ'] = "READ";
        ActionEnum[ActionEnum["WRITE"] = 'WRITE'] = "WRITE";
        ActionEnum[ActionEnum["NONE"] = 'NONE'] = "NONE";
    })(ActionEnum = DataUsageConsentPermission.ActionEnum || (DataUsageConsentPermission.ActionEnum = {}));
})(DataUsageConsentPermission || (DataUsageConsentPermission = {}));
/**
 * @export
 * @namespace DisruptionConnection
 */
export var DisruptionConnection;
(function (DisruptionConnection) {
    /**
     * @export
     * @enum {string}
     */
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["Ok"] = 'ok'] = "Ok";
        StatusEnum[StatusEnum["Broken"] = 'broken'] = "Broken";
    })(StatusEnum = DisruptionConnection.StatusEnum || (DisruptionConnection.StatusEnum = {}));
})(DisruptionConnection || (DisruptionConnection = {}));
/**
 * @export
 * @namespace DocumentEnvelopeMetadata
 */
export var DocumentEnvelopeMetadata;
(function (DocumentEnvelopeMetadata) {
    /**
     * @export
     * @enum {string}
     */
    var DocumentTypeEnum;
    (function (DocumentTypeEnum) {
        DocumentTypeEnum[DocumentTypeEnum["String"] = 'string'] = "String";
        DocumentTypeEnum[DocumentTypeEnum["Pdf"] = 'pdf'] = "Pdf";
    })(DocumentTypeEnum = DocumentEnvelopeMetadata.DocumentTypeEnum || (DocumentEnvelopeMetadata.DocumentTypeEnum = {}));
})(DocumentEnvelopeMetadata || (DocumentEnvelopeMetadata = {}));
/**
 * @export
 * @namespace DxApiPublicPaymentMethod
 */
export var DxApiPublicPaymentMethod;
(function (DxApiPublicPaymentMethod) {
    /**
     * @export
     * @enum {string}
     */
    var PaymentTypeEnum;
    (function (PaymentTypeEnum) {
        PaymentTypeEnum[PaymentTypeEnum["PaymentCard"] = 'PaymentCard'] = "PaymentCard";
        PaymentTypeEnum[PaymentTypeEnum["MilesPayment"] = 'MilesPayment'] = "MilesPayment";
        PaymentTypeEnum[PaymentTypeEnum["AlternativePaymentMethod"] = 'AlternativePaymentMethod'] = "AlternativePaymentMethod";
        PaymentTypeEnum[PaymentTypeEnum["VoucherPayment"] = 'VoucherPayment'] = "VoucherPayment";
        PaymentTypeEnum[PaymentTypeEnum["CustomPayment"] = 'CustomPayment'] = "CustomPayment";
        PaymentTypeEnum[PaymentTypeEnum["CheckoutFormPayment"] = 'CheckoutFormPayment'] = "CheckoutFormPayment";
    })(PaymentTypeEnum = DxApiPublicPaymentMethod.PaymentTypeEnum || (DxApiPublicPaymentMethod.PaymentTypeEnum = {}));
})(DxApiPublicPaymentMethod || (DxApiPublicPaymentMethod = {}));
/**
 * @export
 * @namespace Eligibility
 */
export var Eligibility;
(function (Eligibility) {
    /**
     * @export
     * @enum {string}
     */
    var ReasonsEnum;
    (function (ReasonsEnum) {
        ReasonsEnum[ReasonsEnum["FirstFlightOtherAirline"] = 'firstFlightOtherAirline'] = "FirstFlightOtherAirline";
        ReasonsEnum[ReasonsEnum["FirstFlightOnOtherDepartureControlSystem"] = 'firstFlightOnOtherDepartureControlSystem'] = "FirstFlightOnOtherDepartureControlSystem";
        ReasonsEnum[ReasonsEnum["FlightAcceptanceEligibilityWindow"] = 'flightAcceptanceEligibilityWindow'] = "FlightAcceptanceEligibilityWindow";
        ReasonsEnum[ReasonsEnum["FlightAcceptanceDefaultEligibilityWindow"] = 'flightAcceptanceDefaultEligibilityWindow'] = "FlightAcceptanceDefaultEligibilityWindow";
        ReasonsEnum[ReasonsEnum["FlightEligibilityRule"] = 'flightEligibilityRule'] = "FlightEligibilityRule";
        ReasonsEnum[ReasonsEnum["FlightEligibilityDefaultRule"] = 'flightEligibilityDefaultRule'] = "FlightEligibilityDefaultRule";
        ReasonsEnum[ReasonsEnum["FlightGeneralStatus"] = 'flightGeneralStatus'] = "FlightGeneralStatus";
        ReasonsEnum[ReasonsEnum["FlightAcceptanceStatus"] = 'flightAcceptanceStatus'] = "FlightAcceptanceStatus";
        ReasonsEnum[ReasonsEnum["DepartureAirportInhibited"] = 'departureAirportInhibited'] = "DepartureAirportInhibited";
        ReasonsEnum[ReasonsEnum["ArrivalAirportInhibited"] = 'arrivalAirportInhibited'] = "ArrivalAirportInhibited";
        ReasonsEnum[ReasonsEnum["FirstFlightIsInhibited"] = 'firstFlightIsInhibited'] = "FirstFlightIsInhibited";
        ReasonsEnum[ReasonsEnum["PassiveSegment"] = 'passiveSegment'] = "PassiveSegment";
        ReasonsEnum[ReasonsEnum["PreviousFlightIsInhibited"] = 'previousFlightIsInhibited'] = "PreviousFlightIsInhibited";
        ReasonsEnum[ReasonsEnum["InfantStatusNeedToBeChecked"] = 'infantStatusNeedToBeChecked'] = "InfantStatusNeedToBeChecked";
        ReasonsEnum[ReasonsEnum["InfantAgeToBeChecked"] = 'infantAgeToBeChecked'] = "InfantAgeToBeChecked";
        ReasonsEnum[ReasonsEnum["ChildAgeToBeChecked"] = 'childAgeToBeChecked'] = "ChildAgeToBeChecked";
        ReasonsEnum[ReasonsEnum["TicketProblem"] = 'ticketProblem'] = "TicketProblem";
        ReasonsEnum[ReasonsEnum["TicketTypeNotAllowed"] = 'ticketTypeNotAllowed'] = "TicketTypeNotAllowed";
        ReasonsEnum[ReasonsEnum["HighPriorityComment"] = 'highPriorityComment'] = "HighPriorityComment";
        ReasonsEnum[ReasonsEnum["CustomerEligibilityRule"] = 'customerEligibilityRule'] = "CustomerEligibilityRule";
        ReasonsEnum[ReasonsEnum["OperationalStatusNotSupported"] = 'operationalStatusNotSupported'] = "OperationalStatusNotSupported";
        ReasonsEnum[ReasonsEnum["ServiceRequestNotSupported"] = 'serviceRequestNotSupported'] = "ServiceRequestNotSupported";
        ReasonsEnum[ReasonsEnum["UnpaidService"] = 'unpaidService'] = "UnpaidService";
        ReasonsEnum[ReasonsEnum["RegulatoryDetailsInhibition"] = 'regulatoryDetailsInhibition'] = "RegulatoryDetailsInhibition";
        ReasonsEnum[ReasonsEnum["RegulatoryDetailsLimitations"] = 'regulatoryDetailsLimitations'] = "RegulatoryDetailsLimitations";
        ReasonsEnum[ReasonsEnum["RegulatoryDetailsNameNotMatching"] = 'regulatoryDetailsNameNotMatching'] = "RegulatoryDetailsNameNotMatching";
        ReasonsEnum[ReasonsEnum["RegulatoryDetailsMultipleNationality"] = 'regulatoryDetailsMultipleNationality'] = "RegulatoryDetailsMultipleNationality";
        ReasonsEnum[ReasonsEnum["RegulatoryDetailsStatusNotAuthorized"] = 'regulatoryDetailsStatusNotAuthorized'] = "RegulatoryDetailsStatusNotAuthorized";
        ReasonsEnum[ReasonsEnum["RegulatoryDetailsPassportExpired"] = 'regulatoryDetailsPassportExpired'] = "RegulatoryDetailsPassportExpired";
        ReasonsEnum[ReasonsEnum["ReprintingIsInhibited"] = 'reprintingIsInhibited'] = "ReprintingIsInhibited";
        ReasonsEnum[ReasonsEnum["AlreadyBoarded"] = 'alreadyBoarded'] = "AlreadyBoarded";
        ReasonsEnum[ReasonsEnum["VisaNeedAgentVerification"] = 'visaNeedAgentVerification'] = "VisaNeedAgentVerification";
        ReasonsEnum[ReasonsEnum["IneligibleBookingstatus"] = 'ineligibleBookingstatus'] = "IneligibleBookingstatus";
        ReasonsEnum[ReasonsEnum["IneligibleNonRevenuePassenger"] = 'ineligibleNonRevenuePassenger'] = "IneligibleNonRevenuePassenger";
        ReasonsEnum[ReasonsEnum["FlightIsDisrupted"] = 'flightIsDisrupted'] = "FlightIsDisrupted";
        ReasonsEnum[ReasonsEnum["PassengerAlreadyAccepted"] = 'passengerAlreadyAccepted'] = "PassengerAlreadyAccepted";
        ReasonsEnum[ReasonsEnum["ReasonNotSupportedInThisVersion"] = 'reasonNotSupportedInThisVersion'] = "ReasonNotSupportedInThisVersion";
        ReasonsEnum[ReasonsEnum["ItinerarySequenceCheck"] = 'itinerarySequenceCheck'] = "ItinerarySequenceCheck";
        ReasonsEnum[ReasonsEnum["CustomerTypeCheck"] = 'customerTypeCheck'] = "CustomerTypeCheck";
        ReasonsEnum[ReasonsEnum["DeeplinkInhibition"] = 'deeplinkInhibition'] = "DeeplinkInhibition";
    })(ReasonsEnum = Eligibility.ReasonsEnum || (Eligibility.ReasonsEnum = {}));
})(Eligibility || (Eligibility = {}));
/**
 * @export
 * @namespace EligibilityBoardingPass
 */
export var EligibilityBoardingPass;
(function (EligibilityBoardingPass) {
    /**
     * @export
     * @enum {string}
     */
    var AllowedBoardingPassTypesEnum;
    (function (AllowedBoardingPassTypesEnum) {
        AllowedBoardingPassTypesEnum[AllowedBoardingPassTypesEnum["AirportPrinted"] = 'airportPrinted'] = "AirportPrinted";
        AllowedBoardingPassTypesEnum[AllowedBoardingPassTypesEnum["HomePrinted"] = 'homePrinted'] = "HomePrinted";
        AllowedBoardingPassTypesEnum[AllowedBoardingPassTypesEnum["BarcodeOnDevice"] = 'barcodeOnDevice'] = "BarcodeOnDevice";
        AllowedBoardingPassTypesEnum[AllowedBoardingPassTypesEnum["TextMessageOnDevice"] = 'textMessageOnDevice'] = "TextMessageOnDevice";
    })(AllowedBoardingPassTypesEnum = EligibilityBoardingPass.AllowedBoardingPassTypesEnum || (EligibilityBoardingPass.AllowedBoardingPassTypesEnum = {}));
})(EligibilityBoardingPass || (EligibilityBoardingPass = {}));
/**
 * @export
 * @namespace EligibilityCommon
 */
export var EligibilityCommon;
(function (EligibilityCommon) {
    /**
     * @export
     * @enum {string}
     */
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["Eligible"] = 'eligible'] = "Eligible";
        StatusEnum[StatusEnum["Ineligible"] = 'ineligible'] = "Ineligible";
        StatusEnum[StatusEnum["Partial"] = 'partial'] = "Partial";
    })(StatusEnum = EligibilityCommon.StatusEnum || (EligibilityCommon.StatusEnum = {}));
})(EligibilityCommon || (EligibilityCommon = {}));
/**
 * @export
 * @namespace EligibleCondition
 */
export var EligibleCondition;
(function (EligibleCondition) {
    /**
     * @export
     * @enum {string}
     */
    var TypeEnum;
    (function (TypeEnum) {
        TypeEnum[TypeEnum["PromocodeEligibleCondition"] = 'PromocodeEligibleCondition'] = "PromocodeEligibleCondition";
    })(TypeEnum = EligibleCondition.TypeEnum || (EligibleCondition.TypeEnum = {}));
})(EligibleCondition || (EligibleCondition = {}));
/**
 * @export
 * @namespace Email
 */
export var Email;
(function (Email) {
    /**
     * @export
     * @enum {string}
     */
    var PurposeEnum;
    (function (PurposeEnum) {
        PurposeEnum[PurposeEnum["Standard"] = 'standard'] = "Standard";
        PurposeEnum[PurposeEnum["Notification"] = 'notification'] = "Notification";
        PurposeEnum[PurposeEnum["Information"] = 'information'] = "Information";
    })(PurposeEnum = Email.PurposeEnum || (Email.PurposeEnum = {}));
})(Email || (Email = {}));
/**
 * @export
 * @namespace EntertainmentAmenity
 */
export var EntertainmentAmenity;
(function (EntertainmentAmenity) {
    /**
     * @export
     * @enum {string}
     */
    var EntertainmentTypeEnum;
    (function (EntertainmentTypeEnum) {
        EntertainmentTypeEnum[EntertainmentTypeEnum["AIRLINEPROVIDEDTABLET"] = 'AIRLINE_PROVIDED_TABLET'] = "AIRLINEPROVIDEDTABLET";
        EntertainmentTypeEnum[EntertainmentTypeEnum["STREAMINGONFLIGHTWIFI"] = 'STREAMING_ON_FLIGHT_WIFI'] = "STREAMINGONFLIGHTWIFI";
        EntertainmentTypeEnum[EntertainmentTypeEnum["OVERHEADMONITORS"] = 'OVERHEAD_MONITORS'] = "OVERHEADMONITORS";
        EntertainmentTypeEnum[EntertainmentTypeEnum["AUDIOVIDEOONDEMAND"] = 'AUDIO_VIDEO_ON_DEMAND'] = "AUDIOVIDEOONDEMAND";
        EntertainmentTypeEnum[EntertainmentTypeEnum["LIVETV"] = 'LIVE_TV'] = "LIVETV";
        EntertainmentTypeEnum[EntertainmentTypeEnum["PREFLIGHTDOWNLOADCONTENT"] = 'PRE_FLIGHT_DOWNLOAD_CONTENT'] = "PREFLIGHTDOWNLOADCONTENT";
        EntertainmentTypeEnum[EntertainmentTypeEnum["SEATBACKSCREENS"] = 'SEAT_BACK_SCREENS'] = "SEATBACKSCREENS";
        EntertainmentTypeEnum[EntertainmentTypeEnum["NONE"] = 'NONE'] = "NONE";
    })(EntertainmentTypeEnum = EntertainmentAmenity.EntertainmentTypeEnum || (EntertainmentAmenity.EntertainmentTypeEnum = {}));
})(EntertainmentAmenity || (EntertainmentAmenity = {}));
/**
 * @export
 * @namespace EntitlementDocument
 */
export var EntitlementDocument;
(function (EntitlementDocument) {
    /**
     * @export
     * @enum {string}
     */
    var DocumentTypeEnum;
    (function (DocumentTypeEnum) {
        DocumentTypeEnum[DocumentTypeEnum["SpanishResidentCard"] = 'SpanishResidentCard'] = "SpanishResidentCard";
        DocumentTypeEnum[DocumentTypeEnum["SpanishLargeFamilyCard"] = 'SpanishLargeFamilyCard'] = "SpanishLargeFamilyCard";
    })(DocumentTypeEnum = EntitlementDocument.DocumentTypeEnum || (EntitlementDocument.DocumentTypeEnum = {}));
})(EntitlementDocument || (EntitlementDocument = {}));
/**
 * @export
 * @namespace ExchangeFareInfoRequest
 */
export var ExchangeFareInfoRequest;
(function (ExchangeFareInfoRequest) {
    /**
     * @export
     * @enum {string}
     */
    var FareTypeEnum;
    (function (FareTypeEnum) {
        FareTypeEnum[FareTypeEnum["Public"] = 'public'] = "Public";
        FareTypeEnum[FareTypeEnum["Unifares"] = 'unifares'] = "Unifares";
    })(FareTypeEnum = ExchangeFareInfoRequest.FareTypeEnum || (ExchangeFareInfoRequest.FareTypeEnum = {}));
})(ExchangeFareInfoRequest || (ExchangeFareInfoRequest = {}));
/**
 * @export
 * @namespace ExchangeTravelDocument
 */
export var ExchangeTravelDocument;
(function (ExchangeTravelDocument) {
    /**
     * @export
     * @enum {string}
     */
    var DocumentTypeEnum;
    (function (DocumentTypeEnum) {
        DocumentTypeEnum[DocumentTypeEnum["Eticket"] = 'eticket'] = "Eticket";
        DocumentTypeEnum[DocumentTypeEnum["Services"] = 'services'] = "Services";
    })(DocumentTypeEnum = ExchangeTravelDocument.DocumentTypeEnum || (ExchangeTravelDocument.DocumentTypeEnum = {}));
})(ExchangeTravelDocument || (ExchangeTravelDocument = {}));
/**
 * @export
 * @namespace ExtendedRegulatoryDocument
 */
export var ExtendedRegulatoryDocument;
(function (ExtendedRegulatoryDocument) {
    /**
     * @export
     * @enum {string}
     */
    var DocumentTypeEnum;
    (function (DocumentTypeEnum) {
        DocumentTypeEnum[DocumentTypeEnum["Passport"] = 'passport'] = "Passport";
        DocumentTypeEnum[DocumentTypeEnum["IdentityCard"] = 'identityCard'] = "IdentityCard";
        DocumentTypeEnum[DocumentTypeEnum["AirAttendanceLicense"] = 'airAttendanceLicense'] = "AirAttendanceLicense";
        DocumentTypeEnum[DocumentTypeEnum["BirthCertificate"] = 'birthCertificate'] = "BirthCertificate";
        DocumentTypeEnum[DocumentTypeEnum["BorderCrossingCard"] = 'borderCrossingCard'] = "BorderCrossingCard";
        DocumentTypeEnum[DocumentTypeEnum["DrivingLicense"] = 'drivingLicense'] = "DrivingLicense";
        DocumentTypeEnum[DocumentTypeEnum["FlightMechanicalLicense"] = 'flightMechanicalLicense'] = "FlightMechanicalLicense";
        DocumentTypeEnum[DocumentTypeEnum["ForeignNationalRegistration"] = 'foreignNationalRegistration'] = "ForeignNationalRegistration";
        DocumentTypeEnum[DocumentTypeEnum["LoyalAttorneyIdentification"] = 'loyalAttorneyIdentification'] = "LoyalAttorneyIdentification";
        DocumentTypeEnum[DocumentTypeEnum["MilitaryIdentityCard"] = 'militaryIdentityCard'] = "MilitaryIdentityCard";
        DocumentTypeEnum[DocumentTypeEnum["OperationalDispatcherLicense"] = 'operationalDispatcherLicense'] = "OperationalDispatcherLicense";
        DocumentTypeEnum[DocumentTypeEnum["PilotLicense"] = 'pilotLicense'] = "PilotLicense";
        DocumentTypeEnum[DocumentTypeEnum["ReEntryPermit"] = 'reEntryPermit'] = "ReEntryPermit";
        DocumentTypeEnum[DocumentTypeEnum["NaturalisationCardUS"] = 'naturalisationCardUS'] = "NaturalisationCardUS";
        DocumentTypeEnum[DocumentTypeEnum["WorkPermit"] = 'workPermit'] = "WorkPermit";
        DocumentTypeEnum[DocumentTypeEnum["Visa"] = 'visa'] = "Visa";
        DocumentTypeEnum[DocumentTypeEnum["ResidentAlienCard"] = 'residentAlienCard'] = "ResidentAlienCard";
        DocumentTypeEnum[DocumentTypeEnum["PermanentResidentCard"] = 'permanentResidentCard'] = "PermanentResidentCard";
        DocumentTypeEnum[DocumentTypeEnum["RedressNumber"] = 'redressNumber'] = "RedressNumber";
        DocumentTypeEnum[DocumentTypeEnum["KnownTravelerNumber"] = 'knownTravelerNumber'] = "KnownTravelerNumber";
        DocumentTypeEnum[DocumentTypeEnum["HomeReentryPermit"] = 'homeReentryPermit'] = "HomeReentryPermit";
        DocumentTypeEnum[DocumentTypeEnum["ChinaTravelPermit"] = 'chinaTravelPermit'] = "ChinaTravelPermit";
        DocumentTypeEnum[DocumentTypeEnum["ChinaTravelPermitHongKongMacao"] = 'chinaTravelPermitHongKongMacao'] = "ChinaTravelPermitHongKongMacao";
        DocumentTypeEnum[DocumentTypeEnum["ChinaExitAndEntryPermit"] = 'chinaExitAndEntryPermit'] = "ChinaExitAndEntryPermit";
        DocumentTypeEnum[DocumentTypeEnum["ResidentTravelPermit"] = 'residentTravelPermit'] = "ResidentTravelPermit";
        DocumentTypeEnum[DocumentTypeEnum["ResidentTravelPermitToFromTaiwanAndChina"] = 'residentTravelPermitToFromTaiwanAndChina'] = "ResidentTravelPermitToFromTaiwanAndChina";
        DocumentTypeEnum[DocumentTypeEnum["ResidentTravelPermitToFromHongKongMacao"] = 'residentTravelPermitToFromHongKongMacao'] = "ResidentTravelPermitToFromHongKongMacao";
        DocumentTypeEnum[DocumentTypeEnum["ResidentTravelPermitToHongKongMacao"] = 'residentTravelPermitToHongKongMacao'] = "ResidentTravelPermitToHongKongMacao";
        DocumentTypeEnum[DocumentTypeEnum["TaiwanExitAndEntryPermit"] = 'taiwanExitAndEntryPermit'] = "TaiwanExitAndEntryPermit";
        DocumentTypeEnum[DocumentTypeEnum["NexusCard"] = 'nexusCard'] = "NexusCard";
    })(DocumentTypeEnum = ExtendedRegulatoryDocument.DocumentTypeEnum || (ExtendedRegulatoryDocument.DocumentTypeEnum = {}));
})(ExtendedRegulatoryDocument || (ExtendedRegulatoryDocument = {}));
/**
 * @export
 * @namespace Extension
 */
export var Extension;
(function (Extension) {
    /**
     * @export
     * @enum {string}
     */
    var ExtensionTypeEnum;
    (function (ExtensionTypeEnum) {
        ExtensionTypeEnum[ExtensionTypeEnum["TextExtension"] = 'TextExtension'] = "TextExtension";
    })(ExtensionTypeEnum = Extension.ExtensionTypeEnum || (Extension.ExtensionTypeEnum = {}));
})(Extension || (Extension = {}));
/**
 * @export
 * @namespace ExtensionsTransportationOffer
 */
export var ExtensionsTransportationOffer;
(function (ExtensionsTransportationOffer) {
    /**
     * @export
     * @enum {string}
     */
    var TransportationTypeEnum;
    (function (TransportationTypeEnum) {
        TransportationTypeEnum[TransportationTypeEnum["Car"] = 'car'] = "Car";
        TransportationTypeEnum[TransportationTypeEnum["Bus"] = 'bus'] = "Bus";
        TransportationTypeEnum[TransportationTypeEnum["Taxi"] = 'taxi'] = "Taxi";
        TransportationTypeEnum[TransportationTypeEnum["Train"] = 'train'] = "Train";
        TransportationTypeEnum[TransportationTypeEnum["Metro"] = 'metro'] = "Metro";
        TransportationTypeEnum[TransportationTypeEnum["Helicopter"] = 'helicopter'] = "Helicopter";
        TransportationTypeEnum[TransportationTypeEnum["Bike"] = 'bike'] = "Bike";
        TransportationTypeEnum[TransportationTypeEnum["Scooter"] = 'scooter'] = "Scooter";
        TransportationTypeEnum[TransportationTypeEnum["Others"] = 'others'] = "Others";
    })(TransportationTypeEnum = ExtensionsTransportationOffer.TransportationTypeEnum || (ExtensionsTransportationOffer.TransportationTypeEnum = {}));
})(ExtensionsTransportationOffer || (ExtensionsTransportationOffer = {}));
/**
 * @export
 * @namespace FareBenefitsDifference
 */
export var FareBenefitsDifference;
(function (FareBenefitsDifference) {
    /**
     * @export
     * @enum {string}
     */
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["ADDED"] = 'ADDED'] = "ADDED";
        StatusEnum[StatusEnum["REMOVED"] = 'REMOVED'] = "REMOVED";
        StatusEnum[StatusEnum["CHANGED"] = 'CHANGED'] = "CHANGED";
    })(StatusEnum = FareBenefitsDifference.StatusEnum || (FareBenefitsDifference.StatusEnum = {}));
})(FareBenefitsDifference || (FareBenefitsDifference = {}));
/**
 * @export
 * @namespace FareConditionsDictionaryItem
 */
export var FareConditionsDictionaryItem;
(function (FareConditionsDictionaryItem) {
    /**
     * @export
     * @enum {string}
     */
    var CategoryEnum;
    (function (CategoryEnum) {
        CategoryEnum[CategoryEnum["Change"] = 'change'] = "Change";
        CategoryEnum[CategoryEnum["Refund"] = 'refund'] = "Refund";
    })(CategoryEnum = FareConditionsDictionaryItem.CategoryEnum || (FareConditionsDictionaryItem.CategoryEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var SituationEnum;
    (function (SituationEnum) {
        SituationEnum[SituationEnum["BeforeDeparture"] = 'beforeDeparture'] = "BeforeDeparture";
    })(SituationEnum = FareConditionsDictionaryItem.SituationEnum || (FareConditionsDictionaryItem.SituationEnum = {}));
})(FareConditionsDictionaryItem || (FareConditionsDictionaryItem = {}));
/**
 * @export
 * @namespace FareConditionsDifference
 */
export var FareConditionsDifference;
(function (FareConditionsDifference) {
    /**
     * @export
     * @enum {string}
     */
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["ADDED"] = 'ADDED'] = "ADDED";
        StatusEnum[StatusEnum["REMOVED"] = 'REMOVED'] = "REMOVED";
    })(StatusEnum = FareConditionsDifference.StatusEnum || (FareConditionsDifference.StatusEnum = {}));
})(FareConditionsDifference || (FareConditionsDifference = {}));
/**
 * @export
 * @namespace FareDiscount
 */
export var FareDiscount;
(function (FareDiscount) {
    /**
     * @export
     * @enum {string}
     */
    var CodeEnum;
    (function (CodeEnum) {
        CodeEnum[CodeEnum["DCP"] = 'DCP'] = "DCP";
    })(CodeEnum = FareDiscount.CodeEnum || (FareDiscount.CodeEnum = {}));
})(FareDiscount || (FareDiscount = {}));
/**
 * @export
 * @namespace FareElement
 */
export var FareElement;
(function (FareElement) {
    /**
     * @export
     * @enum {string}
     */
    var CodeEnum;
    (function (CodeEnum) {
        CodeEnum[CodeEnum["FT"] = 'FT'] = "FT";
    })(CodeEnum = FareElement.CodeEnum || (FareElement.CodeEnum = {}));
})(FareElement || (FareElement = {}));
/**
 * @export
 * @namespace FareFamilyService
 */
export var FareFamilyService;
(function (FareFamilyService) {
    /**
     * @export
     * @enum {string}
     */
    var ApplicabilityEnum;
    (function (ApplicabilityEnum) {
        ApplicabilityEnum[ApplicabilityEnum["Included"] = 'included'] = "Included";
        ApplicabilityEnum[ApplicabilityEnum["Chargeable"] = 'chargeable'] = "Chargeable";
        ApplicabilityEnum[ApplicabilityEnum["NotOffered"] = 'notOffered'] = "NotOffered";
    })(ApplicabilityEnum = FareFamilyService.ApplicabilityEnum || (FareFamilyService.ApplicabilityEnum = {}));
})(FareFamilyService || (FareFamilyService = {}));
/**
 * @export
 * @namespace FareInfo
 */
export var FareInfo;
(function (FareInfo) {
    /**
     * @export
     * @enum {string}
     */
    var FareTypeEnum;
    (function (FareTypeEnum) {
        FareTypeEnum[FareTypeEnum["Public"] = 'public'] = "Public";
        FareTypeEnum[FareTypeEnum["Unifares"] = 'unifares'] = "Unifares";
    })(FareTypeEnum = FareInfo.FareTypeEnum || (FareInfo.FareTypeEnum = {}));
})(FareInfo || (FareInfo = {}));
/**
 * @export
 * @namespace FareInfoTravelDocument
 */
export var FareInfoTravelDocument;
(function (FareInfoTravelDocument) {
    /**
     * @export
     * @enum {string}
     */
    var CouponStatusEnum;
    (function (CouponStatusEnum) {
        CouponStatusEnum[CouponStatusEnum["AirportControl"] = 'airportControl'] = "AirportControl";
        CouponStatusEnum[CouponStatusEnum["CheckedIn"] = 'checkedIn'] = "CheckedIn";
        CouponStatusEnum[CouponStatusEnum["ExchangedOrReissued"] = 'exchangedOrReissued'] = "ExchangedOrReissued";
        CouponStatusEnum[CouponStatusEnum["FlownOrUsed"] = 'flownOrUsed'] = "FlownOrUsed";
        CouponStatusEnum[CouponStatusEnum["ConvertedToFIM"] = 'convertedToFIM'] = "ConvertedToFIM";
        CouponStatusEnum[CouponStatusEnum["IrregularOperations"] = 'irregularOperations'] = "IrregularOperations";
        CouponStatusEnum[CouponStatusEnum["LiftedOrBoarded"] = 'liftedOrBoarded'] = "LiftedOrBoarded";
        CouponStatusEnum[CouponStatusEnum["Open"] = 'open'] = "Open";
        CouponStatusEnum[CouponStatusEnum["Printed"] = 'printed'] = "Printed";
        CouponStatusEnum[CouponStatusEnum["Refunded"] = 'refunded'] = "Refunded";
        CouponStatusEnum[CouponStatusEnum["Suspended"] = 'suspended'] = "Suspended";
        CouponStatusEnum[CouponStatusEnum["Revoked"] = 'revoked'] = "Revoked";
        CouponStatusEnum[CouponStatusEnum["PaperTicket"] = 'paperTicket'] = "PaperTicket";
        CouponStatusEnum[CouponStatusEnum["Unavailable"] = 'unavailable'] = "Unavailable";
        CouponStatusEnum[CouponStatusEnum["Void"] = 'void'] = "Void";
        CouponStatusEnum[CouponStatusEnum["RefundTaxesOrFeesOrCharges"] = 'refundTaxesOrFeesOrCharges'] = "RefundTaxesOrFeesOrCharges";
        CouponStatusEnum[CouponStatusEnum["PrintExchange"] = 'printExchange'] = "PrintExchange";
        CouponStatusEnum[CouponStatusEnum["Closed"] = 'closed'] = "Closed";
        CouponStatusEnum[CouponStatusEnum["GroundTransportationVoucher"] = 'groundTransportationVoucher'] = "GroundTransportationVoucher";
    })(CouponStatusEnum = FareInfoTravelDocument.CouponStatusEnum || (FareInfoTravelDocument.CouponStatusEnum = {}));
})(FareInfoTravelDocument || (FareInfoTravelDocument = {}));
/**
 * @export
 * @namespace FareOptions
 */
export var FareOptions;
(function (FareOptions) {
    /**
     * @export
     * @enum {string}
     */
    var FareTypesEnum;
    (function (FareTypesEnum) {
        FareTypesEnum[FareTypesEnum["Public"] = 'public'] = "Public";
        FareTypesEnum[FareTypesEnum["Unifare"] = 'unifare'] = "Unifare";
    })(FareTypesEnum = FareOptions.FareTypesEnum || (FareOptions.FareTypesEnum = {}));
})(FareOptions || (FareOptions = {}));
/**
 * @export
 * @namespace Fee
 */
export var Fee;
(function (Fee) {
    /**
     * @export
     * @enum {string}
     */
    var NatureEnum;
    (function (NatureEnum) {
        NatureEnum[NatureEnum["Ticketing"] = 'ticketing'] = "Ticketing";
        NatureEnum[NatureEnum["PaymentCard"] = 'paymentCard'] = "PaymentCard";
    })(NatureEnum = Fee.NatureEnum || (Fee.NatureEnum = {}));
})(Fee || (Fee = {}));
/**
 * @export
 * @namespace Flight
 */
export var Flight;
(function (Flight) {
    /**
     * @export
     * @enum {string}
     */
    var FlightStatusEnum;
    (function (FlightStatusEnum) {
        FlightStatusEnum[FlightStatusEnum["Scheduled"] = 'scheduled'] = "Scheduled";
        FlightStatusEnum[FlightStatusEnum["Departed"] = 'departed'] = "Departed";
        FlightStatusEnum[FlightStatusEnum["Cancelled"] = 'cancelled'] = "Cancelled";
        FlightStatusEnum[FlightStatusEnum["Delayed"] = 'delayed'] = "Delayed";
        FlightStatusEnum[FlightStatusEnum["Arrived"] = 'arrived'] = "Arrived";
        FlightStatusEnum[FlightStatusEnum["LandingCancelled"] = 'landingCancelled'] = "LandingCancelled";
        FlightStatusEnum[FlightStatusEnum["Diverted"] = 'diverted'] = "Diverted";
    })(FlightStatusEnum = Flight.FlightStatusEnum || (Flight.FlightStatusEnum = {}));
})(Flight || (Flight = {}));
/**
 * @export
 * @namespace FlightChangeEligibility
 */
export var FlightChangeEligibility;
(function (FlightChangeEligibility) {
    /**
     * @export
     * @enum {string}
     */
    var NonEligibilityReasonEnum;
    (function (NonEligibilityReasonEnum) {
        NonEligibilityReasonEnum[NonEligibilityReasonEnum["FlightGeneralStatus"] = 'flightGeneralStatus'] = "FlightGeneralStatus";
        NonEligibilityReasonEnum[NonEligibilityReasonEnum["TicketProblem"] = 'ticketProblem'] = "TicketProblem";
        NonEligibilityReasonEnum[NonEligibilityReasonEnum["TicketTypeNotAllowed"] = 'ticketTypeNotAllowed'] = "TicketTypeNotAllowed";
        NonEligibilityReasonEnum[NonEligibilityReasonEnum["OfferConditionRule"] = 'offerConditionRule'] = "OfferConditionRule";
        NonEligibilityReasonEnum[NonEligibilityReasonEnum["OperationalStatusNotSupported"] = 'operationalStatusNotSupported'] = "OperationalStatusNotSupported";
        NonEligibilityReasonEnum[NonEligibilityReasonEnum["IneligibleBookingStatus"] = 'ineligibleBookingStatus'] = "IneligibleBookingStatus";
        NonEligibilityReasonEnum[NonEligibilityReasonEnum["FlightIsDisrupted"] = 'flightIsDisrupted'] = "FlightIsDisrupted";
        NonEligibilityReasonEnum[NonEligibilityReasonEnum["FlightChangeNotActivated"] = 'flightChangeNotActivated'] = "FlightChangeNotActivated";
        NonEligibilityReasonEnum[NonEligibilityReasonEnum["IncompatibleCheckinStatus"] = 'incompatibleCheckinStatus'] = "IncompatibleCheckinStatus";
        NonEligibilityReasonEnum[NonEligibilityReasonEnum["GroupsNotSupported"] = 'groupsNotSupported'] = "GroupsNotSupported";
        NonEligibilityReasonEnum[NonEligibilityReasonEnum["PromotionNotSupported"] = 'promotionNotSupported'] = "PromotionNotSupported";
        NonEligibilityReasonEnum[NonEligibilityReasonEnum["UpgradedPNRNotAllowed"] = 'upgradedPNRNotAllowed'] = "UpgradedPNRNotAllowed";
        NonEligibilityReasonEnum[NonEligibilityReasonEnum["UnaccompaniedMinorNotSupported"] = 'unaccompaniedMinorNotSupported'] = "UnaccompaniedMinorNotSupported";
        NonEligibilityReasonEnum[NonEligibilityReasonEnum["TooManyPassengerTypes"] = 'tooManyPassengerTypes'] = "TooManyPassengerTypes";
        NonEligibilityReasonEnum[NonEligibilityReasonEnum["UnissuedServicePresent"] = 'unissuedServicePresent'] = "UnissuedServicePresent";
        NonEligibilityReasonEnum[NonEligibilityReasonEnum["ComplexItineraryNotAllowed"] = 'complexItineraryNotAllowed'] = "ComplexItineraryNotAllowed";
        NonEligibilityReasonEnum[NonEligibilityReasonEnum["FareDiscountNotAllowed"] = 'fareDiscountNotAllowed'] = "FareDiscountNotAllowed";
        NonEligibilityReasonEnum[NonEligibilityReasonEnum["ExtraSeatNotAllowed"] = 'extraSeatNotAllowed'] = "ExtraSeatNotAllowed";
        NonEligibilityReasonEnum[NonEligibilityReasonEnum["DiscrepancyInOrder"] = 'discrepancyInOrder'] = "DiscrepancyInOrder";
        NonEligibilityReasonEnum[NonEligibilityReasonEnum["MilesAndCashNotAllowed"] = 'milesAndCashNotAllowed'] = "MilesAndCashNotAllowed";
        NonEligibilityReasonEnum[NonEligibilityReasonEnum["DynamicWaiverPresent"] = 'dynamicWaiverPresent'] = "DynamicWaiverPresent";
        NonEligibilityReasonEnum[NonEligibilityReasonEnum["ReasonNotSupportedInThisVersion"] = 'reasonNotSupportedInThisVersion'] = "ReasonNotSupportedInThisVersion";
    })(NonEligibilityReasonEnum = FlightChangeEligibility.NonEligibilityReasonEnum || (FlightChangeEligibility.NonEligibilityReasonEnum = {}));
})(FlightChangeEligibility || (FlightChangeEligibility = {}));
/**
 * @export
 * @namespace FlightInformation
 */
export var FlightInformation;
(function (FlightInformation) {
    /**
     * @export
     * @enum {string}
     */
    var FlightStatusEnum;
    (function (FlightStatusEnum) {
        FlightStatusEnum[FlightStatusEnum["Scheduled"] = 'scheduled'] = "Scheduled";
        FlightStatusEnum[FlightStatusEnum["BoardingOpen"] = 'boardingOpen'] = "BoardingOpen";
        FlightStatusEnum[FlightStatusEnum["BoardingClosed"] = 'boardingClosed'] = "BoardingClosed";
        FlightStatusEnum[FlightStatusEnum["Departed"] = 'departed'] = "Departed";
        FlightStatusEnum[FlightStatusEnum["Cancelled"] = 'cancelled'] = "Cancelled";
        FlightStatusEnum[FlightStatusEnum["Delayed"] = 'delayed'] = "Delayed";
        FlightStatusEnum[FlightStatusEnum["Arrived"] = 'arrived'] = "Arrived";
        FlightStatusEnum[FlightStatusEnum["LandingCancelled"] = 'landingCancelled'] = "LandingCancelled";
        FlightStatusEnum[FlightStatusEnum["Diverted"] = 'diverted'] = "Diverted";
    })(FlightStatusEnum = FlightInformation.FlightStatusEnum || (FlightInformation.FlightStatusEnum = {}));
})(FlightInformation || (FlightInformation = {}));
/**
 * @export
 * @namespace FlightInformationArrivalEndPoint
 */
export var FlightInformationArrivalEndPoint;
(function (FlightInformationArrivalEndPoint) {
    /**
     * @export
     * @enum {string}
     */
    var FlightStatusEnum;
    (function (FlightStatusEnum) {
        FlightStatusEnum[FlightStatusEnum["Scheduled"] = 'scheduled'] = "Scheduled";
        FlightStatusEnum[FlightStatusEnum["Departed"] = 'departed'] = "Departed";
        FlightStatusEnum[FlightStatusEnum["Cancelled"] = 'cancelled'] = "Cancelled";
        FlightStatusEnum[FlightStatusEnum["Delayed"] = 'delayed'] = "Delayed";
        FlightStatusEnum[FlightStatusEnum["Arrived"] = 'arrived'] = "Arrived";
        FlightStatusEnum[FlightStatusEnum["LandingCancelled"] = 'landingCancelled'] = "LandingCancelled";
        FlightStatusEnum[FlightStatusEnum["Diverted"] = 'diverted'] = "Diverted";
    })(FlightStatusEnum = FlightInformationArrivalEndPoint.FlightStatusEnum || (FlightInformationArrivalEndPoint.FlightStatusEnum = {}));
})(FlightInformationArrivalEndPoint || (FlightInformationArrivalEndPoint = {}));
/**
 * @export
 * @namespace FlightInformationDepartureEndPoint
 */
export var FlightInformationDepartureEndPoint;
(function (FlightInformationDepartureEndPoint) {
    /**
     * @export
     * @enum {string}
     */
    var FlightStatusEnum;
    (function (FlightStatusEnum) {
        FlightStatusEnum[FlightStatusEnum["Scheduled"] = 'scheduled'] = "Scheduled";
        FlightStatusEnum[FlightStatusEnum["Departed"] = 'departed'] = "Departed";
        FlightStatusEnum[FlightStatusEnum["Cancelled"] = 'cancelled'] = "Cancelled";
        FlightStatusEnum[FlightStatusEnum["Delayed"] = 'delayed'] = "Delayed";
        FlightStatusEnum[FlightStatusEnum["Arrived"] = 'arrived'] = "Arrived";
        FlightStatusEnum[FlightStatusEnum["LandingCancelled"] = 'landingCancelled'] = "LandingCancelled";
        FlightStatusEnum[FlightStatusEnum["Diverted"] = 'diverted'] = "Diverted";
    })(FlightStatusEnum = FlightInformationDepartureEndPoint.FlightStatusEnum || (FlightInformationDepartureEndPoint.FlightStatusEnum = {}));
})(FlightInformationDepartureEndPoint || (FlightInformationDepartureEndPoint = {}));
/**
 * @export
 * @namespace FlightInformationFlightStop
 */
export var FlightInformationFlightStop;
(function (FlightInformationFlightStop) {
    /**
     * @export
     * @enum {string}
     */
    var FlightStatusEnum;
    (function (FlightStatusEnum) {
        FlightStatusEnum[FlightStatusEnum["Scheduled"] = 'scheduled'] = "Scheduled";
        FlightStatusEnum[FlightStatusEnum["Departed"] = 'departed'] = "Departed";
        FlightStatusEnum[FlightStatusEnum["Cancelled"] = 'cancelled'] = "Cancelled";
        FlightStatusEnum[FlightStatusEnum["Delayed"] = 'delayed'] = "Delayed";
        FlightStatusEnum[FlightStatusEnum["Arrived"] = 'arrived'] = "Arrived";
        FlightStatusEnum[FlightStatusEnum["LandingCancelled"] = 'landingCancelled'] = "LandingCancelled";
        FlightStatusEnum[FlightStatusEnum["Diverted"] = 'diverted'] = "Diverted";
    })(FlightStatusEnum = FlightInformationFlightStop.FlightStatusEnum || (FlightInformationFlightStop.FlightStatusEnum = {}));
})(FlightInformationFlightStop || (FlightInformationFlightStop = {}));
/**
 * @export
 * @namespace FlightItem
 */
export var FlightItem;
(function (FlightItem) {
    /**
     * @export
     * @enum {string}
     */
    var CabinEnum;
    (function (CabinEnum) {
        CabinEnum[CabinEnum["Eco"] = 'eco'] = "Eco";
        CabinEnum[CabinEnum["EcoPremium"] = 'ecoPremium'] = "EcoPremium";
        CabinEnum[CabinEnum["Business"] = 'business'] = "Business";
        CabinEnum[CabinEnum["First"] = 'first'] = "First";
    })(CabinEnum = FlightItem.CabinEnum || (FlightItem.CabinEnum = {}));
})(FlightItem || (FlightItem = {}));
/**
 * @export
 * @namespace FlightTimetableData
 */
export var FlightTimetableData;
(function (FlightTimetableData) {
    /**
     * @export
     * @enum {string}
     */
    var OperatingDaysEnum;
    (function (OperatingDaysEnum) {
        OperatingDaysEnum[OperatingDaysEnum["Monday"] = 'monday'] = "Monday";
        OperatingDaysEnum[OperatingDaysEnum["Tuesday"] = 'tuesday'] = "Tuesday";
        OperatingDaysEnum[OperatingDaysEnum["Wednesday"] = 'wednesday'] = "Wednesday";
        OperatingDaysEnum[OperatingDaysEnum["Thursday"] = 'thursday'] = "Thursday";
        OperatingDaysEnum[OperatingDaysEnum["Friday"] = 'friday'] = "Friday";
        OperatingDaysEnum[OperatingDaysEnum["Saturday"] = 'saturday'] = "Saturday";
        OperatingDaysEnum[OperatingDaysEnum["Sunday"] = 'sunday'] = "Sunday";
    })(OperatingDaysEnum = FlightTimetableData.OperatingDaysEnum || (FlightTimetableData.OperatingDaysEnum = {}));
})(FlightTimetableData || (FlightTimetableData = {}));
/**
 * @export
 * @namespace FoodAmenity
 */
export var FoodAmenity;
(function (FoodAmenity) {
    /**
     * @export
     * @enum {string}
     */
    var FoodTypeEnum;
    (function (FoodTypeEnum) {
        FoodTypeEnum[FoodTypeEnum["FOODAVAILABLE"] = 'FOOD_AVAILABLE'] = "FOODAVAILABLE";
    })(FoodTypeEnum = FoodAmenity.FoodTypeEnum || (FoodAmenity.FoodTypeEnum = {}));
})(FoodAmenity || (FoodAmenity = {}));
/**
 * @export
 * @namespace FormOfIdentificationDetail
 */
export var FormOfIdentificationDetail;
(function (FormOfIdentificationDetail) {
    /**
     * @export
     * @enum {string}
     */
    var IdentificationTypeEnum;
    (function (IdentificationTypeEnum) {
        IdentificationTypeEnum[IdentificationTypeEnum["IdentificationRegulatoryDocuments"] = 'IdentificationRegulatoryDocuments'] = "IdentificationRegulatoryDocuments";
        IdentificationTypeEnum[IdentificationTypeEnum["IdentificationFrequentFlyerCard"] = 'IdentificationFrequentFlyerCard'] = "IdentificationFrequentFlyerCard";
        IdentificationTypeEnum[IdentificationTypeEnum["IdentificationPaymentCard"] = 'IdentificationPaymentCard'] = "IdentificationPaymentCard";
        IdentificationTypeEnum[IdentificationTypeEnum["IdentificationTicketNumber"] = 'IdentificationTicketNumber'] = "IdentificationTicketNumber";
        IdentificationTypeEnum[IdentificationTypeEnum["IdentificationConfirmationNumber"] = 'IdentificationConfirmationNumber'] = "IdentificationConfirmationNumber";
        IdentificationTypeEnum[IdentificationTypeEnum["IdentificationFromReference"] = 'IdentificationFromReference'] = "IdentificationFromReference";
    })(IdentificationTypeEnum = FormOfIdentificationDetail.IdentificationTypeEnum || (FormOfIdentificationDetail.IdentificationTypeEnum = {}));
})(FormOfIdentificationDetail || (FormOfIdentificationDetail = {}));
/**
 * @export
 * @namespace FreeFlow
 */
export var FreeFlow;
(function (FreeFlow) {
    /**
     * @export
     * @enum {string}
     */
    var PurposeEnum;
    (function (PurposeEnum) {
        PurposeEnum[PurposeEnum["Standard"] = 'standard'] = "Standard";
        PurposeEnum[PurposeEnum["Notification"] = 'notification'] = "Notification";
        PurposeEnum[PurposeEnum["Emergency"] = 'emergency'] = "Emergency";
        PurposeEnum[PurposeEnum["Information"] = 'information'] = "Information";
    })(PurposeEnum = FreeFlow.PurposeEnum || (FreeFlow.PurposeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var MaskingMethodAppliedEnum;
    (function (MaskingMethodAppliedEnum) {
        MaskingMethodAppliedEnum[MaskingMethodAppliedEnum["Masked"] = 'masked'] = "Masked";
        MaskingMethodAppliedEnum[MaskingMethodAppliedEnum["PartiallyMasked"] = 'partiallyMasked'] = "PartiallyMasked";
        MaskingMethodAppliedEnum[MaskingMethodAppliedEnum["NotMasked"] = 'notMasked'] = "NotMasked";
    })(MaskingMethodAppliedEnum = FreeFlow.MaskingMethodAppliedEnum || (FreeFlow.MaskingMethodAppliedEnum = {}));
})(FreeFlow || (FreeFlow = {}));
/**
 * @export
 * @namespace FrequentFlyerCardRequest
 */
export var FrequentFlyerCardRequest;
(function (FrequentFlyerCardRequest) {
    /**
     * @export
     * @enum {string}
     */
    var UsageEnum;
    (function (UsageEnum) {
        UsageEnum[UsageEnum["MilesAccrual"] = 'milesAccrual'] = "MilesAccrual";
        UsageEnum[UsageEnum["Servicing"] = 'servicing'] = "Servicing";
        UsageEnum[UsageEnum["Owner"] = 'owner'] = "Owner";
    })(UsageEnum = FrequentFlyerCardRequest.UsageEnum || (FrequentFlyerCardRequest.UsageEnum = {}));
})(FrequentFlyerCardRequest || (FrequentFlyerCardRequest = {}));
/**
 * @export
 * @namespace FrequentFlyerCustomerProfile
 */
export var FrequentFlyerCustomerProfile;
(function (FrequentFlyerCustomerProfile) {
    /**
     * @export
     * @enum {string}
     */
    var GenderEnum;
    (function (GenderEnum) {
        GenderEnum[GenderEnum["Male"] = 'male'] = "Male";
        GenderEnum[GenderEnum["Female"] = 'female'] = "Female";
        GenderEnum[GenderEnum["Unknown"] = 'unknown'] = "Unknown";
    })(GenderEnum = FrequentFlyerCustomerProfile.GenderEnum || (FrequentFlyerCustomerProfile.GenderEnum = {}));
})(FrequentFlyerCustomerProfile || (FrequentFlyerCustomerProfile = {}));
/**
 * @export
 * @namespace HotelPaymentPolicy
 */
export var HotelPaymentPolicy;
(function (HotelPaymentPolicy) {
    /**
     * @export
     * @enum {string}
     */
    var MethodsEnum;
    (function (MethodsEnum) {
        MethodsEnum[MethodsEnum["CREDITCARD"] = 'CREDIT_CARD'] = "CREDITCARD";
        MethodsEnum[MethodsEnum["AGENCYACCOUNT"] = 'AGENCY_ACCOUNT'] = "AGENCYACCOUNT";
        MethodsEnum[MethodsEnum["TRAVELAGENTID"] = 'TRAVEL_AGENT_ID'] = "TRAVELAGENTID";
        MethodsEnum[MethodsEnum["CORPORATEID"] = 'CORPORATE_ID'] = "CORPORATEID";
        MethodsEnum[MethodsEnum["HOTELGUESTID"] = 'HOTEL_GUEST_ID'] = "HOTELGUESTID";
        MethodsEnum[MethodsEnum["CHECK"] = 'CHECK'] = "CHECK";
        MethodsEnum[MethodsEnum["MISCCHARGEORDER"] = 'MISC_CHARGE_ORDER'] = "MISCCHARGEORDER";
        MethodsEnum[MethodsEnum["ADVANCEDEPOSIT"] = 'ADVANCE_DEPOSIT'] = "ADVANCEDEPOSIT";
        MethodsEnum[MethodsEnum["COMPANYADDRESS"] = 'COMPANY_ADDRESS'] = "COMPANYADDRESS";
    })(MethodsEnum = HotelPaymentPolicy.MethodsEnum || (HotelPaymentPolicy.MethodsEnum = {}));
})(HotelPaymentPolicy || (HotelPaymentPolicy = {}));
/**
 * @export
 * @namespace HotelRelevantCriteria
 */
export var HotelRelevantCriteria;
(function (HotelRelevantCriteria) {
    /**
     * @export
     * @enum {string}
     */
    var OrderByEnum;
    (function (OrderByEnum) {
        OrderByEnum[OrderByEnum["PriceAsc"] = 'priceAsc'] = "PriceAsc";
        OrderByEnum[OrderByEnum["PriceDesc"] = 'priceDesc'] = "PriceDesc";
        OrderByEnum[OrderByEnum["StarRatingAsc"] = 'starRatingAsc'] = "StarRatingAsc";
        OrderByEnum[OrderByEnum["StarRatingDesc"] = 'starRatingDesc'] = "StarRatingDesc";
    })(OrderByEnum = HotelRelevantCriteria.OrderByEnum || (HotelRelevantCriteria.OrderByEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var RadiusUnitEnum;
    (function (RadiusUnitEnum) {
        RadiusUnitEnum[RadiusUnitEnum["Km"] = 'km'] = "Km";
        RadiusUnitEnum[RadiusUnitEnum["Mile"] = 'mile'] = "Mile";
    })(RadiusUnitEnum = HotelRelevantCriteria.RadiusUnitEnum || (HotelRelevantCriteria.RadiusUnitEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var BoardTypeEnum;
    (function (BoardTypeEnum) {
        BoardTypeEnum[BoardTypeEnum["ROOMONLY"] = 'ROOM_ONLY'] = "ROOMONLY";
        BoardTypeEnum[BoardTypeEnum["BREAKFAST"] = 'BREAKFAST'] = "BREAKFAST";
        BoardTypeEnum[BoardTypeEnum["HALFBOARD"] = 'HALF_BOARD'] = "HALFBOARD";
        BoardTypeEnum[BoardTypeEnum["FULLBOARD"] = 'FULL_BOARD'] = "FULLBOARD";
        BoardTypeEnum[BoardTypeEnum["ALLINCLUSIVE"] = 'ALL_INCLUSIVE'] = "ALLINCLUSIVE";
    })(BoardTypeEnum = HotelRelevantCriteria.BoardTypeEnum || (HotelRelevantCriteria.BoardTypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var AmenitiesEnum;
    (function (AmenitiesEnum) {
        AmenitiesEnum[AmenitiesEnum["SWIMMINGPOOL"] = 'SWIMMING_POOL'] = "SWIMMINGPOOL";
        AmenitiesEnum[AmenitiesEnum["RESTAURANT"] = 'RESTAURANT'] = "RESTAURANT";
        AmenitiesEnum[AmenitiesEnum["SPA"] = 'SPA'] = "SPA";
        AmenitiesEnum[AmenitiesEnum["PARKING"] = 'PARKING'] = "PARKING";
        AmenitiesEnum[AmenitiesEnum["FITNESSCENTER"] = 'FITNESS_CENTER'] = "FITNESSCENTER";
        AmenitiesEnum[AmenitiesEnum["AIRCONDITIONING"] = 'AIR_CONDITIONING'] = "AIRCONDITIONING";
        AmenitiesEnum[AmenitiesEnum["AIRPORTSHUTTLE"] = 'AIRPORT_SHUTTLE'] = "AIRPORTSHUTTLE";
        AmenitiesEnum[AmenitiesEnum["PETSALLOWED"] = 'PETS_ALLOWED'] = "PETSALLOWED";
        AmenitiesEnum[AmenitiesEnum["BUSINESSCENTER"] = 'BUSINESS_CENTER'] = "BUSINESSCENTER";
        AmenitiesEnum[AmenitiesEnum["DISABLEDFACILITIES"] = 'DISABLED_FACILITIES'] = "DISABLEDFACILITIES";
        AmenitiesEnum[AmenitiesEnum["WIFI"] = 'WIFI'] = "WIFI";
    })(AmenitiesEnum = HotelRelevantCriteria.AmenitiesEnum || (HotelRelevantCriteria.AmenitiesEnum = {}));
})(HotelRelevantCriteria || (HotelRelevantCriteria = {}));
/**
 * @export
 * @namespace HttpRequest
 */
export var HttpRequest;
(function (HttpRequest) {
    /**
     * @export
     * @enum {string}
     */
    var MethodsEnum;
    (function (MethodsEnum) {
        MethodsEnum[MethodsEnum["GET"] = 'GET'] = "GET";
        MethodsEnum[MethodsEnum["POST"] = 'POST'] = "POST";
        MethodsEnum[MethodsEnum["PUT"] = 'PUT'] = "PUT";
        MethodsEnum[MethodsEnum["PATCH"] = 'PATCH'] = "PATCH";
        MethodsEnum[MethodsEnum["DELETE"] = 'DELETE'] = "DELETE";
    })(MethodsEnum = HttpRequest.MethodsEnum || (HttpRequest.MethodsEnum = {}));
})(HttpRequest || (HttpRequest = {}));
/**
 * @export
 * @namespace Individual
 */
export var Individual;
(function (Individual) {
    /**
     * @export
     * @enum {string}
     */
    var GenderEnum;
    (function (GenderEnum) {
        GenderEnum[GenderEnum["Male"] = 'male'] = "Male";
        GenderEnum[GenderEnum["Female"] = 'female'] = "Female";
        GenderEnum[GenderEnum["Unspecified"] = 'unspecified'] = "Unspecified";
        GenderEnum[GenderEnum["Unknown"] = 'unknown'] = "Unknown";
    })(GenderEnum = Individual.GenderEnum || (Individual.GenderEnum = {}));
})(Individual || (Individual = {}));
/**
 * @export
 * @namespace InsuranceDetail
 */
export var InsuranceDetail;
(function (InsuranceDetail) {
    /**
     * @export
     * @enum {string}
     */
    var TypeEnum;
    (function (TypeEnum) {
        TypeEnum[TypeEnum["Text"] = 'text'] = "Text";
        TypeEnum[TypeEnum["Url"] = 'url'] = "Url";
    })(TypeEnum = InsuranceDetail.TypeEnum || (InsuranceDetail.TypeEnum = {}));
})(InsuranceDetail || (InsuranceDetail = {}));
/**
 * @export
 * @namespace ItineraryByOffer
 */
export var ItineraryByOffer;
(function (ItineraryByOffer) {
    /**
     * @export
     * @enum {string}
     */
    var OriginLocationTypeEnum;
    (function (OriginLocationTypeEnum) {
        OriginLocationTypeEnum[OriginLocationTypeEnum["Airport"] = 'airport'] = "Airport";
        OriginLocationTypeEnum[OriginLocationTypeEnum["City"] = 'city'] = "City";
    })(OriginLocationTypeEnum = ItineraryByOffer.OriginLocationTypeEnum || (ItineraryByOffer.OriginLocationTypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var DestinationLocationTypeEnum;
    (function (DestinationLocationTypeEnum) {
        DestinationLocationTypeEnum[DestinationLocationTypeEnum["Airport"] = 'airport'] = "Airport";
        DestinationLocationTypeEnum[DestinationLocationTypeEnum["City"] = 'city'] = "City";
    })(DestinationLocationTypeEnum = ItineraryByOffer.DestinationLocationTypeEnum || (ItineraryByOffer.DestinationLocationTypeEnum = {}));
})(ItineraryByOffer || (ItineraryByOffer = {}));
/**
 * @export
 * @namespace Journey
 */
export var Journey;
(function (Journey) {
    /**
     * @export
     * @enum {string}
     */
    var TypeEnum;
    (function (TypeEnum) {
        TypeEnum[TypeEnum["Standalone"] = 'standalone'] = "Standalone";
        TypeEnum[TypeEnum["Outbound"] = 'outbound'] = "Outbound";
        TypeEnum[TypeEnum["Inbound"] = 'inbound'] = "Inbound";
    })(TypeEnum = Journey.TypeEnum || (Journey.TypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var TripTypeEnum;
    (function (TripTypeEnum) {
        TripTypeEnum[TripTypeEnum["ROUNDTRIP"] = 'ROUNDTRIP'] = "ROUNDTRIP";
        TripTypeEnum[TripTypeEnum["ONEWAY"] = 'ONEWAY'] = "ONEWAY";
    })(TripTypeEnum = Journey.TripTypeEnum || (Journey.TripTypeEnum = {}));
})(Journey || (Journey = {}));
/**
 * @export
 * @namespace JourneyAlternativeFlightOffer
 */
export var JourneyAlternativeFlightOffer;
(function (JourneyAlternativeFlightOffer) {
    /**
     * @export
     * @enum {string}
     */
    var OfferTypeEnum;
    (function (OfferTypeEnum) {
        OfferTypeEnum[OfferTypeEnum["StandbyEarly"] = 'standbyEarly'] = "StandbyEarly";
        OfferTypeEnum[OfferTypeEnum["SameDayChange"] = 'sameDayChange'] = "SameDayChange";
    })(OfferTypeEnum = JourneyAlternativeFlightOffer.OfferTypeEnum || (JourneyAlternativeFlightOffer.OfferTypeEnum = {}));
})(JourneyAlternativeFlightOffer || (JourneyAlternativeFlightOffer = {}));
/**
 * @export
 * @namespace JourneyDisruption
 */
export var JourneyDisruption;
(function (JourneyDisruption) {
    /**
     * @export
     * @enum {string}
     */
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["IsDisrupted"] = 'isDisrupted'] = "IsDisrupted";
        StatusEnum[StatusEnum["WasDisrupted"] = 'wasDisrupted'] = "WasDisrupted";
    })(StatusEnum = JourneyDisruption.StatusEnum || (JourneyDisruption.StatusEnum = {}));
})(JourneyDisruption || (JourneyDisruption = {}));
/**
 * @export
 * @namespace JourneyElement
 */
export var JourneyElement;
(function (JourneyElement) {
    /**
     * @export
     * @enum {string}
     */
    var CheckInStatusEnum;
    (function (CheckInStatusEnum) {
        CheckInStatusEnum[CheckInStatusEnum["Accepted"] = 'accepted'] = "Accepted";
        CheckInStatusEnum[CheckInStatusEnum["StandBy"] = 'standBy'] = "StandBy";
        CheckInStatusEnum[CheckInStatusEnum["NotAccepted"] = 'notAccepted'] = "NotAccepted";
        CheckInStatusEnum[CheckInStatusEnum["Rejected"] = 'rejected'] = "Rejected";
    })(CheckInStatusEnum = JourneyElement.CheckInStatusEnum || (JourneyElement.CheckInStatusEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var BoardingPassPrintStatusEnum;
    (function (BoardingPassPrintStatusEnum) {
        BoardingPassPrintStatusEnum[BoardingPassPrintStatusEnum["NotPrinted"] = 'notPrinted'] = "NotPrinted";
        BoardingPassPrintStatusEnum[BoardingPassPrintStatusEnum["Printed"] = 'printed'] = "Printed";
        BoardingPassPrintStatusEnum[BoardingPassPrintStatusEnum["NeedPrinting"] = 'needPrinting'] = "NeedPrinting";
    })(BoardingPassPrintStatusEnum = JourneyElement.BoardingPassPrintStatusEnum || (JourneyElement.BoardingPassPrintStatusEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var BoardingStatusEnum;
    (function (BoardingStatusEnum) {
        BoardingStatusEnum[BoardingStatusEnum["NotBoarded"] = 'notBoarded'] = "NotBoarded";
        BoardingStatusEnum[BoardingStatusEnum["Boarded"] = 'boarded'] = "Boarded";
        BoardingStatusEnum[BoardingStatusEnum["Unknown"] = 'unknown'] = "Unknown";
    })(BoardingStatusEnum = JourneyElement.BoardingStatusEnum || (JourneyElement.BoardingStatusEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var ExitSeatSuitabilityEnum;
    (function (ExitSeatSuitabilityEnum) {
        ExitSeatSuitabilityEnum[ExitSeatSuitabilityEnum["Suitable"] = 'suitable'] = "Suitable";
        ExitSeatSuitabilityEnum[ExitSeatSuitabilityEnum["NotSuitable"] = 'notSuitable'] = "NotSuitable";
        ExitSeatSuitabilityEnum[ExitSeatSuitabilityEnum["UnableToDetermine"] = 'unableToDetermine'] = "UnableToDetermine";
    })(ExitSeatSuitabilityEnum = JourneyElement.ExitSeatSuitabilityEnum || (JourneyElement.ExitSeatSuitabilityEnum = {}));
})(JourneyElement || (JourneyElement = {}));
/**
 * @export
 * @namespace JourneyElementUpgrade
 */
export var JourneyElementUpgrade;
(function (JourneyElementUpgrade) {
    /**
     * @export
     * @enum {string}
     */
    var UpgradeTypeEnum;
    (function (UpgradeTypeEnum) {
        UpgradeTypeEnum[UpgradeTypeEnum["PaidUpgrade"] = 'paidUpgrade'] = "PaidUpgrade";
        UpgradeTypeEnum[UpgradeTypeEnum["MilesUpgrade"] = 'milesUpgrade'] = "MilesUpgrade";
        UpgradeTypeEnum[UpgradeTypeEnum["CreditsUpgrade"] = 'creditsUpgrade'] = "CreditsUpgrade";
    })(UpgradeTypeEnum = JourneyElementUpgrade.UpgradeTypeEnum || (JourneyElementUpgrade.UpgradeTypeEnum = {}));
})(JourneyElementUpgrade || (JourneyElementUpgrade = {}));
/**
 * @export
 * @namespace JourneyPaymentAuthorizationReplyData
 */
export var JourneyPaymentAuthorizationReplyData;
(function (JourneyPaymentAuthorizationReplyData) {
    /**
     * @export
     * @enum {string}
     */
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["Ok"] = 'ok'] = "Ok";
        StatusEnum[StatusEnum["Ko"] = 'ko'] = "Ko";
        StatusEnum[StatusEnum["Pending3DSecure"] = 'pending3DSecure'] = "Pending3DSecure";
    })(StatusEnum = JourneyPaymentAuthorizationReplyData.StatusEnum || (JourneyPaymentAuthorizationReplyData.StatusEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var PaymentActionEnum;
    (function (PaymentActionEnum) {
        PaymentActionEnum[PaymentActionEnum["Confirm"] = 'confirm'] = "Confirm";
        PaymentActionEnum[PaymentActionEnum["Redirect"] = 'redirect'] = "Redirect";
        PaymentActionEnum[PaymentActionEnum["Error"] = 'error'] = "Error";
        PaymentActionEnum[PaymentActionEnum["MopSelection"] = 'mopSelection'] = "MopSelection";
    })(PaymentActionEnum = JourneyPaymentAuthorizationReplyData.PaymentActionEnum || (JourneyPaymentAuthorizationReplyData.PaymentActionEnum = {}));
})(JourneyPaymentAuthorizationReplyData || (JourneyPaymentAuthorizationReplyData = {}));
/**
 * @export
 * @namespace JourneyPaymentAuthorizationRequest
 */
export var JourneyPaymentAuthorizationRequest;
(function (JourneyPaymentAuthorizationRequest) {
    /**
     * @export
     * @enum {string}
     */
    var PaymentActionEnum;
    (function (PaymentActionEnum) {
        PaymentActionEnum[PaymentActionEnum["Add"] = 'add'] = "Add";
    })(PaymentActionEnum = JourneyPaymentAuthorizationRequest.PaymentActionEnum || (JourneyPaymentAuthorizationRequest.PaymentActionEnum = {}));
})(JourneyPaymentAuthorizationRequest || (JourneyPaymentAuthorizationRequest = {}));
/**
 * @export
 * @namespace JourneyPaymentRequest
 */
export var JourneyPaymentRequest;
(function (JourneyPaymentRequest) {
    /**
     * @export
     * @enum {string}
     */
    var PaymentOperationTypeEnum;
    (function (PaymentOperationTypeEnum) {
        PaymentOperationTypeEnum[PaymentOperationTypeEnum["Services"] = 'services'] = "Services";
        PaymentOperationTypeEnum[PaymentOperationTypeEnum["Upgrade"] = 'upgrade'] = "Upgrade";
        PaymentOperationTypeEnum[PaymentOperationTypeEnum["StandbyEarly"] = 'standbyEarly'] = "StandbyEarly";
        PaymentOperationTypeEnum[PaymentOperationTypeEnum["SameDayChange"] = 'sameDayChange'] = "SameDayChange";
    })(PaymentOperationTypeEnum = JourneyPaymentRequest.PaymentOperationTypeEnum || (JourneyPaymentRequest.PaymentOperationTypeEnum = {}));
})(JourneyPaymentRequest || (JourneyPaymentRequest = {}));
/**
 * @export
 * @namespace JourneyRequest
 */
export var JourneyRequest;
(function (JourneyRequest) {
    /**
     * @export
     * @enum {string}
     */
    var DocumentTypeEnum;
    (function (DocumentTypeEnum) {
        DocumentTypeEnum[DocumentTypeEnum["Passport"] = 'passport'] = "Passport";
        DocumentTypeEnum[DocumentTypeEnum["IdentityCard"] = 'identityCard'] = "IdentityCard";
        DocumentTypeEnum[DocumentTypeEnum["DrivingLicense"] = 'drivingLicense'] = "DrivingLicense";
    })(DocumentTypeEnum = JourneyRequest.DocumentTypeEnum || (JourneyRequest.DocumentTypeEnum = {}));
})(JourneyRequest || (JourneyRequest = {}));
/**
 * @export
 * @namespace JourneySeatSelection
 */
export var JourneySeatSelection;
(function (JourneySeatSelection) {
    /**
     * @export
     * @enum {string}
     */
    var ExitSeatSuitabilityEnum;
    (function (ExitSeatSuitabilityEnum) {
        ExitSeatSuitabilityEnum[ExitSeatSuitabilityEnum["Suitable"] = 'suitable'] = "Suitable";
        ExitSeatSuitabilityEnum[ExitSeatSuitabilityEnum["NotSuitable"] = 'notSuitable'] = "NotSuitable";
        ExitSeatSuitabilityEnum[ExitSeatSuitabilityEnum["UnableToDetermine"] = 'unableToDetermine'] = "UnableToDetermine";
    })(ExitSeatSuitabilityEnum = JourneySeatSelection.ExitSeatSuitabilityEnum || (JourneySeatSelection.ExitSeatSuitabilityEnum = {}));
})(JourneySeatSelection || (JourneySeatSelection = {}));
/**
 * @export
 * @namespace JourneyTraveler
 */
export var JourneyTraveler;
(function (JourneyTraveler) {
    /**
     * @export
     * @enum {string}
     */
    var PurposeOfVisitEnum;
    (function (PurposeOfVisitEnum) {
        PurposeOfVisitEnum[PurposeOfVisitEnum["Hajj"] = 'hajj'] = "Hajj";
        PurposeOfVisitEnum[PurposeOfVisitEnum["Umrah"] = 'umrah'] = "Umrah";
    })(PurposeOfVisitEnum = JourneyTraveler.PurposeOfVisitEnum || (JourneyTraveler.PurposeOfVisitEnum = {}));
})(JourneyTraveler || (JourneyTraveler = {}));
/**
 * @export
 * @namespace JourneyTravelerPatchRequest
 */
export var JourneyTravelerPatchRequest;
(function (JourneyTravelerPatchRequest) {
    /**
     * @export
     * @enum {string}
     */
    var PurposeOfVisitEnum;
    (function (PurposeOfVisitEnum) {
        PurposeOfVisitEnum[PurposeOfVisitEnum["Hajj"] = 'hajj'] = "Hajj";
        PurposeOfVisitEnum[PurposeOfVisitEnum["Umrah"] = 'umrah'] = "Umrah";
    })(PurposeOfVisitEnum = JourneyTravelerPatchRequest.PurposeOfVisitEnum || (JourneyTravelerPatchRequest.PurposeOfVisitEnum = {}));
})(JourneyTravelerPatchRequest || (JourneyTravelerPatchRequest = {}));
/**
 * @export
 * @namespace JourneyUnpaidBaggageItem
 */
export var JourneyUnpaidBaggageItem;
(function (JourneyUnpaidBaggageItem) {
    /**
     * @export
     * @enum {string}
     */
    var QuantityUnitEnum;
    (function (QuantityUnitEnum) {
        QuantityUnitEnum[QuantityUnitEnum["Pieces"] = 'pieces'] = "Pieces";
        QuantityUnitEnum[QuantityUnitEnum["Kg"] = 'kg'] = "Kg";
    })(QuantityUnitEnum = JourneyUnpaidBaggageItem.QuantityUnitEnum || (JourneyUnpaidBaggageItem.QuantityUnitEnum = {}));
})(JourneyUnpaidBaggageItem || (JourneyUnpaidBaggageItem = {}));
/**
 * @export
 * @namespace LocalizationParameter
 */
export var LocalizationParameter;
(function (LocalizationParameter) {
    /**
     * @export
     * @enum {string}
     */
    var TemplateTypeEnum;
    (function (TemplateTypeEnum) {
        TemplateTypeEnum[TemplateTypeEnum["DateTemplateParameter"] = 'DateTemplateParameter'] = "DateTemplateParameter";
        TemplateTypeEnum[TemplateTypeEnum["DateTimeTemplateParameter"] = 'DateTimeTemplateParameter'] = "DateTimeTemplateParameter";
        TemplateTypeEnum[TemplateTypeEnum["AmountTemplateParameter"] = 'AmountTemplateParameter'] = "AmountTemplateParameter";
        TemplateTypeEnum[TemplateTypeEnum["BooleanTemplateParameter"] = 'BooleanTemplateParameter'] = "BooleanTemplateParameter";
        TemplateTypeEnum[TemplateTypeEnum["LocationCodeTemplateParameter"] = 'LocationCodeTemplateParameter'] = "LocationCodeTemplateParameter";
    })(TemplateTypeEnum = LocalizationParameter.TemplateTypeEnum || (LocalizationParameter.TemplateTypeEnum = {}));
})(LocalizationParameter || (LocalizationParameter = {}));
/**
 * @export
 * @namespace LocationDictionaryItem
 */
export var LocationDictionaryItem;
(function (LocationDictionaryItem) {
    /**
     * @export
     * @enum {string}
     */
    var TypeEnum;
    (function (TypeEnum) {
        TypeEnum[TypeEnum["Airport"] = 'airport'] = "Airport";
        TypeEnum[TypeEnum["City"] = 'city'] = "City";
        TypeEnum[TypeEnum["State"] = 'state'] = "State";
    })(TypeEnum = LocationDictionaryItem.TypeEnum || (LocationDictionaryItem.TypeEnum = {}));
})(LocationDictionaryItem || (LocationDictionaryItem = {}));
/**
 * @export
 * @namespace LoyaltyAward
 */
export var LoyaltyAward;
(function (LoyaltyAward) {
    /**
     * @export
     * @enum {string}
     */
    var LoyaltyAwardTypeEnum;
    (function (LoyaltyAwardTypeEnum) {
        LoyaltyAwardTypeEnum[LoyaltyAwardTypeEnum["BASE"] = 'BASE'] = "BASE";
        LoyaltyAwardTypeEnum[LoyaltyAwardTypeEnum["BONUS"] = 'BONUS'] = "BONUS";
    })(LoyaltyAwardTypeEnum = LoyaltyAward.LoyaltyAwardTypeEnum || (LoyaltyAward.LoyaltyAwardTypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var CategoryEnum;
    (function (CategoryEnum) {
        CategoryEnum[CategoryEnum["STANDARD"] = 'STANDARD'] = "STANDARD";
        CategoryEnum[CategoryEnum["TIER"] = 'TIER'] = "TIER";
        CategoryEnum[CategoryEnum["BENEFIT"] = 'BENEFIT'] = "BENEFIT";
    })(CategoryEnum = LoyaltyAward.CategoryEnum || (LoyaltyAward.CategoryEnum = {}));
})(LoyaltyAward || (LoyaltyAward = {}));
/**
 * @export
 * @namespace LoyaltyNumbersItem
 */
export var LoyaltyNumbersItem;
(function (LoyaltyNumbersItem) {
    /**
     * @export
     * @enum {string}
     */
    var LoyaltyCodeEnum;
    (function (LoyaltyCodeEnum) {
        LoyaltyCodeEnum[LoyaltyCodeEnum["CD"] = 'CD'] = "CD";
        LoyaltyCodeEnum[LoyaltyCodeEnum["PC"] = 'PC'] = "PC";
        LoyaltyCodeEnum[LoyaltyCodeEnum["NIL"] = 'NIL'] = "NIL";
        LoyaltyCodeEnum[LoyaltyCodeEnum["ID"] = 'ID'] = "ID";
        LoyaltyCodeEnum[LoyaltyCodeEnum["IT"] = 'IT'] = "IT";
        LoyaltyCodeEnum[LoyaltyCodeEnum["FT"] = 'FT'] = "FT";
        LoyaltyCodeEnum[LoyaltyCodeEnum["RC"] = 'RC'] = "RC";
    })(LoyaltyCodeEnum = LoyaltyNumbersItem.LoyaltyCodeEnum || (LoyaltyNumbersItem.LoyaltyCodeEnum = {}));
})(LoyaltyNumbersItem || (LoyaltyNumbersItem = {}));
/**
 * @export
 * @namespace ManualPriceTax
 */
export var ManualPriceTax;
(function (ManualPriceTax) {
    /**
     * @export
     * @enum {string}
     */
    var CategoryEnum;
    (function (CategoryEnum) {
        CategoryEnum[CategoryEnum["TAXNEW"] = 'TAXNEW'] = "TAXNEW";
    })(CategoryEnum = ManualPriceTax.CategoryEnum || (ManualPriceTax.CategoryEnum = {}));
})(ManualPriceTax || (ManualPriceTax = {}));
/**
 * @export
 * @namespace ManualServiceQuotationRecord
 */
export var ManualServiceQuotationRecord;
(function (ManualServiceQuotationRecord) {
    /**
     * @export
     * @enum {string}
     */
    var InternationaIndicatorEnum;
    (function (InternationaIndicatorEnum) {
        InternationaIndicatorEnum[InternationaIndicatorEnum["DOMESTIC"] = 'DOMESTIC'] = "DOMESTIC";
        InternationaIndicatorEnum[InternationaIndicatorEnum["INTERNATIONAL"] = 'INTERNATIONAL'] = "INTERNATIONAL";
    })(InternationaIndicatorEnum = ManualServiceQuotationRecord.InternationaIndicatorEnum || (ManualServiceQuotationRecord.InternationaIndicatorEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var IssueIdentifierEnum;
    (function (IssueIdentifierEnum) {
        IssueIdentifierEnum[IssueIdentifierEnum["FIRTSTISSUE"] = 'FIRTSTISSUE'] = "FIRTSTISSUE";
        IssueIdentifierEnum[IssueIdentifierEnum["TOTALDOC"] = 'TOTALDOC'] = "TOTALDOC";
    })(IssueIdentifierEnum = ManualServiceQuotationRecord.IssueIdentifierEnum || (ManualServiceQuotationRecord.IssueIdentifierEnum = {}));
})(ManualServiceQuotationRecord || (ManualServiceQuotationRecord = {}));
/**
 * @export
 * @namespace Mileage
 */
export var Mileage;
(function (Mileage) {
    /**
     * @export
     * @enum {string}
     */
    var DistanceUnitEnum;
    (function (DistanceUnitEnum) {
        DistanceUnitEnum[DistanceUnitEnum["Km"] = 'km'] = "Km";
        DistanceUnitEnum[DistanceUnitEnum["Miles"] = 'miles'] = "Miles";
    })(DistanceUnitEnum = Mileage.DistanceUnitEnum || (Mileage.DistanceUnitEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var MileageTimeWindowEnum;
    (function (MileageTimeWindowEnum) {
        MileageTimeWindowEnum[MileageTimeWindowEnum["Daily"] = 'daily'] = "Daily";
        MileageTimeWindowEnum[MileageTimeWindowEnum["Monthly"] = 'monthly'] = "Monthly";
        MileageTimeWindowEnum[MileageTimeWindowEnum["Weekly"] = 'weekly'] = "Weekly";
        MileageTimeWindowEnum[MileageTimeWindowEnum["FullPeriod"] = 'fullPeriod'] = "FullPeriod";
    })(MileageTimeWindowEnum = Mileage.MileageTimeWindowEnum || (Mileage.MileageTimeWindowEnum = {}));
})(Mileage || (Mileage = {}));
/**
 * @export
 * @namespace Name
 */
export var Name;
(function (Name) {
    /**
     * @export
     * @enum {string}
     */
    var NameTypeEnum;
    (function (NameTypeEnum) {
        NameTypeEnum[NameTypeEnum["Universal"] = 'universal'] = "Universal";
        NameTypeEnum[NameTypeEnum["Native"] = 'native'] = "Native";
        NameTypeEnum[NameTypeEnum["Romanized"] = 'romanized'] = "Romanized";
    })(NameTypeEnum = Name.NameTypeEnum || (Name.NameTypeEnum = {}));
})(Name || (Name = {}));
/**
 * @export
 * @namespace NameRegulatory
 */
export var NameRegulatory;
(function (NameRegulatory) {
    /**
     * @export
     * @enum {string}
     */
    var NameTypeEnum;
    (function (NameTypeEnum) {
        NameTypeEnum[NameTypeEnum["Universal"] = 'universal'] = "Universal";
        NameTypeEnum[NameTypeEnum["Native"] = 'native'] = "Native";
        NameTypeEnum[NameTypeEnum["Romanized"] = 'romanized'] = "Romanized";
    })(NameTypeEnum = NameRegulatory.NameTypeEnum || (NameRegulatory.NameTypeEnum = {}));
})(NameRegulatory || (NameRegulatory = {}));
/**
 * @export
 * @namespace NotificationIdentity
 */
export var NotificationIdentity;
(function (NotificationIdentity) {
    /**
     * @export
     * @enum {string}
     */
    var ContentTypeEnum;
    (function (ContentTypeEnum) {
        ContentTypeEnum[ContentTypeEnum["TravelDocumentReceipt"] = 'travelDocumentReceipt'] = "TravelDocumentReceipt";
        ContentTypeEnum[ContentTypeEnum["Itinerary"] = 'itinerary'] = "Itinerary";
        ContentTypeEnum[ContentTypeEnum["Invoice"] = 'invoice'] = "Invoice";
    })(ContentTypeEnum = NotificationIdentity.ContentTypeEnum || (NotificationIdentity.ContentTypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var FormatEnum;
    (function (FormatEnum) {
        FormatEnum[FormatEnum["Email"] = 'email'] = "Email";
        FormatEnum[FormatEnum["Link"] = 'link'] = "Link";
    })(FormatEnum = NotificationIdentity.FormatEnum || (NotificationIdentity.FormatEnum = {}));
})(NotificationIdentity || (NotificationIdentity = {}));
/**
 * @export
 * @namespace NotificationResult
 */
export var NotificationResult;
(function (NotificationResult) {
    /**
     * @export
     * @enum {string}
     */
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["Sent"] = 'sent'] = "Sent";
        StatusEnum[StatusEnum["Created"] = 'created'] = "Created";
        StatusEnum[StatusEnum["Error"] = 'error'] = "Error";
    })(StatusEnum = NotificationResult.StatusEnum || (NotificationResult.StatusEnum = {}));
})(NotificationResult || (NotificationResult = {}));
/**
 * @export
 * @namespace OpeningHours
 */
export var OpeningHours;
(function (OpeningHours) {
    /**
     * @export
     * @enum {string}
     */
    var TimeModeEnum;
    (function (TimeModeEnum) {
        TimeModeEnum[TimeModeEnum["PickUpTime"] = 'pickUpTime'] = "PickUpTime";
        TimeModeEnum[TimeModeEnum["LocalTime"] = 'localTime'] = "LocalTime";
        TimeModeEnum[TimeModeEnum["DropOffTime"] = 'dropOffTime'] = "DropOffTime";
    })(TimeModeEnum = OpeningHours.TimeModeEnum || (OpeningHours.TimeModeEnum = {}));
})(OpeningHours || (OpeningHours = {}));
/**
 * @export
 * @namespace Order
 */
export var Order;
(function (Order) {
    /**
     * @export
     * @enum {string}
     */
    var TagsEnum;
    (function (TagsEnum) {
        TagsEnum[TagsEnum["Domestic"] = 'domestic'] = "Domestic";
        TagsEnum[TagsEnum["International"] = 'international'] = "International";
    })(TagsEnum = Order.TagsEnum || (Order.TagsEnum = {}));
})(Order || (Order = {}));
/**
 * @export
 * @namespace OrderAppliedRefundOptionsItem
 */
export var OrderAppliedRefundOptionsItem;
(function (OrderAppliedRefundOptionsItem) {
    /**
     * @export
     * @enum {string}
     */
    var DocumentTypeEnum;
    (function (DocumentTypeEnum) {
        DocumentTypeEnum[DocumentTypeEnum["Eticket"] = 'eticket'] = "Eticket";
        DocumentTypeEnum[DocumentTypeEnum["Services"] = 'services'] = "Services";
        DocumentTypeEnum[DocumentTypeEnum["Hotel"] = 'hotel'] = "Hotel";
    })(DocumentTypeEnum = OrderAppliedRefundOptionsItem.DocumentTypeEnum || (OrderAppliedRefundOptionsItem.DocumentTypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["Refunded"] = 'refunded'] = "Refunded";
        StatusEnum[StatusEnum["PendingManualRefund"] = 'pendingManualRefund'] = "PendingManualRefund";
        StatusEnum[StatusEnum["NotRefundable"] = 'notRefundable'] = "NotRefundable";
        StatusEnum[StatusEnum["Refundable"] = 'refundable'] = "Refundable";
    })(StatusEnum = OrderAppliedRefundOptionsItem.StatusEnum || (OrderAppliedRefundOptionsItem.StatusEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var RefundTypeEnum;
    (function (RefundTypeEnum) {
        RefundTypeEnum[RefundTypeEnum["Involuntary"] = 'involuntary'] = "Involuntary";
    })(RefundTypeEnum = OrderAppliedRefundOptionsItem.RefundTypeEnum || (OrderAppliedRefundOptionsItem.RefundTypeEnum = {}));
})(OrderAppliedRefundOptionsItem || (OrderAppliedRefundOptionsItem = {}));
/**
 * @export
 * @namespace OrderCancelAndRefundEligibility
 */
export var OrderCancelAndRefundEligibility;
(function (OrderCancelAndRefundEligibility) {
    /**
     * @export
     * @enum {string}
     */
    var RefundStatusEnum;
    (function (RefundStatusEnum) {
        RefundStatusEnum[RefundStatusEnum["Refundable"] = 'refundable'] = "Refundable";
        RefundStatusEnum[RefundStatusEnum["NotRefundable"] = 'notRefundable'] = "NotRefundable";
        RefundStatusEnum[RefundStatusEnum["ManuallyRefundable"] = 'manuallyRefundable'] = "ManuallyRefundable";
    })(RefundStatusEnum = OrderCancelAndRefundEligibility.RefundStatusEnum || (OrderCancelAndRefundEligibility.RefundStatusEnum = {}));
})(OrderCancelAndRefundEligibility || (OrderCancelAndRefundEligibility = {}));
/**
 * @export
 * @namespace OrderCommon
 */
export var OrderCommon;
(function (OrderCommon) {
    /**
     * @export
     * @enum {string}
     */
    var TagsEnum;
    (function (TagsEnum) {
        TagsEnum[TagsEnum["Domestic"] = 'domestic'] = "Domestic";
        TagsEnum[TagsEnum["International"] = 'international'] = "International";
    })(TagsEnum = OrderCommon.TagsEnum || (OrderCommon.TagsEnum = {}));
})(OrderCommon || (OrderCommon = {}));
/**
 * @export
 * @namespace OrderMiscellaneousAncillaryItem
 */
export var OrderMiscellaneousAncillaryItem;
(function (OrderMiscellaneousAncillaryItem) {
    /**
     * @export
     * @enum {string}
     */
    var TypeEnum;
    (function (TypeEnum) {
        TypeEnum[TypeEnum["Penalty"] = 'penalty'] = "Penalty";
        TypeEnum[TypeEnum["RefundBalance"] = 'refundBalance'] = "RefundBalance";
    })(TypeEnum = OrderMiscellaneousAncillaryItem.TypeEnum || (OrderMiscellaneousAncillaryItem.TypeEnum = {}));
})(OrderMiscellaneousAncillaryItem || (OrderMiscellaneousAncillaryItem = {}));
/**
 * @export
 * @namespace OrderRefundEventLog
 */
export var OrderRefundEventLog;
(function (OrderRefundEventLog) {
    /**
     * @export
     * @enum {string}
     */
    var TriggerEventNameEnum;
    (function (TriggerEventNameEnum) {
        TriggerEventNameEnum[TriggerEventNameEnum["Sent"] = 'sent'] = "Sent";
    })(TriggerEventNameEnum = OrderRefundEventLog.TriggerEventNameEnum || (OrderRefundEventLog.TriggerEventNameEnum = {}));
})(OrderRefundEventLog || (OrderRefundEventLog = {}));
/**
 * @export
 * @namespace OrderRefundOptionsItem
 */
export var OrderRefundOptionsItem;
(function (OrderRefundOptionsItem) {
    /**
     * @export
     * @enum {string}
     */
    var DocumentTypeEnum;
    (function (DocumentTypeEnum) {
        DocumentTypeEnum[DocumentTypeEnum["Eticket"] = 'eticket'] = "Eticket";
        DocumentTypeEnum[DocumentTypeEnum["Services"] = 'services'] = "Services";
        DocumentTypeEnum[DocumentTypeEnum["Hotel"] = 'hotel'] = "Hotel";
    })(DocumentTypeEnum = OrderRefundOptionsItem.DocumentTypeEnum || (OrderRefundOptionsItem.DocumentTypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["Refundable"] = 'refundable'] = "Refundable";
        StatusEnum[StatusEnum["NotRefundable"] = 'notRefundable'] = "NotRefundable";
        StatusEnum[StatusEnum["ManuallyRefundable"] = 'manuallyRefundable'] = "ManuallyRefundable";
        StatusEnum[StatusEnum["Unavailable"] = 'unavailable'] = "Unavailable";
    })(StatusEnum = OrderRefundOptionsItem.StatusEnum || (OrderRefundOptionsItem.StatusEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var RefundTypeEnum;
    (function (RefundTypeEnum) {
        RefundTypeEnum[RefundTypeEnum["Involuntary"] = 'involuntary'] = "Involuntary";
    })(RefundTypeEnum = OrderRefundOptionsItem.RefundTypeEnum || (OrderRefundOptionsItem.RefundTypeEnum = {}));
})(OrderRefundOptionsItem || (OrderRefundOptionsItem = {}));
/**
 * @export
 * @namespace OriginalTravelDocument
 */
export var OriginalTravelDocument;
(function (OriginalTravelDocument) {
    /**
     * @export
     * @enum {string}
     */
    var DocumentTypeEnum;
    (function (DocumentTypeEnum) {
        DocumentTypeEnum[DocumentTypeEnum["Eticket"] = 'eticket'] = "Eticket";
        DocumentTypeEnum[DocumentTypeEnum["Services"] = 'services'] = "Services";
        DocumentTypeEnum[DocumentTypeEnum["Insurance"] = 'insurance'] = "Insurance";
        DocumentTypeEnum[DocumentTypeEnum["Hotel"] = 'hotel'] = "Hotel";
    })(DocumentTypeEnum = OriginalTravelDocument.DocumentTypeEnum || (OriginalTravelDocument.DocumentTypeEnum = {}));
})(OriginalTravelDocument || (OriginalTravelDocument = {}));
/**
 * @export
 * @namespace PayerIdentification
 */
export var PayerIdentification;
(function (PayerIdentification) {
    /**
     * @export
     * @enum {string}
     */
    var ChannelEnum;
    (function (ChannelEnum) {
        ChannelEnum[ChannelEnum["Desktop"] = 'desktop'] = "Desktop";
        ChannelEnum[ChannelEnum["Mobile"] = 'mobile'] = "Mobile";
        ChannelEnum[ChannelEnum["Tablet"] = 'tablet'] = "Tablet";
    })(ChannelEnum = PayerIdentification.ChannelEnum || (PayerIdentification.ChannelEnum = {}));
})(PayerIdentification || (PayerIdentification = {}));
/**
 * @export
 * @namespace PayerIdentificationName
 */
export var PayerIdentificationName;
(function (PayerIdentificationName) {
    /**
     * @export
     * @enum {string}
     */
    var NameTypeEnum;
    (function (NameTypeEnum) {
        NameTypeEnum[NameTypeEnum["Universal"] = 'universal'] = "Universal";
        NameTypeEnum[NameTypeEnum["Native"] = 'native'] = "Native";
        NameTypeEnum[NameTypeEnum["Romanized"] = 'romanized'] = "Romanized";
    })(NameTypeEnum = PayerIdentificationName.NameTypeEnum || (PayerIdentificationName.NameTypeEnum = {}));
})(PayerIdentificationName || (PayerIdentificationName = {}));
/**
 * @export
 * @namespace Payment3DSAuthentication
 */
export var Payment3DSAuthentication;
(function (Payment3DSAuthentication) {
    /**
     * @export
     * @enum {string}
     */
    var DeviceChannelEnum;
    (function (DeviceChannelEnum) {
        DeviceChannelEnum[DeviceChannelEnum["ONLINE"] = 'ONLINE'] = "ONLINE";
        DeviceChannelEnum[DeviceChannelEnum["OFFLINE"] = 'OFFLINE'] = "OFFLINE";
        DeviceChannelEnum[DeviceChannelEnum["EXEMPTED"] = 'EXEMPTED'] = "EXEMPTED";
    })(DeviceChannelEnum = Payment3DSAuthentication.DeviceChannelEnum || (Payment3DSAuthentication.DeviceChannelEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var ParesStatusEnum;
    (function (ParesStatusEnum) {
        ParesStatusEnum[ParesStatusEnum["Y"] = 'Y'] = "Y";
        ParesStatusEnum[ParesStatusEnum["N"] = 'N'] = "N";
        ParesStatusEnum[ParesStatusEnum["A"] = 'A'] = "A";
        ParesStatusEnum[ParesStatusEnum["U"] = 'U'] = "U";
    })(ParesStatusEnum = Payment3DSAuthentication.ParesStatusEnum || (Payment3DSAuthentication.ParesStatusEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var VeresStatusEnum;
    (function (VeresStatusEnum) {
        VeresStatusEnum[VeresStatusEnum["Y"] = 'Y'] = "Y";
        VeresStatusEnum[VeresStatusEnum["N"] = 'N'] = "N";
        VeresStatusEnum[VeresStatusEnum["U"] = 'U'] = "U";
    })(VeresStatusEnum = Payment3DSAuthentication.VeresStatusEnum || (Payment3DSAuthentication.VeresStatusEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var TransStatusEnum;
    (function (TransStatusEnum) {
        TransStatusEnum[TransStatusEnum["Y"] = 'Y'] = "Y";
        TransStatusEnum[TransStatusEnum["N"] = 'N'] = "N";
        TransStatusEnum[TransStatusEnum["U"] = 'U'] = "U";
        TransStatusEnum[TransStatusEnum["A"] = 'A'] = "A";
        TransStatusEnum[TransStatusEnum["C"] = 'C'] = "C";
        TransStatusEnum[TransStatusEnum["D"] = 'D'] = "D";
        TransStatusEnum[TransStatusEnum["R"] = 'R'] = "R";
        TransStatusEnum[TransStatusEnum["I"] = 'I'] = "I";
    })(TransStatusEnum = Payment3DSAuthentication.TransStatusEnum || (Payment3DSAuthentication.TransStatusEnum = {}));
})(Payment3DSAuthentication || (Payment3DSAuthentication = {}));
/**
 * @export
 * @namespace PaymentCurrencyConversionProposalMerchantProvider
 */
export var PaymentCurrencyConversionProposalMerchantProvider;
(function (PaymentCurrencyConversionProposalMerchantProvider) {
    /**
     * @export
     * @enum {string}
     */
    var MerchantTypeEnum;
    (function (MerchantTypeEnum) {
        MerchantTypeEnum[MerchantTypeEnum["DCC"] = 'DCC'] = "DCC";
        MerchantTypeEnum[MerchantTypeEnum["MCP"] = 'MCP'] = "MCP";
    })(MerchantTypeEnum = PaymentCurrencyConversionProposalMerchantProvider.MerchantTypeEnum || (PaymentCurrencyConversionProposalMerchantProvider.MerchantTypeEnum = {}));
})(PaymentCurrencyConversionProposalMerchantProvider || (PaymentCurrencyConversionProposalMerchantProvider = {}));
/**
 * @export
 * @namespace PaymentMethod
 */
export var PaymentMethod;
(function (PaymentMethod) {
    /**
     * @export
     * @enum {string}
     */
    var PaymentTypeEnum;
    (function (PaymentTypeEnum) {
        PaymentTypeEnum[PaymentTypeEnum["PaymentCard"] = 'PaymentCard'] = "PaymentCard";
        PaymentTypeEnum[PaymentTypeEnum["ExternalPayment"] = 'ExternalPayment'] = "ExternalPayment";
        PaymentTypeEnum[PaymentTypeEnum["MilesPayment"] = 'MilesPayment'] = "MilesPayment";
        PaymentTypeEnum[PaymentTypeEnum["AlternativePaymentMethod"] = 'AlternativePaymentMethod'] = "AlternativePaymentMethod";
        PaymentTypeEnum[PaymentTypeEnum["VoucherPayment"] = 'VoucherPayment'] = "VoucherPayment";
        PaymentTypeEnum[PaymentTypeEnum["CustomPayment"] = 'CustomPayment'] = "CustomPayment";
        PaymentTypeEnum[PaymentTypeEnum["PaymentReferenceId"] = 'PaymentReferenceId'] = "PaymentReferenceId";
        PaymentTypeEnum[PaymentTypeEnum["CheckoutFormPayment"] = 'CheckoutFormPayment'] = "CheckoutFormPayment";
    })(PaymentTypeEnum = PaymentMethod.PaymentTypeEnum || (PaymentMethod.PaymentTypeEnum = {}));
})(PaymentMethod || (PaymentMethod = {}));
/**
 * @export
 * @namespace Penalty
 */
export var Penalty;
(function (Penalty) {
    /**
     * @export
     * @enum {string}
     */
    var CodeEnum;
    (function (CodeEnum) {
        CodeEnum[CodeEnum["BDT"] = 'BDT'] = "BDT";
        CodeEnum[CodeEnum["BDC"] = 'BDC'] = "BDC";
    })(CodeEnum = Penalty.CodeEnum || (Penalty.CodeEnum = {}));
})(Penalty || (Penalty = {}));
/**
 * @export
 * @namespace PersonalDetails
 */
export var PersonalDetails;
(function (PersonalDetails) {
    /**
     * @export
     * @enum {string}
     */
    var PurposeOfVisitEnum;
    (function (PurposeOfVisitEnum) {
        PurposeOfVisitEnum[PurposeOfVisitEnum["Business"] = 'business'] = "Business";
        PurposeOfVisitEnum[PurposeOfVisitEnum["Immigration"] = 'immigration'] = "Immigration";
        PurposeOfVisitEnum[PurposeOfVisitEnum["Studies"] = 'studies'] = "Studies";
        PurposeOfVisitEnum[PurposeOfVisitEnum["Tourist"] = 'tourist'] = "Tourist";
        PurposeOfVisitEnum[PurposeOfVisitEnum["Work"] = 'work'] = "Work";
    })(PurposeOfVisitEnum = PersonalDetails.PurposeOfVisitEnum || (PersonalDetails.PurposeOfVisitEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var GenderEnum;
    (function (GenderEnum) {
        GenderEnum[GenderEnum["Male"] = 'male'] = "Male";
        GenderEnum[GenderEnum["Female"] = 'female'] = "Female";
        GenderEnum[GenderEnum["Unspecified"] = 'unspecified'] = "Unspecified";
        GenderEnum[GenderEnum["Unknown"] = 'unknown'] = "Unknown";
    })(GenderEnum = PersonalDetails.GenderEnum || (PersonalDetails.GenderEnum = {}));
})(PersonalDetails || (PersonalDetails = {}));
/**
 * @export
 * @namespace Phone
 */
export var Phone;
(function (Phone) {
    /**
     * @export
     * @enum {string}
     */
    var DeviceTypeEnum;
    (function (DeviceTypeEnum) {
        DeviceTypeEnum[DeviceTypeEnum["Mobile"] = 'mobile'] = "Mobile";
        DeviceTypeEnum[DeviceTypeEnum["Landline"] = 'landline'] = "Landline";
        DeviceTypeEnum[DeviceTypeEnum["Fax"] = 'fax'] = "Fax";
    })(DeviceTypeEnum = Phone.DeviceTypeEnum || (Phone.DeviceTypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var PurposeEnum;
    (function (PurposeEnum) {
        PurposeEnum[PurposeEnum["Standard"] = 'standard'] = "Standard";
        PurposeEnum[PurposeEnum["Notification"] = 'notification'] = "Notification";
        PurposeEnum[PurposeEnum["Emergency"] = 'emergency'] = "Emergency";
        PurposeEnum[PurposeEnum["Information"] = 'information'] = "Information";
    })(PurposeEnum = Phone.PurposeEnum || (Phone.PurposeEnum = {}));
})(Phone || (Phone = {}));
/**
 * @export
 * @namespace PowerAmenity
 */
export var PowerAmenity;
(function (PowerAmenity) {
    /**
     * @export
     * @enum {string}
     */
    var PowerTypeEnum;
    (function (PowerTypeEnum) {
        PowerTypeEnum[PowerTypeEnum["PLUG"] = 'PLUG'] = "PLUG";
        PowerTypeEnum[PowerTypeEnum["ADAPTOR"] = 'ADAPTOR'] = "ADAPTOR";
        PowerTypeEnum[PowerTypeEnum["NOPOWERAVAILABLE"] = 'NO_POWER_AVAILABLE'] = "NOPOWERAVAILABLE";
        PowerTypeEnum[PowerTypeEnum["USBPORT"] = 'USB_PORT'] = "USBPORT";
        PowerTypeEnum[PowerTypeEnum["NONE"] = 'NONE'] = "NONE";
    })(PowerTypeEnum = PowerAmenity.PowerTypeEnum || (PowerAmenity.PowerTypeEnum = {}));
})(PowerAmenity || (PowerAmenity = {}));
/**
 * @export
 * @namespace RawAirOfferCondition
 */
export var RawAirOfferCondition;
(function (RawAirOfferCondition) {
    /**
     * @export
     * @enum {string}
     */
    var CategoryEnum;
    (function (CategoryEnum) {
        CategoryEnum[CategoryEnum["AdvancePurchase"] = 'advancePurchase'] = "AdvancePurchase";
        CategoryEnum[CategoryEnum["MinimumStay"] = 'minimumStay'] = "MinimumStay";
        CategoryEnum[CategoryEnum["MaximumStay"] = 'maximumStay'] = "MaximumStay";
        CategoryEnum[CategoryEnum["Change"] = 'change'] = "Change";
        CategoryEnum[CategoryEnum["Refund"] = 'refund'] = "Refund";
        CategoryEnum[CategoryEnum["SalesRestrictions"] = 'salesRestrictions'] = "SalesRestrictions";
        CategoryEnum[CategoryEnum["FlightApplication"] = 'flightApplication'] = "FlightApplication";
        CategoryEnum[CategoryEnum["ChildDiscounts"] = 'childDiscounts'] = "ChildDiscounts";
        CategoryEnum[CategoryEnum["TourConductor"] = 'tourConductor'] = "TourConductor";
        CategoryEnum[CategoryEnum["AgentsDiscounts"] = 'agentsDiscounts'] = "AgentsDiscounts";
        CategoryEnum[CategoryEnum["OtherDiscounts"] = 'otherDiscounts'] = "OtherDiscounts";
        CategoryEnum[CategoryEnum["Stopovers"] = 'stopovers'] = "Stopovers";
        CategoryEnum[CategoryEnum["Transfers"] = 'transfers'] = "Transfers";
        CategoryEnum[CategoryEnum["Endorsement"] = 'endorsement'] = "Endorsement";
        CategoryEnum[CategoryEnum["Combinability"] = 'combinability'] = "Combinability";
        CategoryEnum[CategoryEnum["HigherIntermediatePoints"] = 'higherIntermediatePoints'] = "HigherIntermediatePoints";
        CategoryEnum[CategoryEnum["Miscellaneous"] = 'miscellaneous'] = "Miscellaneous";
        CategoryEnum[CategoryEnum["Seasonality"] = 'seasonality'] = "Seasonality";
        CategoryEnum[CategoryEnum["Blackouts"] = 'blackouts'] = "Blackouts";
        CategoryEnum[CategoryEnum["DayTime"] = 'dayTime'] = "DayTime";
        CategoryEnum[CategoryEnum["TravelRestrictions"] = 'travelRestrictions'] = "TravelRestrictions";
        CategoryEnum[CategoryEnum["Penalties"] = 'penalties'] = "Penalties";
        CategoryEnum[CategoryEnum["Surcharges"] = 'surcharges'] = "Surcharges";
        CategoryEnum[CategoryEnum["Eligibility"] = 'eligibility'] = "Eligibility";
        CategoryEnum[CategoryEnum["VoluntaryRefunds"] = 'voluntaryRefunds'] = "VoluntaryRefunds";
        CategoryEnum[CategoryEnum["ReservationsAndTicketing"] = 'reservationsAndTicketing'] = "ReservationsAndTicketing";
        CategoryEnum[CategoryEnum["AccompaniedTravel"] = 'accompaniedTravel'] = "AccompaniedTravel";
        CategoryEnum[CategoryEnum["Groups"] = 'groups'] = "Groups";
        CategoryEnum[CategoryEnum["Tours"] = 'tours'] = "Tours";
        CategoryEnum[CategoryEnum["FareByRule"] = 'fareByRule'] = "FareByRule";
        CategoryEnum[CategoryEnum["VisitAnotherCountry"] = 'visitAnotherCountry'] = "VisitAnotherCountry";
        CategoryEnum[CategoryEnum["NegotiatedFares"] = 'negotiatedFares'] = "NegotiatedFares";
        CategoryEnum[CategoryEnum["RuleApplication"] = 'ruleApplication'] = "RuleApplication";
        CategoryEnum[CategoryEnum["Other"] = 'other'] = "Other";
    })(CategoryEnum = RawAirOfferCondition.CategoryEnum || (RawAirOfferCondition.CategoryEnum = {}));
})(RawAirOfferCondition || (RawAirOfferCondition = {}));
/**
 * @export
 * @namespace RegulatoryAddress
 */
export var RegulatoryAddress;
(function (RegulatoryAddress) {
    /**
     * @export
     * @enum {string}
     */
    var TypeEnum;
    (function (TypeEnum) {
        TypeEnum[TypeEnum["HomeAddress"] = 'homeAddress'] = "HomeAddress";
        TypeEnum[TypeEnum["DestinationAddress"] = 'destinationAddress'] = "DestinationAddress";
    })(TypeEnum = RegulatoryAddress.TypeEnum || (RegulatoryAddress.TypeEnum = {}));
})(RegulatoryAddress || (RegulatoryAddress = {}));
/**
 * @export
 * @namespace RegulatoryApisDetail
 */
export var RegulatoryApisDetail;
(function (RegulatoryApisDetail) {
    /**
     * @export
     * @enum {string}
     */
    var RegulatoryApisTypeEnum;
    (function (RegulatoryApisTypeEnum) {
        RegulatoryApisTypeEnum[RegulatoryApisTypeEnum["ApisDetailRegulatoryDocument"] = 'ApisDetailRegulatoryDocument'] = "ApisDetailRegulatoryDocument";
        RegulatoryApisTypeEnum[RegulatoryApisTypeEnum["ApisDetailAddress"] = 'ApisDetailAddress'] = "ApisDetailAddress";
        RegulatoryApisTypeEnum[RegulatoryApisTypeEnum["ApisDetailFromReference"] = 'ApisDetailFromReference'] = "ApisDetailFromReference";
    })(RegulatoryApisTypeEnum = RegulatoryApisDetail.RegulatoryApisTypeEnum || (RegulatoryApisDetail.RegulatoryApisTypeEnum = {}));
})(RegulatoryApisDetail || (RegulatoryApisDetail = {}));
/**
 * @export
 * @namespace RegulatoryApisDocument
 */
export var RegulatoryApisDocument;
(function (RegulatoryApisDocument) {
    /**
     * @export
     * @enum {string}
     */
    var DocumentTypeEnum;
    (function (DocumentTypeEnum) {
        DocumentTypeEnum[DocumentTypeEnum["Passport"] = 'passport'] = "Passport";
        DocumentTypeEnum[DocumentTypeEnum["PassportCard"] = 'passportCard'] = "PassportCard";
        DocumentTypeEnum[DocumentTypeEnum["IdentityCard"] = 'identityCard'] = "IdentityCard";
        DocumentTypeEnum[DocumentTypeEnum["CrewMemberCertificate"] = 'crewMemberCertificate'] = "CrewMemberCertificate";
        DocumentTypeEnum[DocumentTypeEnum["BorderCrossingCard"] = 'borderCrossingCard'] = "BorderCrossingCard";
        DocumentTypeEnum[DocumentTypeEnum["MilitaryIdentityCard"] = 'militaryIdentityCard'] = "MilitaryIdentityCard";
        DocumentTypeEnum[DocumentTypeEnum["ReEntryPermit"] = 'reEntryPermit'] = "ReEntryPermit";
        DocumentTypeEnum[DocumentTypeEnum["NaturalisationCardUS"] = 'naturalisationCardUS'] = "NaturalisationCardUS";
        DocumentTypeEnum[DocumentTypeEnum["ApprovedIdentityDocument"] = 'approvedIdentityDocument'] = "ApprovedIdentityDocument";
        DocumentTypeEnum[DocumentTypeEnum["Visa"] = 'visa'] = "Visa";
        DocumentTypeEnum[DocumentTypeEnum["ResidentAlienCard"] = 'residentAlienCard'] = "ResidentAlienCard";
        DocumentTypeEnum[DocumentTypeEnum["PermanentResidentCard"] = 'permanentResidentCard'] = "PermanentResidentCard";
        DocumentTypeEnum[DocumentTypeEnum["RedressNumber"] = 'redressNumber'] = "RedressNumber";
        DocumentTypeEnum[DocumentTypeEnum["KnownTravellerNumber"] = 'knownTravellerNumber'] = "KnownTravellerNumber";
        DocumentTypeEnum[DocumentTypeEnum["NexusCard"] = 'nexusCard'] = "NexusCard";
    })(DocumentTypeEnum = RegulatoryApisDocument.DocumentTypeEnum || (RegulatoryApisDocument.DocumentTypeEnum = {}));
})(RegulatoryApisDocument || (RegulatoryApisDocument = {}));
/**
 * @export
 * @namespace RegulatoryDetailsCategoryRequirement
 */
export var RegulatoryDetailsCategoryRequirement;
(function (RegulatoryDetailsCategoryRequirement) {
    /**
     * @export
     * @enum {string}
     */
    var DetailsCategoryEnum;
    (function (DetailsCategoryEnum) {
        DetailsCategoryEnum[DetailsCategoryEnum["PersonalDetails"] = 'personalDetails'] = "PersonalDetails";
        DetailsCategoryEnum[DetailsCategoryEnum["GreenCard"] = 'greenCard'] = "GreenCard";
        DetailsCategoryEnum[DetailsCategoryEnum["IdentityDocument"] = 'identityDocument'] = "IdentityDocument";
        DetailsCategoryEnum[DetailsCategoryEnum["CountryEntryDocument"] = 'countryEntryDocument'] = "CountryEntryDocument";
        DetailsCategoryEnum[DetailsCategoryEnum["DestinationAddress"] = 'destinationAddress'] = "DestinationAddress";
        DetailsCategoryEnum[DetailsCategoryEnum["EmergencyContact"] = 'emergencyContact'] = "EmergencyContact";
        DetailsCategoryEnum[DetailsCategoryEnum["HomeAddress"] = 'homeAddress'] = "HomeAddress";
        DetailsCategoryEnum[DetailsCategoryEnum["PermanentResidentCard"] = 'permanentResidentCard'] = "PermanentResidentCard";
        DetailsCategoryEnum[DetailsCategoryEnum["AdditionalSecurityInfo"] = 'additionalSecurityInfo'] = "AdditionalSecurityInfo";
    })(DetailsCategoryEnum = RegulatoryDetailsCategoryRequirement.DetailsCategoryEnum || (RegulatoryDetailsCategoryRequirement.DetailsCategoryEnum = {}));
})(RegulatoryDetailsCategoryRequirement || (RegulatoryDetailsCategoryRequirement = {}));
/**
 * @export
 * @namespace RegulatoryDetailsReplyData
 */
export var RegulatoryDetailsReplyData;
(function (RegulatoryDetailsReplyData) {
    /**
     * @export
     * @enum {string}
     */
    var DeclinedDetailsEnum;
    (function (DeclinedDetailsEnum) {
        DeclinedDetailsEnum[DeclinedDetailsEnum["PersonalDetails"] = 'personalDetails'] = "PersonalDetails";
        DeclinedDetailsEnum[DeclinedDetailsEnum["CountryOfResidence"] = 'countryOfResidence'] = "CountryOfResidence";
        DeclinedDetailsEnum[DeclinedDetailsEnum["Passport"] = 'passport'] = "Passport";
        DeclinedDetailsEnum[DeclinedDetailsEnum["IdentityCard"] = 'identityCard'] = "IdentityCard";
        DeclinedDetailsEnum[DeclinedDetailsEnum["AirAttendanceLicense"] = 'airAttendanceLicense'] = "AirAttendanceLicense";
        DeclinedDetailsEnum[DeclinedDetailsEnum["BirthCertificate"] = 'birthCertificate'] = "BirthCertificate";
        DeclinedDetailsEnum[DeclinedDetailsEnum["BorderCrossingCard"] = 'borderCrossingCard'] = "BorderCrossingCard";
        DeclinedDetailsEnum[DeclinedDetailsEnum["DrivingLicense"] = 'drivingLicense'] = "DrivingLicense";
        DeclinedDetailsEnum[DeclinedDetailsEnum["FlightMechanicalLicense"] = 'flightMechanicalLicense'] = "FlightMechanicalLicense";
        DeclinedDetailsEnum[DeclinedDetailsEnum["ForeignNationalRegistration"] = 'foreignNationalRegistration'] = "ForeignNationalRegistration";
        DeclinedDetailsEnum[DeclinedDetailsEnum["LoyalAttorneyIdentification"] = 'loyalAttorneyIdentification'] = "LoyalAttorneyIdentification";
        DeclinedDetailsEnum[DeclinedDetailsEnum["MilitaryIdentityCard"] = 'militaryIdentityCard'] = "MilitaryIdentityCard";
        DeclinedDetailsEnum[DeclinedDetailsEnum["OperationalDispatcherLicense"] = 'operationalDispatcherLicense'] = "OperationalDispatcherLicense";
        DeclinedDetailsEnum[DeclinedDetailsEnum["PilotLicense"] = 'pilotLicense'] = "PilotLicense";
        DeclinedDetailsEnum[DeclinedDetailsEnum["ReEntryPermit"] = 'reEntryPermit'] = "ReEntryPermit";
        DeclinedDetailsEnum[DeclinedDetailsEnum["NaturalisationCardUS"] = 'naturalisationCardUS'] = "NaturalisationCardUS";
        DeclinedDetailsEnum[DeclinedDetailsEnum["WorkPermit"] = 'workPermit'] = "WorkPermit";
        DeclinedDetailsEnum[DeclinedDetailsEnum["Visa"] = 'visa'] = "Visa";
        DeclinedDetailsEnum[DeclinedDetailsEnum["ResidentAlienCard"] = 'residentAlienCard'] = "ResidentAlienCard";
        DeclinedDetailsEnum[DeclinedDetailsEnum["PermanentResidentCard"] = 'permanentResidentCard'] = "PermanentResidentCard";
        DeclinedDetailsEnum[DeclinedDetailsEnum["DestinationAddress"] = 'destinationAddress'] = "DestinationAddress";
        DeclinedDetailsEnum[DeclinedDetailsEnum["HomeAddress"] = 'homeAddress'] = "HomeAddress";
        DeclinedDetailsEnum[DeclinedDetailsEnum["EmergencyContact"] = 'emergencyContact'] = "EmergencyContact";
        DeclinedDetailsEnum[DeclinedDetailsEnum["RedressNumber"] = 'redressNumber'] = "RedressNumber";
        DeclinedDetailsEnum[DeclinedDetailsEnum["KnownTravelerNumber"] = 'knownTravelerNumber'] = "KnownTravelerNumber";
        DeclinedDetailsEnum[DeclinedDetailsEnum["HomeReentryPermit"] = 'homeReentryPermit'] = "HomeReentryPermit";
        DeclinedDetailsEnum[DeclinedDetailsEnum["ChinaTravelPermit"] = 'chinaTravelPermit'] = "ChinaTravelPermit";
        DeclinedDetailsEnum[DeclinedDetailsEnum["ChinaTravelPermitHongKongMacao"] = 'chinaTravelPermitHongKongMacao'] = "ChinaTravelPermitHongKongMacao";
        DeclinedDetailsEnum[DeclinedDetailsEnum["ChinaExitAndEntryPermit"] = 'chinaExitAndEntryPermit'] = "ChinaExitAndEntryPermit";
        DeclinedDetailsEnum[DeclinedDetailsEnum["ResidentTravelPermit"] = 'residentTravelPermit'] = "ResidentTravelPermit";
        DeclinedDetailsEnum[DeclinedDetailsEnum["ResidentTravelPermitToFromTaiwanAndChina"] = 'residentTravelPermitToFromTaiwanAndChina'] = "ResidentTravelPermitToFromTaiwanAndChina";
        DeclinedDetailsEnum[DeclinedDetailsEnum["ResidentTravelPermitToFromHongKongMacao"] = 'residentTravelPermitToFromHongKongMacao'] = "ResidentTravelPermitToFromHongKongMacao";
        DeclinedDetailsEnum[DeclinedDetailsEnum["ResidentTravelPermitToHongKongMacao"] = 'residentTravelPermitToHongKongMacao'] = "ResidentTravelPermitToHongKongMacao";
        DeclinedDetailsEnum[DeclinedDetailsEnum["TaiwanExitAndEntryPermit"] = 'taiwanExitAndEntryPermit'] = "TaiwanExitAndEntryPermit";
        DeclinedDetailsEnum[DeclinedDetailsEnum["NexusCard"] = 'nexusCard'] = "NexusCard";
    })(DeclinedDetailsEnum = RegulatoryDetailsReplyData.DeclinedDetailsEnum || (RegulatoryDetailsReplyData.DeclinedDetailsEnum = {}));
})(RegulatoryDetailsReplyData || (RegulatoryDetailsReplyData = {}));
/**
 * @export
 * @namespace RegulatoryDetailsRequirements
 */
export var RegulatoryDetailsRequirements;
(function (RegulatoryDetailsRequirements) {
    /**
     * @export
     * @enum {string}
     */
    var DetailsTypeEnum;
    (function (DetailsTypeEnum) {
        DetailsTypeEnum[DetailsTypeEnum["Document"] = 'document'] = "Document";
        DetailsTypeEnum[DetailsTypeEnum["PersonalDetails"] = 'personalDetails'] = "PersonalDetails";
        DetailsTypeEnum[DetailsTypeEnum["Address"] = 'address'] = "Address";
        DetailsTypeEnum[DetailsTypeEnum["Phone"] = 'phone'] = "Phone";
    })(DetailsTypeEnum = RegulatoryDetailsRequirements.DetailsTypeEnum || (RegulatoryDetailsRequirements.DetailsTypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var RequiredDetailsFieldsEnum;
    (function (RequiredDetailsFieldsEnum) {
        RequiredDetailsFieldsEnum[RequiredDetailsFieldsEnum["Name"] = 'name'] = "Name";
        RequiredDetailsFieldsEnum[RequiredDetailsFieldsEnum["BirthDate"] = 'birthDate'] = "BirthDate";
        RequiredDetailsFieldsEnum[RequiredDetailsFieldsEnum["BirthPlace"] = 'birthPlace'] = "BirthPlace";
        RequiredDetailsFieldsEnum[RequiredDetailsFieldsEnum["Gender"] = 'gender'] = "Gender";
        RequiredDetailsFieldsEnum[RequiredDetailsFieldsEnum["Number"] = 'number'] = "Number";
        RequiredDetailsFieldsEnum[RequiredDetailsFieldsEnum["NationalityCountryCode"] = 'nationalityCountryCode'] = "NationalityCountryCode";
        RequiredDetailsFieldsEnum[RequiredDetailsFieldsEnum["ExpiryDate"] = 'expiryDate'] = "ExpiryDate";
        RequiredDetailsFieldsEnum[RequiredDetailsFieldsEnum["EffectiveDate"] = 'effectiveDate'] = "EffectiveDate";
        RequiredDetailsFieldsEnum[RequiredDetailsFieldsEnum["IssuanceDate"] = 'issuanceDate'] = "IssuanceDate";
        RequiredDetailsFieldsEnum[RequiredDetailsFieldsEnum["IssuanceLocation"] = 'issuanceLocation'] = "IssuanceLocation";
        RequiredDetailsFieldsEnum[RequiredDetailsFieldsEnum["IssuanceCountry"] = 'issuanceCountry'] = "IssuanceCountry";
        RequiredDetailsFieldsEnum[RequiredDetailsFieldsEnum["PurposeOfVisit"] = 'purposeOfVisit'] = "PurposeOfVisit";
        RequiredDetailsFieldsEnum[RequiredDetailsFieldsEnum["Lines"] = 'lines'] = "Lines";
        RequiredDetailsFieldsEnum[RequiredDetailsFieldsEnum["ZipCode"] = 'zipCode'] = "ZipCode";
        RequiredDetailsFieldsEnum[RequiredDetailsFieldsEnum["CityName"] = 'cityName'] = "CityName";
        RequiredDetailsFieldsEnum[RequiredDetailsFieldsEnum["StateCode"] = 'stateCode'] = "StateCode";
        RequiredDetailsFieldsEnum[RequiredDetailsFieldsEnum["CountryPhoneExtension"] = 'countryPhoneExtension'] = "CountryPhoneExtension";
        RequiredDetailsFieldsEnum[RequiredDetailsFieldsEnum["CountryOfResidence"] = 'countryOfResidence'] = "CountryOfResidence";
    })(RequiredDetailsFieldsEnum = RegulatoryDetailsRequirements.RequiredDetailsFieldsEnum || (RegulatoryDetailsRequirements.RequiredDetailsFieldsEnum = {}));
})(RegulatoryDetailsRequirements || (RegulatoryDetailsRequirements = {}));
/**
 * @export
 * @namespace RegulatoryDocument
 */
export var RegulatoryDocument;
(function (RegulatoryDocument) {
    /**
     * @export
     * @enum {string}
     */
    var GenderEnum;
    (function (GenderEnum) {
        GenderEnum[GenderEnum["Male"] = 'male'] = "Male";
        GenderEnum[GenderEnum["Female"] = 'female'] = "Female";
        GenderEnum[GenderEnum["Unspecified"] = 'unspecified'] = "Unspecified";
        GenderEnum[GenderEnum["Unknown"] = 'unknown'] = "Unknown";
    })(GenderEnum = RegulatoryDocument.GenderEnum || (RegulatoryDocument.GenderEnum = {}));
})(RegulatoryDocument || (RegulatoryDocument = {}));
/**
 * @export
 * @namespace RegulatoryDocumentCommon
 */
export var RegulatoryDocumentCommon;
(function (RegulatoryDocumentCommon) {
    /**
     * @export
     * @enum {string}
     */
    var GenderEnum;
    (function (GenderEnum) {
        GenderEnum[GenderEnum["Male"] = 'male'] = "Male";
        GenderEnum[GenderEnum["Female"] = 'female'] = "Female";
        GenderEnum[GenderEnum["Unspecified"] = 'unspecified'] = "Unspecified";
        GenderEnum[GenderEnum["Unknown"] = 'unknown'] = "Unknown";
    })(GenderEnum = RegulatoryDocumentCommon.GenderEnum || (RegulatoryDocumentCommon.GenderEnum = {}));
})(RegulatoryDocumentCommon || (RegulatoryDocumentCommon = {}));
/**
 * @export
 * @namespace RegulatoryFoidDocument
 */
export var RegulatoryFoidDocument;
(function (RegulatoryFoidDocument) {
    /**
     * @export
     * @enum {string}
     */
    var DocumentTypeEnum;
    (function (DocumentTypeEnum) {
        DocumentTypeEnum[DocumentTypeEnum["Passport"] = 'passport'] = "Passport";
        DocumentTypeEnum[DocumentTypeEnum["IdentityCard"] = 'identityCard'] = "IdentityCard";
        DocumentTypeEnum[DocumentTypeEnum["LocalIdentityCard"] = 'localIdentityCard'] = "LocalIdentityCard";
        DocumentTypeEnum[DocumentTypeEnum["DrivingLicense"] = 'drivingLicense'] = "DrivingLicense";
        DocumentTypeEnum[DocumentTypeEnum["SocialSecurity"] = 'socialSecurity'] = "SocialSecurity";
    })(DocumentTypeEnum = RegulatoryFoidDocument.DocumentTypeEnum || (RegulatoryFoidDocument.DocumentTypeEnum = {}));
})(RegulatoryFoidDocument || (RegulatoryFoidDocument = {}));
/**
 * @export
 * @namespace RegulatoryPhoneNumber
 */
export var RegulatoryPhoneNumber;
(function (RegulatoryPhoneNumber) {
    /**
     * @export
     * @enum {string}
     */
    var PurposeEnum;
    (function (PurposeEnum) {
        PurposeEnum[PurposeEnum["EmergencyContact"] = 'emergencyContact'] = "EmergencyContact";
    })(PurposeEnum = RegulatoryPhoneNumber.PurposeEnum || (RegulatoryPhoneNumber.PurposeEnum = {}));
})(RegulatoryPhoneNumber || (RegulatoryPhoneNumber = {}));
/**
 * @export
 * @namespace RegulatoryType
 */
export var RegulatoryType;
(function (RegulatoryType) {
    /**
     * @export
     * @enum {string}
     */
    var RegulatoryTypeEnum;
    (function (RegulatoryTypeEnum) {
        RegulatoryTypeEnum[RegulatoryTypeEnum["PersonalDetails"] = 'personalDetails'] = "PersonalDetails";
        RegulatoryTypeEnum[RegulatoryTypeEnum["CountryOfResidence"] = 'countryOfResidence'] = "CountryOfResidence";
        RegulatoryTypeEnum[RegulatoryTypeEnum["Passport"] = 'passport'] = "Passport";
        RegulatoryTypeEnum[RegulatoryTypeEnum["IdentityCard"] = 'identityCard'] = "IdentityCard";
        RegulatoryTypeEnum[RegulatoryTypeEnum["AirAttendanceLicense"] = 'airAttendanceLicense'] = "AirAttendanceLicense";
        RegulatoryTypeEnum[RegulatoryTypeEnum["BirthCertificate"] = 'birthCertificate'] = "BirthCertificate";
        RegulatoryTypeEnum[RegulatoryTypeEnum["BorderCrossingCard"] = 'borderCrossingCard'] = "BorderCrossingCard";
        RegulatoryTypeEnum[RegulatoryTypeEnum["DrivingLicense"] = 'drivingLicense'] = "DrivingLicense";
        RegulatoryTypeEnum[RegulatoryTypeEnum["FlightMechanicalLicense"] = 'flightMechanicalLicense'] = "FlightMechanicalLicense";
        RegulatoryTypeEnum[RegulatoryTypeEnum["ForeignNationalRegistration"] = 'foreignNationalRegistration'] = "ForeignNationalRegistration";
        RegulatoryTypeEnum[RegulatoryTypeEnum["LoyalAttorneyIdentification"] = 'loyalAttorneyIdentification'] = "LoyalAttorneyIdentification";
        RegulatoryTypeEnum[RegulatoryTypeEnum["MilitaryIdentityCard"] = 'militaryIdentityCard'] = "MilitaryIdentityCard";
        RegulatoryTypeEnum[RegulatoryTypeEnum["OperationalDispatcherLicense"] = 'operationalDispatcherLicense'] = "OperationalDispatcherLicense";
        RegulatoryTypeEnum[RegulatoryTypeEnum["PilotLicense"] = 'pilotLicense'] = "PilotLicense";
        RegulatoryTypeEnum[RegulatoryTypeEnum["ReEntryPermit"] = 'reEntryPermit'] = "ReEntryPermit";
        RegulatoryTypeEnum[RegulatoryTypeEnum["NaturalisationCardUS"] = 'naturalisationCardUS'] = "NaturalisationCardUS";
        RegulatoryTypeEnum[RegulatoryTypeEnum["WorkPermit"] = 'workPermit'] = "WorkPermit";
        RegulatoryTypeEnum[RegulatoryTypeEnum["Visa"] = 'visa'] = "Visa";
        RegulatoryTypeEnum[RegulatoryTypeEnum["ResidentAlienCard"] = 'residentAlienCard'] = "ResidentAlienCard";
        RegulatoryTypeEnum[RegulatoryTypeEnum["PermanentResidentCard"] = 'permanentResidentCard'] = "PermanentResidentCard";
        RegulatoryTypeEnum[RegulatoryTypeEnum["DestinationAddress"] = 'destinationAddress'] = "DestinationAddress";
        RegulatoryTypeEnum[RegulatoryTypeEnum["HomeAddress"] = 'homeAddress'] = "HomeAddress";
        RegulatoryTypeEnum[RegulatoryTypeEnum["EmergencyContact"] = 'emergencyContact'] = "EmergencyContact";
        RegulatoryTypeEnum[RegulatoryTypeEnum["RedressNumber"] = 'redressNumber'] = "RedressNumber";
        RegulatoryTypeEnum[RegulatoryTypeEnum["KnownTravelerNumber"] = 'knownTravelerNumber'] = "KnownTravelerNumber";
        RegulatoryTypeEnum[RegulatoryTypeEnum["HomeReentryPermit"] = 'homeReentryPermit'] = "HomeReentryPermit";
        RegulatoryTypeEnum[RegulatoryTypeEnum["ChinaTravelPermit"] = 'chinaTravelPermit'] = "ChinaTravelPermit";
        RegulatoryTypeEnum[RegulatoryTypeEnum["ChinaTravelPermitHongKongMacao"] = 'chinaTravelPermitHongKongMacao'] = "ChinaTravelPermitHongKongMacao";
        RegulatoryTypeEnum[RegulatoryTypeEnum["ChinaExitAndEntryPermit"] = 'chinaExitAndEntryPermit'] = "ChinaExitAndEntryPermit";
        RegulatoryTypeEnum[RegulatoryTypeEnum["ResidentTravelPermit"] = 'residentTravelPermit'] = "ResidentTravelPermit";
        RegulatoryTypeEnum[RegulatoryTypeEnum["ResidentTravelPermitToFromTaiwanAndChina"] = 'residentTravelPermitToFromTaiwanAndChina'] = "ResidentTravelPermitToFromTaiwanAndChina";
        RegulatoryTypeEnum[RegulatoryTypeEnum["ResidentTravelPermitToFromHongKongMacao"] = 'residentTravelPermitToFromHongKongMacao'] = "ResidentTravelPermitToFromHongKongMacao";
        RegulatoryTypeEnum[RegulatoryTypeEnum["ResidentTravelPermitToHongKongMacao"] = 'residentTravelPermitToHongKongMacao'] = "ResidentTravelPermitToHongKongMacao";
        RegulatoryTypeEnum[RegulatoryTypeEnum["TaiwanExitAndEntryPermit"] = 'taiwanExitAndEntryPermit'] = "TaiwanExitAndEntryPermit";
        RegulatoryTypeEnum[RegulatoryTypeEnum["NexusCard"] = 'nexusCard'] = "NexusCard";
    })(RegulatoryTypeEnum = RegulatoryType.RegulatoryTypeEnum || (RegulatoryType.RegulatoryTypeEnum = {}));
})(RegulatoryType || (RegulatoryType = {}));
/**
 * @export
 * @namespace Remark
 */
export var Remark;
(function (Remark) {
    /**
     * @export
     * @enum {string}
     */
    var RemarkTypeEnum;
    (function (RemarkTypeEnum) {
        RemarkTypeEnum[RemarkTypeEnum["GeneralRemark"] = 'GeneralRemark'] = "GeneralRemark";
        RemarkTypeEnum[RemarkTypeEnum["CorporateRemark"] = 'CorporateRemark'] = "CorporateRemark";
        RemarkTypeEnum[RemarkTypeEnum["ConfidentialRemark"] = 'ConfidentialRemark'] = "ConfidentialRemark";
    })(RemarkTypeEnum = Remark.RemarkTypeEnum || (Remark.RemarkTypeEnum = {}));
})(Remark || (Remark = {}));
/**
 * @export
 * @namespace SeatmapCoordinatesUnit
 */
export var SeatmapCoordinatesUnit;
(function (SeatmapCoordinatesUnit) {
    /**
     * @export
     * @enum {string}
     */
    var RotationUnitEnum;
    (function (RotationUnitEnum) {
        RotationUnitEnum[RotationUnitEnum["Radian"] = 'radian'] = "Radian";
        RotationUnitEnum[RotationUnitEnum["Degree"] = 'degree'] = "Degree";
    })(RotationUnitEnum = SeatmapCoordinatesUnit.RotationUnitEnum || (SeatmapCoordinatesUnit.RotationUnitEnum = {}));
})(SeatmapCoordinatesUnit || (SeatmapCoordinatesUnit = {}));
/**
 * @export
 * @namespace SeatmapDeck
 */
export var SeatmapDeck;
(function (SeatmapDeck) {
    /**
     * @export
     * @enum {string}
     */
    var DeckTypeEnum;
    (function (DeckTypeEnum) {
        DeckTypeEnum[DeckTypeEnum["Upper"] = 'upper'] = "Upper";
        DeckTypeEnum[DeckTypeEnum["Main"] = 'main'] = "Main";
    })(DeckTypeEnum = SeatmapDeck.DeckTypeEnum || (SeatmapDeck.DeckTypeEnum = {}));
})(SeatmapDeck || (SeatmapDeck = {}));
/**
 * @export
 * @namespace SeatmapEligibility
 */
export var SeatmapEligibility;
(function (SeatmapEligibility) {
    /**
     * @export
     * @enum {string}
     */
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["Eligible"] = 'eligible'] = "Eligible";
        StatusEnum[StatusEnum["Ineligible"] = 'ineligible'] = "Ineligible";
    })(StatusEnum = SeatmapEligibility.StatusEnum || (SeatmapEligibility.StatusEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var ReasonsEnum;
    (function (ReasonsEnum) {
        ReasonsEnum[ReasonsEnum["PassengerOnStandby"] = 'passengerOnStandby'] = "PassengerOnStandby";
        ReasonsEnum[ReasonsEnum["CustomerEligibilityRule"] = 'customerEligibilityRule'] = "CustomerEligibilityRule";
        ReasonsEnum[ReasonsEnum["FlightEligibilityRule"] = 'flightEligibilityRule'] = "FlightEligibilityRule";
        ReasonsEnum[ReasonsEnum["IATCIflight"] = 'IATCIflight'] = "IATCIflight";
    })(ReasonsEnum = SeatmapEligibility.ReasonsEnum || (SeatmapEligibility.ReasonsEnum = {}));
})(SeatmapEligibility || (SeatmapEligibility = {}));
/**
 * @export
 * @namespace SeatmapFacility
 */
export var SeatmapFacility;
(function (SeatmapFacility) {
    /**
     * @export
     * @enum {string}
     */
    var PositionEnum;
    (function (PositionEnum) {
        PositionEnum[PositionEnum["Front"] = 'front'] = "Front";
        PositionEnum[PositionEnum["Rear"] = 'rear'] = "Rear";
        PositionEnum[PositionEnum["Seat"] = 'seat'] = "Seat";
    })(PositionEnum = SeatmapFacility.PositionEnum || (SeatmapFacility.PositionEnum = {}));
})(SeatmapFacility || (SeatmapFacility = {}));
/**
 * @export
 * @namespace SeatmapSeatProperties
 */
export var SeatmapSeatProperties;
(function (SeatmapSeatProperties) {
    /**
     * @export
     * @enum {string}
     */
    var SeatAvailabilityStatusEnum;
    (function (SeatAvailabilityStatusEnum) {
        SeatAvailabilityStatusEnum[SeatAvailabilityStatusEnum["Available"] = 'available'] = "Available";
        SeatAvailabilityStatusEnum[SeatAvailabilityStatusEnum["Blocked"] = 'blocked'] = "Blocked";
        SeatAvailabilityStatusEnum[SeatAvailabilityStatusEnum["Occupied"] = 'occupied'] = "Occupied";
    })(SeatAvailabilityStatusEnum = SeatmapSeatProperties.SeatAvailabilityStatusEnum || (SeatmapSeatProperties.SeatAvailabilityStatusEnum = {}));
})(SeatmapSeatProperties || (SeatmapSeatProperties = {}));
/**
 * @export
 * @namespace SeatmapTravelerSeatInfo
 */
export var SeatmapTravelerSeatInfo;
(function (SeatmapTravelerSeatInfo) {
    /**
     * @export
     * @enum {string}
     */
    var SeatAvailabilityStatusEnum;
    (function (SeatAvailabilityStatusEnum) {
        SeatAvailabilityStatusEnum[SeatAvailabilityStatusEnum["Available"] = 'available'] = "Available";
        SeatAvailabilityStatusEnum[SeatAvailabilityStatusEnum["Blocked"] = 'blocked'] = "Blocked";
        SeatAvailabilityStatusEnum[SeatAvailabilityStatusEnum["Occupied"] = 'occupied'] = "Occupied";
    })(SeatAvailabilityStatusEnum = SeatmapTravelerSeatInfo.SeatAvailabilityStatusEnum || (SeatmapTravelerSeatInfo.SeatAvailabilityStatusEnum = {}));
})(SeatmapTravelerSeatInfo || (SeatmapTravelerSeatInfo = {}));
/**
 * @export
 * @namespace Security
 */
export var Security;
(function (Security) {
    /**
     * @export
     * @enum {string}
     */
    var PermissionEnum;
    (function (PermissionEnum) {
        PermissionEnum[PermissionEnum["Read"] = 'read'] = "Read";
        PermissionEnum[PermissionEnum["Write"] = 'write'] = "Write";
    })(PermissionEnum = Security.PermissionEnum || (Security.PermissionEnum = {}));
})(Security || (Security = {}));
/**
 * @export
 * @namespace ServiceDescription
 */
export var ServiceDescription;
(function (ServiceDescription) {
    /**
     * @export
     * @enum {string}
     */
    var TypeEnum;
    (function (TypeEnum) {
        TypeEnum[TypeEnum["ShortText"] = 'shortText'] = "ShortText";
        TypeEnum[TypeEnum["LongText"] = 'longText'] = "LongText";
        TypeEnum[TypeEnum["MediaId"] = 'mediaId'] = "MediaId";
    })(TypeEnum = ServiceDescription.TypeEnum || (ServiceDescription.TypeEnum = {}));
})(ServiceDescription || (ServiceDescription = {}));
/**
 * @export
 * @namespace ServiceDictionaryItem
 */
export var ServiceDictionaryItem;
(function (ServiceDictionaryItem) {
    /**
     * @export
     * @enum {string}
     */
    var ServiceTypeEnum;
    (function (ServiceTypeEnum) {
        ServiceTypeEnum[ServiceTypeEnum["FreeCheckedBaggage"] = 'freeCheckedBaggage'] = "FreeCheckedBaggage";
        ServiceTypeEnum[ServiceTypeEnum["FreeCarryOnBaggage"] = 'freeCarryOnBaggage'] = "FreeCarryOnBaggage";
        ServiceTypeEnum[ServiceTypeEnum["Chargeable"] = 'chargeable'] = "Chargeable";
    })(ServiceTypeEnum = ServiceDictionaryItem.ServiceTypeEnum || (ServiceDictionaryItem.ServiceTypeEnum = {}));
})(ServiceDictionaryItem || (ServiceDictionaryItem = {}));
/**
 * @export
 * @namespace ServiceItemCommon
 */
export var ServiceItemCommon;
(function (ServiceItemCommon) {
    /**
     * @export
     * @enum {string}
     */
    var QuotaStatusEnum;
    (function (QuotaStatusEnum) {
        QuotaStatusEnum[QuotaStatusEnum["Unknown"] = 'unknown'] = "Unknown";
        QuotaStatusEnum[QuotaStatusEnum["Guaranteed"] = 'guaranteed'] = "Guaranteed";
        QuotaStatusEnum[QuotaStatusEnum["Pending"] = 'pending'] = "Pending";
    })(QuotaStatusEnum = ServiceItemCommon.QuotaStatusEnum || (ServiceItemCommon.QuotaStatusEnum = {}));
})(ServiceItemCommon || (ServiceItemCommon = {}));
/**
 * @export
 * @namespace ServiceParameter
 */
export var ServiceParameter;
(function (ServiceParameter) {
    /**
     * @export
     * @enum {string}
     */
    var RequirementLevelEnum;
    (function (RequirementLevelEnum) {
        RequirementLevelEnum[RequirementLevelEnum["Mandatory"] = 'mandatory'] = "Mandatory";
        RequirementLevelEnum[RequirementLevelEnum["Optional"] = 'optional'] = "Optional";
    })(RequirementLevelEnum = ServiceParameter.RequirementLevelEnum || (ServiceParameter.RequirementLevelEnum = {}));
})(ServiceParameter || (ServiceParameter = {}));
/**
 * @export
 * @namespace SpanishLargeFamilyCard
 */
export var SpanishLargeFamilyCard;
(function (SpanishLargeFamilyCard) {
    /**
     * @export
     * @enum {string}
     */
    var TravelerTypeEnum;
    (function (TravelerTypeEnum) {
        TravelerTypeEnum[TravelerTypeEnum["SpanishCitizen"] = 'spanishCitizen'] = "SpanishCitizen";
        TravelerTypeEnum[TravelerTypeEnum["EuropeanCitizen"] = 'europeanCitizen'] = "EuropeanCitizen";
        TravelerTypeEnum[TravelerTypeEnum["GovernmentWorker"] = 'governmentWorker'] = "GovernmentWorker";
        TravelerTypeEnum[TravelerTypeEnum["MinorWithoutId"] = 'minorWithoutId'] = "MinorWithoutId";
    })(TravelerTypeEnum = SpanishLargeFamilyCard.TravelerTypeEnum || (SpanishLargeFamilyCard.TravelerTypeEnum = {}));
})(SpanishLargeFamilyCard || (SpanishLargeFamilyCard = {}));
/**
 * @export
 * @namespace SpanishResidentCard
 */
export var SpanishResidentCard;
(function (SpanishResidentCard) {
    /**
     * @export
     * @enum {string}
     */
    var TravelerTypeEnum;
    (function (TravelerTypeEnum) {
        TravelerTypeEnum[TravelerTypeEnum["SpanishCitizen"] = 'spanishCitizen'] = "SpanishCitizen";
        TravelerTypeEnum[TravelerTypeEnum["EuropeanCitizen"] = 'europeanCitizen'] = "EuropeanCitizen";
        TravelerTypeEnum[TravelerTypeEnum["GovernmentWorker"] = 'governmentWorker'] = "GovernmentWorker";
        TravelerTypeEnum[TravelerTypeEnum["MinorWithoutId"] = 'minorWithoutId'] = "MinorWithoutId";
    })(TravelerTypeEnum = SpanishResidentCard.TravelerTypeEnum || (SpanishResidentCard.TravelerTypeEnum = {}));
})(SpanishResidentCard || (SpanishResidentCard = {}));
/**
 * @export
 * @namespace SpecialEquipment
 */
export var SpecialEquipment;
(function (SpecialEquipment) {
    /**
     * @export
     * @enum {string}
     */
    var PricingTimeWindowEnum;
    (function (PricingTimeWindowEnum) {
        PricingTimeWindowEnum[PricingTimeWindowEnum["Hourly"] = 'hourly'] = "Hourly";
        PricingTimeWindowEnum[PricingTimeWindowEnum["Daily"] = 'daily'] = "Daily";
        PricingTimeWindowEnum[PricingTimeWindowEnum["Monthly"] = 'monthly'] = "Monthly";
        PricingTimeWindowEnum[PricingTimeWindowEnum["Weekend"] = 'weekend'] = "Weekend";
        PricingTimeWindowEnum[PricingTimeWindowEnum["Weekly"] = 'weekly'] = "Weekly";
        PricingTimeWindowEnum[PricingTimeWindowEnum["FullPeriod"] = 'fullPeriod'] = "FullPeriod";
    })(PricingTimeWindowEnum = SpecialEquipment.PricingTimeWindowEnum || (SpecialEquipment.PricingTimeWindowEnum = {}));
})(SpecialEquipment || (SpecialEquipment = {}));
/**
 * @export
 * @namespace Status
 */
export var Status;
(function (Status) {
    /**
     * @export
     * @enum {string}
     */
    var ValueEnum;
    (function (ValueEnum) {
        ValueEnum[ValueEnum["SoldOut"] = 'soldOut'] = "SoldOut";
        ValueEnum[ValueEnum["Unavailable"] = 'unavailable'] = "Unavailable";
        ValueEnum[ValueEnum["Waitlist"] = 'waitlist'] = "Waitlist";
        ValueEnum[ValueEnum["TooCloseToDeparture"] = 'tooCloseToDeparture'] = "TooCloseToDeparture";
        ValueEnum[ValueEnum["NonCombinableWithSelectedBound"] = 'nonCombinableWithSelectedBound'] = "NonCombinableWithSelectedBound";
    })(ValueEnum = Status.ValueEnum || (Status.ValueEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var UnavailabilityReasonCodesEnum;
    (function (UnavailabilityReasonCodesEnum) {
        UnavailabilityReasonCodesEnum[UnavailabilityReasonCodesEnum["NoFlights"] = 'noFlights'] = "NoFlights";
        UnavailabilityReasonCodesEnum[UnavailabilityReasonCodesEnum["NoFares"] = 'noFares'] = "NoFares";
        UnavailabilityReasonCodesEnum[UnavailabilityReasonCodesEnum["SoldOut"] = 'soldOut'] = "SoldOut";
        UnavailabilityReasonCodesEnum[UnavailabilityReasonCodesEnum["DateCrossover"] = 'dateCrossover'] = "DateCrossover";
        UnavailabilityReasonCodesEnum[UnavailabilityReasonCodesEnum["TimeCrossover"] = 'timeCrossover'] = "TimeCrossover";
    })(UnavailabilityReasonCodesEnum = Status.UnavailabilityReasonCodesEnum || (Status.UnavailabilityReasonCodesEnum = {}));
})(Status || (Status = {}));
/**
 * @export
 * @namespace Surcharge
 */
export var Surcharge;
(function (Surcharge) {
    /**
     * @export
     * @enum {string}
     */
    var CategoryEnum;
    (function (CategoryEnum) {
        CategoryEnum[CategoryEnum["OLD"] = 'OLD'] = "OLD";
        CategoryEnum[CategoryEnum["NEW"] = 'NEW'] = "NEW";
        CategoryEnum[CategoryEnum["REFUNDABLE"] = 'REFUNDABLE'] = "REFUNDABLE";
        CategoryEnum[CategoryEnum["NEWPAID"] = 'NEW_PAID'] = "NEWPAID";
        CategoryEnum[CategoryEnum["COMPENSATED"] = 'COMPENSATED'] = "COMPENSATED";
    })(CategoryEnum = Surcharge.CategoryEnum || (Surcharge.CategoryEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var PricingTimeWindowEnum;
    (function (PricingTimeWindowEnum) {
        PricingTimeWindowEnum[PricingTimeWindowEnum["Hourly"] = 'hourly'] = "Hourly";
        PricingTimeWindowEnum[PricingTimeWindowEnum["Daily"] = 'daily'] = "Daily";
        PricingTimeWindowEnum[PricingTimeWindowEnum["Monthly"] = 'monthly'] = "Monthly";
        PricingTimeWindowEnum[PricingTimeWindowEnum["Weekend"] = 'weekend'] = "Weekend";
        PricingTimeWindowEnum[PricingTimeWindowEnum["Weekly"] = 'weekly'] = "Weekly";
        PricingTimeWindowEnum[PricingTimeWindowEnum["FullPeriod"] = 'fullPeriod'] = "FullPeriod";
    })(PricingTimeWindowEnum = Surcharge.PricingTimeWindowEnum || (Surcharge.PricingTimeWindowEnum = {}));
})(Surcharge || (Surcharge = {}));
/**
 * @export
 * @namespace TaskRegulatoryAddressSchemaType
 */
export var TaskRegulatoryAddressSchemaType;
(function (TaskRegulatoryAddressSchemaType) {
    /**
     * @export
     * @enum {string}
     */
    var EnumEnum;
    (function (EnumEnum) {
        EnumEnum[EnumEnum["HomeAddress"] = 'homeAddress'] = "HomeAddress";
        EnumEnum[EnumEnum["DestinationAddress"] = 'destinationAddress'] = "DestinationAddress";
    })(EnumEnum = TaskRegulatoryAddressSchemaType.EnumEnum || (TaskRegulatoryAddressSchemaType.EnumEnum = {}));
})(TaskRegulatoryAddressSchemaType || (TaskRegulatoryAddressSchemaType = {}));
/**
 * @export
 * @namespace TaskRegulatoryDocumentSchemaDocumentType
 */
export var TaskRegulatoryDocumentSchemaDocumentType;
(function (TaskRegulatoryDocumentSchemaDocumentType) {
    /**
     * @export
     * @enum {string}
     */
    var EnumEnum;
    (function (EnumEnum) {
        EnumEnum[EnumEnum["Passport"] = 'passport'] = "Passport";
        EnumEnum[EnumEnum["PassportCard"] = 'passportCard'] = "PassportCard";
        EnumEnum[EnumEnum["IdentityCard"] = 'identityCard'] = "IdentityCard";
        EnumEnum[EnumEnum["CrewMemberCertificate"] = 'crewMemberCertificate'] = "CrewMemberCertificate";
        EnumEnum[EnumEnum["BorderCrossingCard"] = 'borderCrossingCard'] = "BorderCrossingCard";
        EnumEnum[EnumEnum["MilitaryIdentityCard"] = 'militaryIdentityCard'] = "MilitaryIdentityCard";
        EnumEnum[EnumEnum["ReEntryPermit"] = 'reEntryPermit'] = "ReEntryPermit";
        EnumEnum[EnumEnum["NaturalisationCardUS"] = 'naturalisationCardUS'] = "NaturalisationCardUS";
        EnumEnum[EnumEnum["ApprovedIdentityDocument"] = 'approvedIdentityDocument'] = "ApprovedIdentityDocument";
        EnumEnum[EnumEnum["Visa"] = 'visa'] = "Visa";
        EnumEnum[EnumEnum["ResidentAlienCard"] = 'residentAlienCard'] = "ResidentAlienCard";
        EnumEnum[EnumEnum["PermanentResidentCard"] = 'permanentResidentCard'] = "PermanentResidentCard";
        EnumEnum[EnumEnum["RedressNumber"] = 'redressNumber'] = "RedressNumber";
        EnumEnum[EnumEnum["KnownTravellerNumber"] = 'knownTravellerNumber'] = "KnownTravellerNumber";
        EnumEnum[EnumEnum["NexusCard"] = 'nexusCard'] = "NexusCard";
    })(EnumEnum = TaskRegulatoryDocumentSchemaDocumentType.EnumEnum || (TaskRegulatoryDocumentSchemaDocumentType.EnumEnum = {}));
})(TaskRegulatoryDocumentSchemaDocumentType || (TaskRegulatoryDocumentSchemaDocumentType = {}));
/**
 * @export
 * @namespace TaskTargetSchema
 */
export var TaskTargetSchema;
(function (TaskTargetSchema) {
    /**
     * @export
     * @enum {string}
     */
    var SchemaTypeEnum;
    (function (SchemaTypeEnum) {
        SchemaTypeEnum[SchemaTypeEnum["TaskRegulatoryAddressSchema"] = 'TaskRegulatoryAddressSchema'] = "TaskRegulatoryAddressSchema";
        SchemaTypeEnum[SchemaTypeEnum["TaskRegulatoryDocumentSchema"] = 'TaskRegulatoryDocumentSchema'] = "TaskRegulatoryDocumentSchema";
        SchemaTypeEnum[SchemaTypeEnum["TaskSpanishLargeFamilyCardSchema"] = 'TaskSpanishLargeFamilyCardSchema'] = "TaskSpanishLargeFamilyCardSchema";
        SchemaTypeEnum[SchemaTypeEnum["TaskSpanishResidentCardSchema"] = 'TaskSpanishResidentCardSchema'] = "TaskSpanishResidentCardSchema";
    })(SchemaTypeEnum = TaskTargetSchema.SchemaTypeEnum || (TaskTargetSchema.SchemaTypeEnum = {}));
})(TaskTargetSchema || (TaskTargetSchema = {}));
/**
 * @export
 * @namespace Tax
 */
export var Tax;
(function (Tax) {
    /**
     * @export
     * @enum {string}
     */
    var CategoryEnum;
    (function (CategoryEnum) {
        CategoryEnum[CategoryEnum["OLD"] = 'OLD'] = "OLD";
        CategoryEnum[CategoryEnum["NEW"] = 'NEW'] = "NEW";
        CategoryEnum[CategoryEnum["REFUNDABLE"] = 'REFUNDABLE'] = "REFUNDABLE";
        CategoryEnum[CategoryEnum["NEWPAID"] = 'NEW_PAID'] = "NEWPAID";
        CategoryEnum[CategoryEnum["COMPENSATED"] = 'COMPENSATED'] = "COMPENSATED";
        CategoryEnum[CategoryEnum["NONREFUNDABLE"] = 'NON_REFUNDABLE'] = "NONREFUNDABLE";
    })(CategoryEnum = Tax.CategoryEnum || (Tax.CategoryEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var TypeEnum;
    (function (TypeEnum) {
        TypeEnum[TypeEnum["PFC"] = 'PFC'] = "PFC";
    })(TypeEnum = Tax.TypeEnum || (Tax.TypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var ApplicationLevelEnum;
    (function (ApplicationLevelEnum) {
        ApplicationLevelEnum[ApplicationLevelEnum["Itinerary"] = 'itinerary'] = "Itinerary";
    })(ApplicationLevelEnum = Tax.ApplicationLevelEnum || (Tax.ApplicationLevelEnum = {}));
})(Tax || (Tax = {}));
/**
 * @export
 * @namespace TaxIdentificationNumber
 */
export var TaxIdentificationNumber;
(function (TaxIdentificationNumber) {
    /**
     * @export
     * @enum {string}
     */
    var DocumentTypeEnum;
    (function (DocumentTypeEnum) {
        DocumentTypeEnum[DocumentTypeEnum["OecdTaxIdentificationNumber"] = 'oecdTaxIdentificationNumber'] = "OecdTaxIdentificationNumber";
    })(DocumentTypeEnum = TaxIdentificationNumber.DocumentTypeEnum || (TaxIdentificationNumber.DocumentTypeEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var SubDocumentTypeEnum;
    (function (SubDocumentTypeEnum) {
        SubDocumentTypeEnum[SubDocumentTypeEnum["AustralianBusinessNumber"] = 'australianBusinessNumber'] = "AustralianBusinessNumber";
    })(SubDocumentTypeEnum = TaxIdentificationNumber.SubDocumentTypeEnum || (TaxIdentificationNumber.SubDocumentTypeEnum = {}));
})(TaxIdentificationNumber || (TaxIdentificationNumber = {}));
/**
 * @export
 * @namespace TeaserItem
 */
export var TeaserItem;
(function (TeaserItem) {
    /**
     * @export
     * @enum {string}
     */
    var RecommendationTypeEnum;
    (function (RecommendationTypeEnum) {
        RecommendationTypeEnum[RecommendationTypeEnum["Car"] = 'car'] = "Car";
        RecommendationTypeEnum[RecommendationTypeEnum["Hotel"] = 'hotel'] = "Hotel";
        RecommendationTypeEnum[RecommendationTypeEnum["Insurance"] = 'insurance'] = "Insurance";
    })(RecommendationTypeEnum = TeaserItem.RecommendationTypeEnum || (TeaserItem.RecommendationTypeEnum = {}));
})(TeaserItem || (TeaserItem = {}));
/**
 * @export
 * @namespace TeaserRequest
 */
export var TeaserRequest;
(function (TeaserRequest) {
    /**
     * @export
     * @enum {string}
     */
    var SearchModeEnum;
    (function (SearchModeEnum) {
        SearchModeEnum[SearchModeEnum["Cheapest"] = 'cheapest'] = "Cheapest";
        SearchModeEnum[SearchModeEnum["Recommended"] = 'recommended'] = "Recommended";
        SearchModeEnum[SearchModeEnum["All"] = 'all'] = "All";
        SearchModeEnum[SearchModeEnum["Consolidated"] = 'consolidated'] = "Consolidated";
    })(SearchModeEnum = TeaserRequest.SearchModeEnum || (TeaserRequest.SearchModeEnum = {}));
})(TeaserRequest || (TeaserRequest = {}));
/**
 * @export
 * @namespace TicketingArrangement
 */
export var TicketingArrangement;
(function (TicketingArrangement) {
    /**
     * @export
     * @enum {string}
     */
    var ActionEnum;
    (function (ActionEnum) {
        ActionEnum[ActionEnum["None"] = 'none'] = "None";
        ActionEnum[ActionEnum["CancelItinerary"] = 'cancelItinerary'] = "CancelItinerary";
        ActionEnum[ActionEnum["Queue"] = 'queue'] = "Queue";
        ActionEnum[ActionEnum["QueueIfInternationalItinerary"] = 'queueIfInternationalItinerary'] = "QueueIfInternationalItinerary";
        ActionEnum[ActionEnum["QueueIfDomesticItinerary"] = 'queueIfDomesticItinerary'] = "QueueIfDomesticItinerary";
        ActionEnum[ActionEnum["QueueIfRevalidationRequired"] = 'queueIfRevalidationRequired'] = "QueueIfRevalidationRequired";
        ActionEnum[ActionEnum["QueueIfTicketsMailed"] = 'queueIfTicketsMailed'] = "QueueIfTicketsMailed";
        ActionEnum[ActionEnum["QueueIfPrepaidTicket"] = 'queueIfPrepaidTicket'] = "QueueIfPrepaidTicket";
        ActionEnum[ActionEnum["QueueIfAirportTicketing"] = 'queueIfAirportTicketing'] = "QueueIfAirportTicketing";
        ActionEnum[ActionEnum["QueueIfSatelliteTicketing"] = 'queueIfSatelliteTicketing'] = "QueueIfSatelliteTicketing";
        ActionEnum[ActionEnum["SelfServiceTicketing"] = 'selfServiceTicketing'] = "SelfServiceTicketing";
    })(ActionEnum = TicketingArrangement.ActionEnum || (TicketingArrangement.ActionEnum = {}));
})(TicketingArrangement || (TicketingArrangement = {}));
/**
 * @export
 * @namespace TravelDocument
 */
export var TravelDocument;
(function (TravelDocument) {
    /**
     * @export
     * @enum {string}
     */
    var DocumentTypeEnum;
    (function (DocumentTypeEnum) {
        DocumentTypeEnum[DocumentTypeEnum["Eticket"] = 'eticket'] = "Eticket";
        DocumentTypeEnum[DocumentTypeEnum["Services"] = 'services'] = "Services";
        DocumentTypeEnum[DocumentTypeEnum["Insurance"] = 'insurance'] = "Insurance";
        DocumentTypeEnum[DocumentTypeEnum["Hotel"] = 'hotel'] = "Hotel";
    })(DocumentTypeEnum = TravelDocument.DocumentTypeEnum || (TravelDocument.DocumentTypeEnum = {}));
})(TravelDocument || (TravelDocument = {}));
/**
 * @export
 * @namespace Traveler
 */
export var Traveler;
(function (Traveler) {
    /**
     * @export
     * @enum {string}
     */
    var GenderEnum;
    (function (GenderEnum) {
        GenderEnum[GenderEnum["Male"] = 'male'] = "Male";
        GenderEnum[GenderEnum["Female"] = 'female'] = "Female";
        GenderEnum[GenderEnum["Unspecified"] = 'unspecified'] = "Unspecified";
        GenderEnum[GenderEnum["Unknown"] = 'unknown'] = "Unknown";
    })(GenderEnum = Traveler.GenderEnum || (Traveler.GenderEnum = {}));
    /**
     * @export
     * @enum {string}
     */
    var StaffCategoryEnum;
    (function (StaffCategoryEnum) {
        StaffCategoryEnum[StaffCategoryEnum["Bookable"] = 'bookable'] = "Bookable";
        StaffCategoryEnum[StaffCategoryEnum["Standby"] = 'standby'] = "Standby";
    })(StaffCategoryEnum = Traveler.StaffCategoryEnum || (Traveler.StaffCategoryEnum = {}));
})(Traveler || (Traveler = {}));
/**
 * @export
 * @namespace UpdateJourneyElementRequest
 */
export var UpdateJourneyElementRequest;
(function (UpdateJourneyElementRequest) {
    /**
     * @export
     * @enum {string}
     */
    var ExitSeatSuitabilityEnum;
    (function (ExitSeatSuitabilityEnum) {
        ExitSeatSuitabilityEnum[ExitSeatSuitabilityEnum["Suitable"] = 'suitable'] = "Suitable";
        ExitSeatSuitabilityEnum[ExitSeatSuitabilityEnum["NotSuitable"] = 'notSuitable'] = "NotSuitable";
        ExitSeatSuitabilityEnum[ExitSeatSuitabilityEnum["UnableToDetermine"] = 'unableToDetermine'] = "UnableToDetermine";
    })(ExitSeatSuitabilityEnum = UpdateJourneyElementRequest.ExitSeatSuitabilityEnum || (UpdateJourneyElementRequest.ExitSeatSuitabilityEnum = {}));
})(UpdateJourneyElementRequest || (UpdateJourneyElementRequest = {}));
/**
 * @export
 * @namespace Voucher
 */
export var Voucher;
(function (Voucher) {
    /**
     * @export
     * @enum {string}
     */
    var StatusEnum;
    (function (StatusEnum) {
        StatusEnum[StatusEnum["Active"] = 'Active'] = "Active";
        StatusEnum[StatusEnum["Used"] = 'Used'] = "Used";
        StatusEnum[StatusEnum["Cancelled"] = 'Cancelled'] = "Cancelled";
        StatusEnum[StatusEnum["Expired"] = 'Expired'] = "Expired";
    })(StatusEnum = Voucher.StatusEnum || (Voucher.StatusEnum = {}));
})(Voucher || (Voucher = {}));
/**
 * @export
 * @namespace VoucherPayment
 */
export var VoucherPayment;
(function (VoucherPayment) {
    /**
     * @export
     * @enum {string}
     */
    var TypeEnum;
    (function (TypeEnum) {
        TypeEnum[TypeEnum["Voucher"] = 'Voucher'] = "Voucher";
        TypeEnum[TypeEnum["Wallet"] = 'Wallet'] = "Wallet";
    })(TypeEnum = VoucherPayment.TypeEnum || (VoucherPayment.TypeEnum = {}));
})(VoucherPayment || (VoucherPayment = {}));
/**
 * @export
 * @namespace VoucherRetrieveRequest
 */
export var VoucherRetrieveRequest;
(function (VoucherRetrieveRequest) {
    /**
     * @export
     * @enum {string}
     */
    var TypeEnum;
    (function (TypeEnum) {
        TypeEnum[TypeEnum["Voucher"] = 'Voucher'] = "Voucher";
        TypeEnum[TypeEnum["Wallet"] = 'Wallet'] = "Wallet";
    })(TypeEnum = VoucherRetrieveRequest.TypeEnum || (VoucherRetrieveRequest.TypeEnum = {}));
})(VoucherRetrieveRequest || (VoucherRetrieveRequest = {}));
/**
 * @export
 * @namespace WifiAmenity
 */
export var WifiAmenity;
(function (WifiAmenity) {
    /**
     * @export
     * @enum {string}
     */
    var WifiCoverageEnum;
    (function (WifiCoverageEnum) {
        WifiCoverageEnum[WifiCoverageEnum["FULL"] = 'FULL'] = "FULL";
        WifiCoverageEnum[WifiCoverageEnum["GSMDATAROAMINGONLY"] = 'GSM_DATA_ROAMING_ONLY'] = "GSMDATAROAMINGONLY";
        WifiCoverageEnum[WifiCoverageEnum["PARTIAL"] = 'PARTIAL'] = "PARTIAL";
        WifiCoverageEnum[WifiCoverageEnum["NONE"] = 'NONE'] = "NONE";
    })(WifiCoverageEnum = WifiAmenity.WifiCoverageEnum || (WifiAmenity.WifiCoverageEnum = {}));
})(WifiAmenity || (WifiAmenity = {}));
